/**
 * Access readers, door controllers and face/fingerprint terminals migrated
 * from tools/camera-additions.json. Hikvision DS-K1xxx readers, DS-K1Txxx
 * face terminals, DS-K2xxx door controllers + Dahua ASI/ASR/ASC/ASF series.
 *
 * AUTO-GENERATED by tools/generate-migrated-catalogs.py from agent research
 * outputs in tools/equipment-research/. DO NOT edit by hand — re-run the
 * script if specs change. Generated on 2026-05-19.
 */
import type { EquipmentCatalogEntry } from './equipmentCatalogEntry';

export const MIGRATED_ACCESS_CONTROL: EquipmentCatalogEntry[] = [
  {
    id: 'hikvision-ds-k1t673dwx',
    manufacturer: 'Hikvision',
    model: 'DS-K1T673DWX',
    category: 'access-reader',
    tagline: 'DS-K1T673DWX — face-recognition terminal, IP65',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Access-Control-Products/Face-Recognition-Terminals/Pro-Series/ds-k1t673dwx/',
    specs: {
      technology: ['mifare'],
      protocol: ['wiegand-26', 'wiegand-34', 'osdp'],
      outdoor: true,
      keypad: false,
      doorStateInput: true,
      lockOutput: true,
      ipRating: 'IP65',
    },
  },
  {
    id: 'hikvision-ds-k1t673dx',
    manufacturer: 'Hikvision',
    model: 'DS-K1T673DX',
    category: 'access-reader',
    tagline: 'DS-K1T673DX — face-recognition terminal, IP65',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Access-Control-Products/Face-Recognition-Terminals/Pro-Series/ds-k1t673dwx/',
    specs: {
      technology: ['mifare'],
      protocol: ['wiegand-26', 'wiegand-34', 'osdp'],
      outdoor: true,
      keypad: false,
      doorStateInput: true,
      lockOutput: true,
      ipRating: 'IP65',
    },
  },
  {
    id: 'hikvision-ds-k1t673dbwfx',
    manufacturer: 'Hikvision',
    model: 'DS-K1T673DBWFX',
    category: 'access-reader',
    tagline: 'DS-K1T673DBWFX — face-recognition terminal, IP65',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Access-Control-Products/Face-Recognition-Terminals/Pro-Series/ds-k1t673dwx/',
    specs: {
      technology: ['mifare'],
      protocol: ['wiegand-26', 'wiegand-34', 'osdp'],
      outdoor: true,
      keypad: false,
      doorStateInput: true,
      lockOutput: true,
      ipRating: 'IP65',
    },
  },
  {
    id: 'hikvision-ds-k1t673dbwfx-qr',
    manufacturer: 'Hikvision',
    model: 'DS-K1T673DBWFX-QR',
    category: 'access-reader',
    tagline: 'DS-K1T673DBWFX-QR — face-recognition terminal, IP65',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Access-Control-Products/Face-Recognition-Terminals/Pro-Series/ds-k1t673dwx/',
    specs: {
      technology: ['mifare'],
      protocol: ['wiegand-26', 'wiegand-34', 'osdp'],
      outdoor: true,
      keypad: false,
      doorStateInput: true,
      lockOutput: true,
      ipRating: 'IP65',
    },
  },
  {
    id: 'hikvision-ds-k1t673dx-e1',
    manufacturer: 'Hikvision',
    model: 'DS-K1T673DX-E1',
    category: 'access-reader',
    tagline: 'DS-K1T673DX-E1 — face-recognition terminal, IP65',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Access-Control-Products/Face-Recognition-Terminals/Pro-Series/ds-k1t673dwx/',
    specs: {
      technology: ['mifare'],
      protocol: ['wiegand-26', 'wiegand-34', 'osdp'],
      outdoor: true,
      keypad: false,
      doorStateInput: true,
      lockOutput: true,
      ipRating: 'IP65',
    },
  },
  {
    id: 'hikvision-ds-k1t673dwx-proe1',
    manufacturer: 'Hikvision',
    model: 'DS-K1T673DWX-PROE1',
    category: 'access-reader',
    tagline: 'DS-K1T673DWX-PROE1 — face-recognition terminal, IP65',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Access-Control-Products/Face-Recognition-Terminals/Pro-Series/ds-k1t673dwx/',
    specs: {
      technology: ['mifare'],
      protocol: ['wiegand-26', 'wiegand-34', 'osdp'],
      outdoor: true,
      keypad: false,
      doorStateInput: true,
      lockOutput: true,
      ipRating: 'IP65',
    },
  },
  {
    id: 'hikvision-ds-k1t673dg1x-e1',
    manufacturer: 'Hikvision',
    model: 'DS-K1T673DG1X-E1',
    category: 'access-reader',
    tagline: 'DS-K1T673DG1X-E1 — face-recognition terminal, IP65',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Access-Control-Products/Face-Recognition-Terminals/Pro-Series/ds-k1t673dwx/',
    specs: {
      technology: ['mifare'],
      protocol: ['wiegand-26', 'wiegand-34', 'osdp'],
      outdoor: true,
      keypad: false,
      doorStateInput: true,
      lockOutput: true,
      ipRating: 'IP65',
    },
  },
  {
    id: 'hikvision-ds-k1t673dgx-e1',
    manufacturer: 'Hikvision',
    model: 'DS-K1T673DGX-E1',
    category: 'access-reader',
    tagline: 'DS-K1T673DGX-E1 — face-recognition terminal, IP65',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Access-Control-Products/Face-Recognition-Terminals/Pro-Series/ds-k1t673dwx/',
    specs: {
      technology: ['mifare'],
      protocol: ['wiegand-26', 'wiegand-34', 'osdp'],
      outdoor: true,
      keypad: false,
      doorStateInput: true,
      lockOutput: true,
      ipRating: 'IP65',
    },
  },
  {
    id: 'hikvision-ds-k1t673dwx-e1',
    manufacturer: 'Hikvision',
    model: 'DS-K1T673DWX-E1',
    category: 'access-reader',
    tagline: 'DS-K1T673DWX-E1 — face-recognition terminal, IP65',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Access-Control-Products/Face-Recognition-Terminals/Pro-Series/ds-k1t673dwx/',
    specs: {
      technology: ['mifare'],
      protocol: ['wiegand-26', 'wiegand-34', 'osdp'],
      outdoor: true,
      keypad: false,
      doorStateInput: true,
      lockOutput: true,
      ipRating: 'IP65',
    },
  },
  {
    id: 'hikvision-ds-k1t673tdwx',
    manufacturer: 'Hikvision',
    model: 'DS-K1T673TDWX',
    category: 'access-reader',
    tagline: 'DS-K1T673TDWX — face-recognition terminal, IP65',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Access-Control-Products/Face-Recognition-Terminals/Pro-Series/ds-k1t673dwx/',
    specs: {
      technology: ['mifare'],
      protocol: ['wiegand-26', 'wiegand-34', 'osdp'],
      outdoor: true,
      keypad: false,
      doorStateInput: true,
      lockOutput: true,
      ipRating: 'IP65',
    },
  },
  {
    id: 'hikvision-ds-k1t673tdx',
    manufacturer: 'Hikvision',
    model: 'DS-K1T673TDX',
    category: 'access-reader',
    tagline: 'DS-K1T673TDX — face-recognition terminal, IP65',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Access-Control-Products/Face-Recognition-Terminals/Pro-Series/ds-k1t673dwx/',
    specs: {
      technology: ['mifare'],
      protocol: ['wiegand-26', 'wiegand-34', 'osdp'],
      outdoor: true,
      keypad: false,
      doorStateInput: true,
      lockOutput: true,
      ipRating: 'IP65',
    },
  },
  {
    id: 'hikvision-ds-k1t673tdx-t',
    manufacturer: 'Hikvision',
    model: 'DS-K1T673TDX-T',
    category: 'access-reader',
    tagline: 'DS-K1T673TDX-T — face-recognition terminal, IP65',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Access-Control-Products/Face-Recognition-Terminals/Pro-Series/ds-k1t673dwx/',
    specs: {
      technology: ['mifare'],
      protocol: ['wiegand-26', 'wiegand-34', 'osdp'],
      outdoor: true,
      keypad: false,
      doorStateInput: true,
      lockOutput: true,
      ipRating: 'IP65',
    },
  },
  {
    id: 'hikvision-ds-k1t673tdgx',
    manufacturer: 'Hikvision',
    model: 'DS-K1T673TDGX',
    category: 'access-reader',
    tagline: 'DS-K1T673TDGX — face-recognition terminal, IP65',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Access-Control-Products/Face-Recognition-Terminals/Pro-Series/ds-k1t673dwx/',
    specs: {
      technology: ['mifare'],
      protocol: ['wiegand-26', 'wiegand-34', 'osdp'],
      outdoor: true,
      keypad: false,
      doorStateInput: true,
      lockOutput: true,
      ipRating: 'IP65',
    },
  },
  {
    id: 'hikvision-ds-k1t673tdwx-proe1',
    manufacturer: 'Hikvision',
    model: 'DS-K1T673TDWX-PROE1',
    category: 'access-reader',
    tagline: 'DS-K1T673TDWX-PROE1 — face-recognition terminal, IP65',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Access-Control-Products/Face-Recognition-Terminals/Pro-Series/ds-k1t673dwx/',
    specs: {
      technology: ['mifare'],
      protocol: ['wiegand-26', 'wiegand-34', 'osdp'],
      outdoor: true,
      keypad: false,
      doorStateInput: true,
      lockOutput: true,
      ipRating: 'IP65',
    },
  },
  {
    id: 'hikvision-ds-k1t673tdwx-e1',
    manufacturer: 'Hikvision',
    model: 'DS-K1T673TDWX-E1',
    category: 'access-reader',
    tagline: 'DS-K1T673TDWX-E1 — face-recognition terminal, IP65',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Access-Control-Products/Face-Recognition-Terminals/Pro-Series/ds-k1t673dwx/',
    specs: {
      technology: ['mifare'],
      protocol: ['wiegand-26', 'wiegand-34', 'osdp'],
      outdoor: true,
      keypad: false,
      doorStateInput: true,
      lockOutput: true,
      ipRating: 'IP65',
    },
  },
  {
    id: 'hikvision-ds-k1t673tdx-e1',
    manufacturer: 'Hikvision',
    model: 'DS-K1T673TDX-E1',
    category: 'access-reader',
    tagline: 'DS-K1T673TDX-E1 — face-recognition terminal, IP65',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Access-Control-Products/Face-Recognition-Terminals/Pro-Series/ds-k1t673dwx/',
    specs: {
      technology: ['mifare'],
      protocol: ['wiegand-26', 'wiegand-34', 'osdp'],
      outdoor: true,
      keypad: false,
      doorStateInput: true,
      lockOutput: true,
      ipRating: 'IP65',
    },
  },
  {
    id: 'hikvision-ds-k1t673',
    manufacturer: 'Hikvision',
    model: 'DS-K1T673',
    category: 'access-reader',
    tagline: 'DS-K1T673 — face-recognition terminal, IP65',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Access-Control-Products/Face-Recognition-Terminals/Pro-Series/ds-k1t673dwx/',
    specs: {
      technology: ['mifare'],
      protocol: ['wiegand-26', 'wiegand-34', 'osdp'],
      outdoor: true,
      keypad: false,
      doorStateInput: true,
      lockOutput: true,
      ipRating: 'IP65',
    },
  },
  {
    id: 'hikvision-ds-k1t673m-3xf',
    manufacturer: 'Hikvision',
    model: 'DS-K1T673M-3XF',
    category: 'access-reader',
    tagline: 'DS-K1T673M-3XF — face-recognition terminal, IP65',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Access-Control-Products/Face-Recognition-Terminals/Pro-Series/ds-k1t673dwx/',
    specs: {
      technology: ['mifare'],
      protocol: ['wiegand-26', 'wiegand-34', 'osdp'],
      outdoor: true,
      keypad: false,
      doorStateInput: true,
      lockOutput: true,
      ipRating: 'IP65',
    },
  },
  {
    id: 'hikvision-ds-k1t673dwx-eu',
    manufacturer: 'Hikvision',
    model: 'DS-K1T673DWX-EU',
    category: 'access-reader',
    tagline: 'DS-K1T673DWX-EU — face-recognition terminal, IP65',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Access-Control-Products/Face-Recognition-Terminals/Pro-Series/ds-k1t673dwx/',
    specs: {
      technology: ['mifare'],
      protocol: ['wiegand-26', 'wiegand-34', 'osdp'],
      outdoor: true,
      keypad: false,
      doorStateInput: true,
      lockOutput: true,
      ipRating: 'IP65',
    },
  },
  {
    id: 'hikvision-ds-k1t673tdx-br',
    manufacturer: 'Hikvision',
    model: 'DS-K1T673TDX-BR',
    category: 'access-reader',
    tagline: 'DS-K1T673TDX-BR — face-recognition terminal, IP65',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Access-Control-Products/Face-Recognition-Terminals/Pro-Series/ds-k1t673dwx/',
    specs: {
      technology: ['mifare'],
      protocol: ['wiegand-26', 'wiegand-34', 'osdp'],
      outdoor: true,
      keypad: false,
      doorStateInput: true,
      lockOutput: true,
      ipRating: 'IP65',
    },
  },
  {
    id: 'hikvision-ds-k1t673dwx-bqr',
    manufacturer: 'Hikvision',
    model: 'DS-K1T673DWX-BQR',
    category: 'access-reader',
    tagline: 'DS-K1T673DWX-BQR — face-recognition terminal, IP65',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Access-Control-Products/Face-Recognition-Terminals/Pro-Series/ds-k1t673dwx/',
    specs: {
      technology: ['mifare'],
      protocol: ['wiegand-26', 'wiegand-34', 'osdp'],
      outdoor: true,
      keypad: false,
      doorStateInput: true,
      lockOutput: true,
      ipRating: 'IP65',
    },
  },
  {
    id: 'hikvision-ds-k1t673dx-g1',
    manufacturer: 'Hikvision',
    model: 'DS-K1T673DX-G1',
    category: 'access-reader',
    tagline: 'DS-K1T673DX-G1 — face-recognition terminal, IP65',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Access-Control-Products/Face-Recognition-Terminals/Pro-Series/ds-k1t673dwx/',
    specs: {
      technology: ['mifare'],
      protocol: ['wiegand-26', 'wiegand-34', 'osdp'],
      outdoor: true,
      keypad: false,
      doorStateInput: true,
      lockOutput: true,
      ipRating: 'IP65',
    },
  },
  {
    id: 'hikvision-ds-k1t673tdx-t-msm-moved',
    manufacturer: 'Hikvision',
    model: 'DS-K1T673TDX-T_MSM_MOVED',
    category: 'access-reader',
    tagline: 'DS-K1T673TDX-T_MSM_MOVED — face-recognition terminal, IP65',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Access-Control-Products/Face-Recognition-Terminals/Pro-Series/ds-k1t673dwx/',
    specs: {
      technology: ['mifare'],
      protocol: ['wiegand-26', 'wiegand-34', 'osdp'],
      outdoor: true,
      keypad: false,
      doorStateInput: true,
      lockOutput: true,
      ipRating: 'IP65',
    },
  },
  {
    id: 'hikvision-ds-k1t342mfx',
    manufacturer: 'Hikvision',
    model: 'DS-K1T342MFX',
    category: 'access-reader',
    tagline: 'DS-K1T342MFX — face-recognition terminal',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Access-Control-Products/Face-Recognition-Terminals/Value-Series/ds-k1t342mfx/',
    specs: {
      technology: ['mifare', 'em-marin-125khz'],
      protocol: ['wiegand-26', 'wiegand-34'],
      outdoor: false,
      keypad: false,
      doorStateInput: true,
      lockOutput: true,
    },
  },
  {
    id: 'hikvision-ds-k1t342mfwx',
    manufacturer: 'Hikvision',
    model: 'DS-K1T342MFWX',
    category: 'access-reader',
    tagline: 'DS-K1T342MFWX — face-recognition terminal',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Access-Control-Products/Face-Recognition-Terminals/Value-Series/ds-k1t342mfx/',
    specs: {
      technology: ['mifare', 'em-marin-125khz'],
      protocol: ['wiegand-26', 'wiegand-34'],
      outdoor: false,
      keypad: false,
      doorStateInput: true,
      lockOutput: true,
    },
  },
  {
    id: 'hikvision-ds-k1t342mwx',
    manufacturer: 'Hikvision',
    model: 'DS-K1T342MWX',
    category: 'access-reader',
    tagline: 'DS-K1T342MWX — face-recognition terminal',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Access-Control-Products/Face-Recognition-Terminals/Value-Series/ds-k1t342mfx/',
    specs: {
      technology: ['mifare', 'em-marin-125khz'],
      protocol: ['wiegand-26', 'wiegand-34'],
      outdoor: false,
      keypad: false,
      doorStateInput: true,
      lockOutput: true,
    },
  },
  {
    id: 'hikvision-ds-k1t342dx',
    manufacturer: 'Hikvision',
    model: 'DS-K1T342DX',
    category: 'access-reader',
    tagline: 'DS-K1T342DX — face-recognition terminal',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Access-Control-Products/Face-Recognition-Terminals/Value-Series/ds-k1t342mfx/',
    specs: {
      technology: ['mifare', 'em-marin-125khz'],
      protocol: ['wiegand-26', 'wiegand-34'],
      outdoor: false,
      keypad: false,
      doorStateInput: true,
      lockOutput: true,
    },
  },
  {
    id: 'hikvision-ds-k1t342ewx',
    manufacturer: 'Hikvision',
    model: 'DS-K1T342EWX',
    category: 'access-reader',
    tagline: 'DS-K1T342EWX — face-recognition terminal',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Access-Control-Products/Face-Recognition-Terminals/Value-Series/ds-k1t342mfx/',
    specs: {
      technology: ['mifare', 'em-marin-125khz'],
      protocol: ['wiegand-26', 'wiegand-34'],
      outdoor: false,
      keypad: false,
      doorStateInput: true,
      lockOutput: true,
    },
  },
  {
    id: 'hikvision-ds-k1t342dwx',
    manufacturer: 'Hikvision',
    model: 'DS-K1T342DWX',
    category: 'access-reader',
    tagline: 'DS-K1T342DWX — face-recognition terminal',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Access-Control-Products/Face-Recognition-Terminals/Value-Series/ds-k1t342mfx/',
    specs: {
      technology: ['mifare', 'em-marin-125khz'],
      protocol: ['wiegand-26', 'wiegand-34'],
      outdoor: false,
      keypad: false,
      doorStateInput: true,
      lockOutput: true,
    },
  },
  {
    id: 'hikvision-ds-k1t342efwx',
    manufacturer: 'Hikvision',
    model: 'DS-K1T342EFWX',
    category: 'access-reader',
    tagline: 'DS-K1T342EFWX — face-recognition terminal',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Access-Control-Products/Face-Recognition-Terminals/Value-Series/ds-k1t342mfx/',
    specs: {
      technology: ['mifare', 'em-marin-125khz'],
      protocol: ['wiegand-26', 'wiegand-34'],
      outdoor: false,
      keypad: false,
      doorStateInput: true,
      lockOutput: true,
    },
  },
  {
    id: 'hikvision-ds-k1t342ex',
    manufacturer: 'Hikvision',
    model: 'DS-K1T342EX',
    category: 'access-reader',
    tagline: 'DS-K1T342EX — face-recognition terminal',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Access-Control-Products/Face-Recognition-Terminals/Value-Series/ds-k1t342mfx/',
    specs: {
      technology: ['mifare', 'em-marin-125khz'],
      protocol: ['wiegand-26', 'wiegand-34'],
      outdoor: false,
      keypad: false,
      doorStateInput: true,
      lockOutput: true,
    },
  },
  {
    id: 'hikvision-ds-k1t342mx',
    manufacturer: 'Hikvision',
    model: 'DS-K1T342MX',
    category: 'access-reader',
    tagline: 'DS-K1T342MX — face-recognition terminal',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Access-Control-Products/Face-Recognition-Terminals/Value-Series/ds-k1t342mfx/',
    specs: {
      technology: ['mifare', 'em-marin-125khz'],
      protocol: ['wiegand-26', 'wiegand-34'],
      outdoor: false,
      keypad: false,
      doorStateInput: true,
      lockOutput: true,
    },
  },
  {
    id: 'hikvision-ds-k1t342dwx-e1',
    manufacturer: 'Hikvision',
    model: 'DS-K1T342DWX-E1',
    category: 'access-reader',
    tagline: 'DS-K1T342DWX-E1 — face-recognition terminal',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Access-Control-Products/Face-Recognition-Terminals/Value-Series/ds-k1t342mfx/',
    specs: {
      technology: ['mifare', 'em-marin-125khz'],
      protocol: ['wiegand-26', 'wiegand-34'],
      outdoor: false,
      keypad: false,
      doorStateInput: true,
      lockOutput: true,
    },
  },
  {
    id: 'hikvision-ds-k1t342dx-e1',
    manufacturer: 'Hikvision',
    model: 'DS-K1T342DX-E1',
    category: 'access-reader',
    tagline: 'DS-K1T342DX-E1 — face-recognition terminal',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Access-Control-Products/Face-Recognition-Terminals/Value-Series/ds-k1t342mfx/',
    specs: {
      technology: ['mifare', 'em-marin-125khz'],
      protocol: ['wiegand-26', 'wiegand-34'],
      outdoor: false,
      keypad: false,
      doorStateInput: true,
      lockOutput: true,
    },
  },
  {
    id: 'hikvision-ds-k1t342ewx-e1',
    manufacturer: 'Hikvision',
    model: 'DS-K1T342EWX-E1',
    category: 'access-reader',
    tagline: 'DS-K1T342EWX-E1 — face-recognition terminal',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Access-Control-Products/Face-Recognition-Terminals/Value-Series/ds-k1t342mfx/',
    specs: {
      technology: ['mifare', 'em-marin-125khz'],
      protocol: ['wiegand-26', 'wiegand-34'],
      outdoor: false,
      keypad: false,
      doorStateInput: true,
      lockOutput: true,
    },
  },
  {
    id: 'hikvision-ds-k1t342ex-e1',
    manufacturer: 'Hikvision',
    model: 'DS-K1T342EX-E1',
    category: 'access-reader',
    tagline: 'DS-K1T342EX-E1 — face-recognition terminal',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Access-Control-Products/Face-Recognition-Terminals/Value-Series/ds-k1t342mfx/',
    specs: {
      technology: ['mifare', 'em-marin-125khz'],
      protocol: ['wiegand-26', 'wiegand-34'],
      outdoor: false,
      keypad: false,
      doorStateInput: true,
      lockOutput: true,
    },
  },
  {
    id: 'hikvision-ds-k1t342efwx-e1',
    manufacturer: 'Hikvision',
    model: 'DS-K1T342EFWX-E1',
    category: 'access-reader',
    tagline: 'DS-K1T342EFWX-E1 — face-recognition terminal',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Access-Control-Products/Face-Recognition-Terminals/Value-Series/ds-k1t342mfx/',
    specs: {
      technology: ['mifare', 'em-marin-125khz'],
      protocol: ['wiegand-26', 'wiegand-34'],
      outdoor: false,
      keypad: false,
      doorStateInput: true,
      lockOutput: true,
    },
  },
  {
    id: 'hikvision-ds-k1t342mwx-e1',
    manufacturer: 'Hikvision',
    model: 'DS-K1T342MWX-E1',
    category: 'access-reader',
    tagline: 'DS-K1T342MWX-E1 — face-recognition terminal',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Access-Control-Products/Face-Recognition-Terminals/Value-Series/ds-k1t342mfx/',
    specs: {
      technology: ['mifare', 'em-marin-125khz'],
      protocol: ['wiegand-26', 'wiegand-34'],
      outdoor: false,
      keypad: false,
      doorStateInput: true,
      lockOutput: true,
    },
  },
  {
    id: 'hikvision-ds-k1t342mx-e1',
    manufacturer: 'Hikvision',
    model: 'DS-K1T342MX-E1',
    category: 'access-reader',
    tagline: 'DS-K1T342MX-E1 — face-recognition terminal',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Access-Control-Products/Face-Recognition-Terminals/Value-Series/ds-k1t342mfx/',
    specs: {
      technology: ['mifare', 'em-marin-125khz'],
      protocol: ['wiegand-26', 'wiegand-34'],
      outdoor: false,
      keypad: false,
      doorStateInput: true,
      lockOutput: true,
    },
  },
  {
    id: 'hikvision-ds-k1t342mfwx-e1',
    manufacturer: 'Hikvision',
    model: 'DS-K1T342MFWX-E1',
    category: 'access-reader',
    tagline: 'DS-K1T342MFWX-E1 — face-recognition terminal',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Access-Control-Products/Face-Recognition-Terminals/Value-Series/ds-k1t342mfx/',
    specs: {
      technology: ['mifare', 'em-marin-125khz'],
      protocol: ['wiegand-26', 'wiegand-34'],
      outdoor: false,
      keypad: false,
      doorStateInput: true,
      lockOutput: true,
    },
  },
  {
    id: 'hikvision-ds-k1t342mfx-e1',
    manufacturer: 'Hikvision',
    model: 'DS-K1T342MFX-E1',
    category: 'access-reader',
    tagline: 'DS-K1T342MFX-E1 — face-recognition terminal',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Access-Control-Products/Face-Recognition-Terminals/Value-Series/ds-k1t342mfx/',
    specs: {
      technology: ['mifare', 'em-marin-125khz'],
      protocol: ['wiegand-26', 'wiegand-34'],
      outdoor: false,
      keypad: false,
      doorStateInput: true,
      lockOutput: true,
    },
  },
  {
    id: 'hikvision-ds-k1t342m',
    manufacturer: 'Hikvision',
    model: 'DS-K1T342M',
    category: 'access-reader',
    tagline: 'DS-K1T342M — face-recognition terminal',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Access-Control-Products/Face-Recognition-Terminals/Value-Series/ds-k1t342mfx/',
    specs: {
      technology: ['mifare', 'em-marin-125khz'],
      protocol: ['wiegand-26', 'wiegand-34'],
      outdoor: false,
      keypad: false,
      doorStateInput: true,
      lockOutput: true,
    },
  },
  {
    id: 'hikvision-ds-k1t342dwx-e1-msm-moved',
    manufacturer: 'Hikvision',
    model: 'DS-K1T342DWX-E1_MSM_MOVED',
    category: 'access-reader',
    tagline: 'DS-K1T342DWX-E1_MSM_MOVED — face-recognition terminal',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Access-Control-Products/Face-Recognition-Terminals/Value-Series/ds-k1t342mfx/',
    specs: {
      technology: ['mifare', 'em-marin-125khz'],
      protocol: ['wiegand-26', 'wiegand-34'],
      outdoor: false,
      keypad: false,
      doorStateInput: true,
      lockOutput: true,
    },
  },
  {
    id: 'hikvision-ds-k1t342efwx-e1-msm-moved',
    manufacturer: 'Hikvision',
    model: 'DS-K1T342EFWX-E1_MSM_MOVED',
    category: 'access-reader',
    tagline: 'DS-K1T342EFWX-E1_MSM_MOVED — face-recognition terminal',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Access-Control-Products/Face-Recognition-Terminals/Value-Series/ds-k1t342mfx/',
    specs: {
      technology: ['mifare', 'em-marin-125khz'],
      protocol: ['wiegand-26', 'wiegand-34'],
      outdoor: false,
      keypad: false,
      doorStateInput: true,
      lockOutput: true,
    },
  },
  {
    id: 'hikvision-ds-k1t342mfwx-e1-msm-moved',
    manufacturer: 'Hikvision',
    model: 'DS-K1T342MFWX-E1_MSM_MOVED',
    category: 'access-reader',
    tagline: 'DS-K1T342MFWX-E1_MSM_MOVED — face-recognition terminal',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Access-Control-Products/Face-Recognition-Terminals/Value-Series/ds-k1t342mfx/',
    specs: {
      technology: ['mifare', 'em-marin-125khz'],
      protocol: ['wiegand-26', 'wiegand-34'],
      outdoor: false,
      keypad: false,
      doorStateInput: true,
      lockOutput: true,
    },
  },
  {
    id: 'hikvision-ds-k1t343ewx',
    manufacturer: 'Hikvision',
    model: 'DS-K1T343EWX',
    category: 'access-reader',
    tagline: 'DS-K1T343EWX — face-recognition terminal',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Access-Control-Products/Face-Recognition-Terminals/Value-Series/ds-k1t343ewx/',
    specs: {
      technology: ['mifare', 'em-marin-125khz'],
      protocol: ['wiegand-26', 'wiegand-34'],
      outdoor: false,
      keypad: false,
      doorStateInput: true,
      lockOutput: true,
    },
  },
  {
    id: 'hikvision-ds-k1t343mwx',
    manufacturer: 'Hikvision',
    model: 'DS-K1T343MWX',
    category: 'access-reader',
    tagline: 'DS-K1T343MWX — face-recognition terminal',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Access-Control-Products/Face-Recognition-Terminals/Value-Series/ds-k1t343ewx/',
    specs: {
      technology: ['mifare', 'em-marin-125khz'],
      protocol: ['wiegand-26', 'wiegand-34'],
      outdoor: false,
      keypad: false,
      doorStateInput: true,
      lockOutput: true,
    },
  },
  {
    id: 'hikvision-ds-k1t343mfwx',
    manufacturer: 'Hikvision',
    model: 'DS-K1T343MFWX',
    category: 'access-reader',
    tagline: 'DS-K1T343MFWX — face-recognition terminal',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Access-Control-Products/Face-Recognition-Terminals/Value-Series/ds-k1t343ewx/',
    specs: {
      technology: ['mifare', 'em-marin-125khz'],
      protocol: ['wiegand-26', 'wiegand-34'],
      outdoor: false,
      keypad: false,
      doorStateInput: true,
      lockOutput: true,
    },
  },
  {
    id: 'hikvision-ds-k1t343efwx',
    manufacturer: 'Hikvision',
    model: 'DS-K1T343EFWX',
    category: 'access-reader',
    tagline: 'DS-K1T343EFWX — face-recognition terminal',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Access-Control-Products/Face-Recognition-Terminals/Value-Series/ds-k1t343ewx/',
    specs: {
      technology: ['mifare', 'em-marin-125khz'],
      protocol: ['wiegand-26', 'wiegand-34'],
      outdoor: false,
      keypad: false,
      doorStateInput: true,
      lockOutput: true,
    },
  },
  {
    id: 'hikvision-ds-k1t343mfwx-b',
    manufacturer: 'Hikvision',
    model: 'DS-K1T343MFWX-B',
    category: 'access-reader',
    tagline: 'DS-K1T343MFWX-B — face-recognition terminal',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Access-Control-Products/Face-Recognition-Terminals/Value-Series/ds-k1t343ewx/',
    specs: {
      technology: ['mifare', 'em-marin-125khz'],
      protocol: ['wiegand-26', 'wiegand-34'],
      outdoor: false,
      keypad: false,
      doorStateInput: true,
      lockOutput: true,
    },
  },
  {
    id: 'hikvision-ds-k1t343efwx-b',
    manufacturer: 'Hikvision',
    model: 'DS-K1T343EFWX-B',
    category: 'access-reader',
    tagline: 'DS-K1T343EFWX-B — face-recognition terminal',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Access-Control-Products/Face-Recognition-Terminals/Value-Series/ds-k1t343ewx/',
    specs: {
      technology: ['mifare', 'em-marin-125khz'],
      protocol: ['wiegand-26', 'wiegand-34'],
      outdoor: false,
      keypad: false,
      doorStateInput: true,
      lockOutput: true,
    },
  },
  {
    id: 'hikvision-ds-k1t343mx',
    manufacturer: 'Hikvision',
    model: 'DS-K1T343MX',
    category: 'access-reader',
    tagline: 'DS-K1T343MX — face-recognition terminal',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Access-Control-Products/Face-Recognition-Terminals/Value-Series/ds-k1t343ewx/',
    specs: {
      technology: ['mifare', 'em-marin-125khz'],
      protocol: ['wiegand-26', 'wiegand-34'],
      outdoor: false,
      keypad: false,
      doorStateInput: true,
      lockOutput: true,
    },
  },
  {
    id: 'hikvision-ds-k1t343ex',
    manufacturer: 'Hikvision',
    model: 'DS-K1T343EX',
    category: 'access-reader',
    tagline: 'DS-K1T343EX — face-recognition terminal',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Access-Control-Products/Face-Recognition-Terminals/Value-Series/ds-k1t343ewx/',
    specs: {
      technology: ['mifare', 'em-marin-125khz'],
      protocol: ['wiegand-26', 'wiegand-34'],
      outdoor: false,
      keypad: false,
      doorStateInput: true,
      lockOutput: true,
    },
  },
  {
    id: 'hikvision-ds-k1t343efx',
    manufacturer: 'Hikvision',
    model: 'DS-K1T343EFX',
    category: 'access-reader',
    tagline: 'DS-K1T343EFX — face-recognition terminal',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Access-Control-Products/Face-Recognition-Terminals/Value-Series/ds-k1t343ewx/',
    specs: {
      technology: ['mifare', 'em-marin-125khz'],
      protocol: ['wiegand-26', 'wiegand-34'],
      outdoor: false,
      keypad: false,
      doorStateInput: true,
      lockOutput: true,
    },
  },
  {
    id: 'hikvision-ds-k1t343mfx',
    manufacturer: 'Hikvision',
    model: 'DS-K1T343MFX',
    category: 'access-reader',
    tagline: 'DS-K1T343MFX — face-recognition terminal',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Access-Control-Products/Face-Recognition-Terminals/Value-Series/ds-k1t343ewx/',
    specs: {
      technology: ['mifare', 'em-marin-125khz'],
      protocol: ['wiegand-26', 'wiegand-34'],
      outdoor: false,
      keypad: false,
      doorStateInput: true,
      lockOutput: true,
    },
  },
  {
    id: 'hikvision-ds-k1t343m',
    manufacturer: 'Hikvision',
    model: 'DS-K1T343M',
    category: 'access-reader',
    tagline: 'DS-K1T343M — face-recognition terminal',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Access-Control-Products/Face-Recognition-Terminals/Value-Series/ds-k1t343ewx/',
    specs: {
      technology: ['mifare', 'em-marin-125khz'],
      protocol: ['wiegand-26', 'wiegand-34'],
      outdoor: false,
      keypad: false,
      doorStateInput: true,
      lockOutput: true,
    },
  },
  {
    id: 'hikvision-ds-k1t344ebwx-e1',
    manufacturer: 'Hikvision',
    model: 'DS-K1T344EBWX-E1',
    category: 'access-reader',
    tagline: 'DS-K1T344EBWX-E1 — face-recognition terminal, IP65',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Access-Control-Products/Face-Recognition-Terminals/Value-Series/ds-k1t344ebwx-e1/',
    specs: {
      technology: ['mifare', 'em-marin-125khz'],
      protocol: ['wiegand-26', 'wiegand-34'],
      outdoor: true,
      keypad: false,
      doorStateInput: true,
      lockOutput: true,
      ipRating: 'IP65',
    },
  },
  {
    id: 'hikvision-ds-k1t344ebwx-qre1',
    manufacturer: 'Hikvision',
    model: 'DS-K1T344EBWX-QRE1',
    category: 'access-reader',
    tagline: 'DS-K1T344EBWX-QRE1 — face-recognition terminal, IP65',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Access-Control-Products/Face-Recognition-Terminals/Value-Series/ds-k1t344ebwx-e1/',
    specs: {
      technology: ['mifare', 'em-marin-125khz'],
      protocol: ['wiegand-26', 'wiegand-34'],
      outdoor: true,
      keypad: false,
      doorStateInput: true,
      lockOutput: true,
      ipRating: 'IP65',
    },
  },
  {
    id: 'hikvision-ds-k1t344mfx-e1',
    manufacturer: 'Hikvision',
    model: 'DS-K1T344MFX-E1',
    category: 'access-reader',
    tagline: 'DS-K1T344MFX-E1 — face-recognition terminal, IP65',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Access-Control-Products/Face-Recognition-Terminals/Value-Series/ds-k1t344ebwx-e1/',
    specs: {
      technology: ['mifare', 'em-marin-125khz'],
      protocol: ['wiegand-26', 'wiegand-34'],
      outdoor: true,
      keypad: false,
      doorStateInput: true,
      lockOutput: true,
      ipRating: 'IP65',
    },
  },
  {
    id: 'hikvision-ds-k1t344ex-e1',
    manufacturer: 'Hikvision',
    model: 'DS-K1T344EX-E1',
    category: 'access-reader',
    tagline: 'DS-K1T344EX-E1 — face-recognition terminal, IP65',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Access-Control-Products/Face-Recognition-Terminals/Value-Series/ds-k1t344ebwx-e1/',
    specs: {
      technology: ['mifare', 'em-marin-125khz'],
      protocol: ['wiegand-26', 'wiegand-34'],
      outdoor: true,
      keypad: false,
      doorStateInput: true,
      lockOutput: true,
      ipRating: 'IP65',
    },
  },
  {
    id: 'hikvision-ds-k1t344mbwx-qre1',
    manufacturer: 'Hikvision',
    model: 'DS-K1T344MBWX-QRE1',
    category: 'access-reader',
    tagline: 'DS-K1T344MBWX-QRE1 — face-recognition terminal, IP65',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Access-Control-Products/Face-Recognition-Terminals/Value-Series/ds-k1t344ebwx-e1/',
    specs: {
      technology: ['mifare', 'em-marin-125khz'],
      protocol: ['wiegand-26', 'wiegand-34'],
      outdoor: true,
      keypad: false,
      doorStateInput: true,
      lockOutput: true,
      ipRating: 'IP65',
    },
  },
  {
    id: 'hikvision-ds-k1t344mbfwx-e1',
    manufacturer: 'Hikvision',
    model: 'DS-K1T344MBFWX-E1',
    category: 'access-reader',
    tagline: 'DS-K1T344MBFWX-E1 — face-recognition terminal, IP65',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Access-Control-Products/Face-Recognition-Terminals/Value-Series/ds-k1t344ebwx-e1/',
    specs: {
      technology: ['mifare', 'em-marin-125khz'],
      protocol: ['wiegand-26', 'wiegand-34'],
      outdoor: true,
      keypad: false,
      doorStateInput: true,
      lockOutput: true,
      ipRating: 'IP65',
    },
  },
  {
    id: 'hikvision-ds-k1t344mx-e1',
    manufacturer: 'Hikvision',
    model: 'DS-K1T344MX-E1',
    category: 'access-reader',
    tagline: 'DS-K1T344MX-E1 — face-recognition terminal, IP65',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Access-Control-Products/Face-Recognition-Terminals/Value-Series/ds-k1t344ebwx-e1/',
    specs: {
      technology: ['mifare', 'em-marin-125khz'],
      protocol: ['wiegand-26', 'wiegand-34'],
      outdoor: true,
      keypad: false,
      doorStateInput: true,
      lockOutput: true,
      ipRating: 'IP65',
    },
  },
  {
    id: 'hikvision-ds-k1t344mbwx-e1',
    manufacturer: 'Hikvision',
    model: 'DS-K1T344MBWX-E1',
    category: 'access-reader',
    tagline: 'DS-K1T344MBWX-E1 — face-recognition terminal, IP65',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Access-Control-Products/Face-Recognition-Terminals/Value-Series/ds-k1t344ebwx-e1/',
    specs: {
      technology: ['mifare', 'em-marin-125khz'],
      protocol: ['wiegand-26', 'wiegand-34'],
      outdoor: true,
      keypad: false,
      doorStateInput: true,
      lockOutput: true,
      ipRating: 'IP65',
    },
  },
  {
    id: 'hikvision-ds-k1t344ebfwx-e1',
    manufacturer: 'Hikvision',
    model: 'DS-K1T344EBFWX-E1',
    category: 'access-reader',
    tagline: 'DS-K1T344EBFWX-E1 — face-recognition terminal, IP65',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Access-Control-Products/Face-Recognition-Terminals/Value-Series/ds-k1t344ebwx-e1/',
    specs: {
      technology: ['mifare', 'em-marin-125khz'],
      protocol: ['wiegand-26', 'wiegand-34'],
      outdoor: true,
      keypad: false,
      doorStateInput: true,
      lockOutput: true,
      ipRating: 'IP65',
    },
  },
  {
    id: 'hikvision-ds-k1t344ebwx-e1-eu',
    manufacturer: 'Hikvision',
    model: 'DS-K1T344EBWX-E1-EU',
    category: 'access-reader',
    tagline: 'DS-K1T344EBWX-E1-EU — face-recognition terminal, IP65',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Access-Control-Products/Face-Recognition-Terminals/Value-Series/ds-k1t344ebwx-e1/',
    specs: {
      technology: ['mifare', 'em-marin-125khz'],
      protocol: ['wiegand-26', 'wiegand-34'],
      outdoor: true,
      keypad: false,
      doorStateInput: true,
      lockOutput: true,
      ipRating: 'IP65',
    },
  },
  {
    id: 'hikvision-ds-k1t344mbfwx-e1-eu',
    manufacturer: 'Hikvision',
    model: 'DS-K1T344MBFWX-E1-EU',
    category: 'access-reader',
    tagline: 'DS-K1T344MBFWX-E1-EU — face-recognition terminal, IP65',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Access-Control-Products/Face-Recognition-Terminals/Value-Series/ds-k1t344ebwx-e1/',
    specs: {
      technology: ['mifare', 'em-marin-125khz'],
      protocol: ['wiegand-26', 'wiegand-34'],
      outdoor: true,
      keypad: false,
      doorStateInput: true,
      lockOutput: true,
      ipRating: 'IP65',
    },
  },
  {
    id: 'hikvision-ds-k1t344mbwx-qre1-eu',
    manufacturer: 'Hikvision',
    model: 'DS-K1T344MBWX-QRE1-EU',
    category: 'access-reader',
    tagline: 'DS-K1T344MBWX-QRE1-EU — face-recognition terminal, IP65',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Access-Control-Products/Face-Recognition-Terminals/Value-Series/ds-k1t344ebwx-e1/',
    specs: {
      technology: ['mifare', 'em-marin-125khz'],
      protocol: ['wiegand-26', 'wiegand-34'],
      outdoor: true,
      keypad: false,
      doorStateInput: true,
      lockOutput: true,
      ipRating: 'IP65',
    },
  },
  {
    id: 'hikvision-ds-k1t344mbwx-e1-eu',
    manufacturer: 'Hikvision',
    model: 'DS-K1T344MBWX-E1-EU',
    category: 'access-reader',
    tagline: 'DS-K1T344MBWX-E1-EU — face-recognition terminal, IP65',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Access-Control-Products/Face-Recognition-Terminals/Value-Series/ds-k1t344ebwx-e1/',
    specs: {
      technology: ['mifare', 'em-marin-125khz'],
      protocol: ['wiegand-26', 'wiegand-34'],
      outdoor: true,
      keypad: false,
      doorStateInput: true,
      lockOutput: true,
      ipRating: 'IP65',
    },
  },
  {
    id: 'hikvision-ds-k1t344ebfwx-e1-eu',
    manufacturer: 'Hikvision',
    model: 'DS-K1T344EBFWX-E1-EU',
    category: 'access-reader',
    tagline: 'DS-K1T344EBFWX-E1-EU — face-recognition terminal, IP65',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Access-Control-Products/Face-Recognition-Terminals/Value-Series/ds-k1t344ebwx-e1/',
    specs: {
      technology: ['mifare', 'em-marin-125khz'],
      protocol: ['wiegand-26', 'wiegand-34'],
      outdoor: true,
      keypad: false,
      doorStateInput: true,
      lockOutput: true,
      ipRating: 'IP65',
    },
  },
  {
    id: 'hikvision-ds-k1t502dbfwx-c',
    manufacturer: 'Hikvision',
    model: 'DS-K1T502DBFWX-C',
    category: 'access-reader',
    tagline: 'DS-K1T502DBFWX-C — face-recognition terminal, IP65',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Access-Control-Products/FingerPrint-Terminals/Pro-Series/ds-k1t502dbfwx-c/',
    specs: {
      technology: ['mifare'],
      protocol: ['wiegand-26', 'wiegand-34', 'osdp'],
      outdoor: true,
      keypad: true,
      doorStateInput: true,
      lockOutput: true,
      ipRating: 'IP65',
    },
  },
  {
    id: 'hikvision-ds-k1t502dbfwxv',
    manufacturer: 'Hikvision',
    model: 'DS-K1T502DBFWXV',
    category: 'access-reader',
    tagline: 'DS-K1T502DBFWXV — face-recognition terminal, IP65',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Access-Control-Products/FingerPrint-Terminals/Pro-Series/ds-k1t502dbfwx-c/',
    specs: {
      technology: ['mifare'],
      protocol: ['wiegand-26', 'wiegand-34', 'osdp'],
      outdoor: true,
      keypad: true,
      doorStateInput: true,
      lockOutput: true,
      ipRating: 'IP65',
    },
  },
  {
    id: 'hikvision-ds-k1t502dbfwx-e1',
    manufacturer: 'Hikvision',
    model: 'DS-K1T502DBFWX-E1',
    category: 'access-reader',
    tagline: 'DS-K1T502DBFWX-E1 — face-recognition terminal, IP65',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Access-Control-Products/FingerPrint-Terminals/Pro-Series/ds-k1t502dbfwx-c/',
    specs: {
      technology: ['mifare'],
      protocol: ['wiegand-26', 'wiegand-34', 'osdp'],
      outdoor: true,
      keypad: true,
      doorStateInput: true,
      lockOutput: true,
      ipRating: 'IP65',
    },
  },
  {
    id: 'hikvision-ds-k1t502dbfwx-ce1',
    manufacturer: 'Hikvision',
    model: 'DS-K1T502DBFWX-CE1',
    category: 'access-reader',
    tagline: 'DS-K1T502DBFWX-CE1 — face-recognition terminal, IP65',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Access-Control-Products/FingerPrint-Terminals/Pro-Series/ds-k1t502dbfwx-c/',
    specs: {
      technology: ['mifare'],
      protocol: ['wiegand-26', 'wiegand-34', 'osdp'],
      outdoor: true,
      keypad: true,
      doorStateInput: true,
      lockOutput: true,
      ipRating: 'IP65',
    },
  },
  {
    id: 'hikvision-ds-k1t502dbwx',
    manufacturer: 'Hikvision',
    model: 'DS-K1T502DBWX',
    category: 'access-reader',
    tagline: 'DS-K1T502DBWX — face-recognition terminal, IP65',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Access-Control-Products/FingerPrint-Terminals/Pro-Series/ds-k1t502dbfwx-c/',
    specs: {
      technology: ['mifare'],
      protocol: ['wiegand-26', 'wiegand-34', 'osdp'],
      outdoor: true,
      keypad: true,
      doorStateInput: true,
      lockOutput: true,
      ipRating: 'IP65',
    },
  },
  {
    id: 'hikvision-ds-k1t502dbwx-qr',
    manufacturer: 'Hikvision',
    model: 'DS-K1T502DBWX-QR',
    category: 'access-reader',
    tagline: 'DS-K1T502DBWX-QR — face-recognition terminal, IP65',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Access-Control-Products/FingerPrint-Terminals/Pro-Series/ds-k1t502dbfwx-c/',
    specs: {
      technology: ['mifare'],
      protocol: ['wiegand-26', 'wiegand-34', 'osdp'],
      outdoor: true,
      keypad: true,
      doorStateInput: true,
      lockOutput: true,
      ipRating: 'IP65',
    },
  },
  {
    id: 'hikvision-ds-k1t502dbwx-cqr',
    manufacturer: 'Hikvision',
    model: 'DS-K1T502DBWX-CQR',
    category: 'access-reader',
    tagline: 'DS-K1T502DBWX-CQR — face-recognition terminal, IP65',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Access-Control-Products/FingerPrint-Terminals/Pro-Series/ds-k1t502dbfwx-c/',
    specs: {
      technology: ['mifare'],
      protocol: ['wiegand-26', 'wiegand-34', 'osdp'],
      outdoor: true,
      keypad: true,
      doorStateInput: true,
      lockOutput: true,
      ipRating: 'IP65',
    },
  },
  {
    id: 'hikvision-ds-k1t502dbwx-qre1',
    manufacturer: 'Hikvision',
    model: 'DS-K1T502DBWX-QRE1',
    category: 'access-reader',
    tagline: 'DS-K1T502DBWX-QRE1 — face-recognition terminal, IP65',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Access-Control-Products/FingerPrint-Terminals/Pro-Series/ds-k1t502dbfwx-c/',
    specs: {
      technology: ['mifare'],
      protocol: ['wiegand-26', 'wiegand-34', 'osdp'],
      outdoor: true,
      keypad: true,
      doorStateInput: true,
      lockOutput: true,
      ipRating: 'IP65',
    },
  },
  {
    id: 'hikvision-ds-k1t502dbwx-ce1',
    manufacturer: 'Hikvision',
    model: 'DS-K1T502DBWX-CE1',
    category: 'access-reader',
    tagline: 'DS-K1T502DBWX-CE1 — face-recognition terminal, IP65',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Access-Control-Products/FingerPrint-Terminals/Pro-Series/ds-k1t502dbfwx-c/',
    specs: {
      technology: ['mifare'],
      protocol: ['wiegand-26', 'wiegand-34', 'osdp'],
      outdoor: true,
      keypad: true,
      doorStateInput: true,
      lockOutput: true,
      ipRating: 'IP65',
    },
  },
  {
    id: 'hikvision-ds-k1t502dbwx-cqre1',
    manufacturer: 'Hikvision',
    model: 'DS-K1T502DBWX-CQRE1',
    category: 'access-reader',
    tagline: 'DS-K1T502DBWX-CQRE1 — face-recognition terminal, IP65',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Access-Control-Products/FingerPrint-Terminals/Pro-Series/ds-k1t502dbfwx-c/',
    specs: {
      technology: ['mifare'],
      protocol: ['wiegand-26', 'wiegand-34', 'osdp'],
      outdoor: true,
      keypad: true,
      doorStateInput: true,
      lockOutput: true,
      ipRating: 'IP65',
    },
  },
  {
    id: 'hikvision-ds-k1t502dbwx-e1',
    manufacturer: 'Hikvision',
    model: 'DS-K1T502DBWX-E1',
    category: 'access-reader',
    tagline: 'DS-K1T502DBWX-E1 — face-recognition terminal, IP65',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Access-Control-Products/FingerPrint-Terminals/Pro-Series/ds-k1t502dbfwx-c/',
    specs: {
      technology: ['mifare'],
      protocol: ['wiegand-26', 'wiegand-34', 'osdp'],
      outdoor: true,
      keypad: true,
      doorStateInput: true,
      lockOutput: true,
      ipRating: 'IP65',
    },
  },
  {
    id: 'hikvision-ds-k1t502dbwx-c',
    manufacturer: 'Hikvision',
    model: 'DS-K1T502DBWX-C',
    category: 'access-reader',
    tagline: 'DS-K1T502DBWX-C — face-recognition terminal, IP65',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Access-Control-Products/FingerPrint-Terminals/Pro-Series/ds-k1t502dbfwx-c/',
    specs: {
      technology: ['mifare'],
      protocol: ['wiegand-26', 'wiegand-34', 'osdp'],
      outdoor: true,
      keypad: true,
      doorStateInput: true,
      lockOutput: true,
      ipRating: 'IP65',
    },
  },
  {
    id: 'hikvision-ds-k1t502mbw',
    manufacturer: 'Hikvision',
    model: 'DS-K1T502MBW',
    category: 'access-reader',
    tagline: 'DS-K1T502MBW — face-recognition terminal, IP65',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Access-Control-Products/FingerPrint-Terminals/Pro-Series/ds-k1t502dbfwx-c/',
    specs: {
      technology: ['mifare'],
      protocol: ['wiegand-26', 'wiegand-34', 'osdp'],
      outdoor: true,
      keypad: true,
      doorStateInput: true,
      lockOutput: true,
      ipRating: 'IP65',
    },
  },
  {
    id: 'hikvision-ds-k1t502mbfw',
    manufacturer: 'Hikvision',
    model: 'DS-K1T502MBFW',
    category: 'access-reader',
    tagline: 'DS-K1T502MBFW — face-recognition terminal, IP65',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Access-Control-Products/FingerPrint-Terminals/Pro-Series/ds-k1t502dbfwx-c/',
    specs: {
      technology: ['mifare'],
      protocol: ['wiegand-26', 'wiegand-34', 'osdp'],
      outdoor: true,
      keypad: true,
      doorStateInput: true,
      lockOutput: true,
      ipRating: 'IP65',
    },
  },
  {
    id: 'hikvision-ds-k1t502mbfw-c',
    manufacturer: 'Hikvision',
    model: 'DS-K1T502MBFW-C',
    category: 'access-reader',
    tagline: 'DS-K1T502MBFW-C — face-recognition terminal, IP65',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Access-Control-Products/FingerPrint-Terminals/Pro-Series/ds-k1t502dbfwx-c/',
    specs: {
      technology: ['mifare'],
      protocol: ['wiegand-26', 'wiegand-34', 'osdp'],
      outdoor: true,
      keypad: true,
      doorStateInput: true,
      lockOutput: true,
      ipRating: 'IP65',
    },
  },
  {
    id: 'hikvision-ds-k1t502mbw-c',
    manufacturer: 'Hikvision',
    model: 'DS-K1T502MBW-C',
    category: 'access-reader',
    tagline: 'DS-K1T502MBW-C — face-recognition terminal, IP65',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Access-Control-Products/FingerPrint-Terminals/Pro-Series/ds-k1t502dbfwx-c/',
    specs: {
      technology: ['mifare'],
      protocol: ['wiegand-26', 'wiegand-34', 'osdp'],
      outdoor: true,
      keypad: true,
      doorStateInput: true,
      lockOutput: true,
      ipRating: 'IP65',
    },
  },
  {
    id: 'hikvision-ds-k1t502dbwx-c-backbox',
    manufacturer: 'Hikvision',
    model: 'DS-K1T502DBWX-C-BACKBOX',
    category: 'access-reader',
    tagline: 'DS-K1T502DBWX-C-BACKBOX — face-recognition terminal, IP65',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Access-Control-Products/FingerPrint-Terminals/Pro-Series/ds-k1t502dbfwx-c/',
    specs: {
      technology: ['mifare'],
      protocol: ['wiegand-26', 'wiegand-34', 'osdp'],
      outdoor: true,
      keypad: true,
      doorStateInput: true,
      lockOutput: true,
      ipRating: 'IP65',
    },
  },
  {
    id: 'hikvision-ds-k1t6qt-f43mfw',
    manufacturer: 'Hikvision',
    model: 'DS-K1T6QT-F43MFW',
    category: 'access-reader',
    tagline: 'DS-K1T6QT-F43MFW — face-recognition terminal',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Access-Control-Products/Face-Recognition-Terminals/Value-Series/ds-k1t6qt-f43mfw/',
    specs: {
      technology: ['mifare'],
      protocol: ['wiegand-26', 'wiegand-34'],
      outdoor: false,
      keypad: false,
      doorStateInput: true,
      lockOutput: true,
    },
  },
  {
    id: 'hikvision-ds-k1t6qt-f72dx',
    manufacturer: 'Hikvision',
    model: 'DS-K1T6QT-F72DX',
    category: 'access-reader',
    tagline: 'DS-K1T6QT-F72DX — face-recognition terminal',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Access-Control-Products/Face-Recognition-Terminals/Value-Series/ds-k1t6qt-f43mfw/',
    specs: {
      technology: ['mifare'],
      protocol: ['wiegand-26', 'wiegand-34'],
      outdoor: false,
      keypad: false,
      doorStateInput: true,
      lockOutput: true,
    },
  },
  {
    id: 'hikvision-ds-k1t6qt-f72dwx',
    manufacturer: 'Hikvision',
    model: 'DS-K1T6QT-F72DWX',
    category: 'access-reader',
    tagline: 'DS-K1T6QT-F72DWX — face-recognition terminal',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Access-Control-Products/Face-Recognition-Terminals/Value-Series/ds-k1t6qt-f43mfw/',
    specs: {
      technology: ['mifare'],
      protocol: ['wiegand-26', 'wiegand-34'],
      outdoor: false,
      keypad: false,
      doorStateInput: true,
      lockOutput: true,
    },
  },
  {
    id: 'hikvision-ds-k1t6qt-f72tdx',
    manufacturer: 'Hikvision',
    model: 'DS-K1T6QT-F72TDX',
    category: 'access-reader',
    tagline: 'DS-K1T6QT-F72TDX — face-recognition terminal',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Access-Control-Products/Face-Recognition-Terminals/Value-Series/ds-k1t6qt-f43mfw/',
    specs: {
      technology: ['mifare'],
      protocol: ['wiegand-26', 'wiegand-34'],
      outdoor: false,
      keypad: false,
      doorStateInput: true,
      lockOutput: true,
    },
  },
  {
    id: 'hikvision-ds-k1t6qt-f72tdwx',
    manufacturer: 'Hikvision',
    model: 'DS-K1T6QT-F72TDWX',
    category: 'access-reader',
    tagline: 'DS-K1T6QT-F72TDWX — face-recognition terminal',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Access-Control-Products/Face-Recognition-Terminals/Value-Series/ds-k1t6qt-f43mfw/',
    specs: {
      technology: ['mifare'],
      protocol: ['wiegand-26', 'wiegand-34'],
      outdoor: false,
      keypad: false,
      doorStateInput: true,
      lockOutput: true,
    },
  },
  {
    id: 'hikvision-ds-k1t6-gs3',
    manufacturer: 'Hikvision',
    model: 'DS-K1T6-GS3',
    category: 'access-reader',
    tagline: 'DS-K1T6-GS3 — face-recognition terminal',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Access-Control-Products/Face-Recognition-Terminals/Value-Series/ds-k1t6qt-f43mfw/',
    specs: {
      technology: ['mifare'],
      protocol: ['wiegand-26', 'wiegand-34'],
      outdoor: false,
      keypad: false,
      doorStateInput: true,
      lockOutput: true,
    },
  },
  {
    id: 'hikvision-ds-k1t6-gs4',
    manufacturer: 'Hikvision',
    model: 'DS-K1T6-GS4',
    category: 'access-reader',
    tagline: 'DS-K1T6-GS4 — face-recognition terminal',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Access-Control-Products/Face-Recognition-Terminals/Value-Series/ds-k1t6qt-f43mfw/',
    specs: {
      technology: ['mifare'],
      protocol: ['wiegand-26', 'wiegand-34'],
      outdoor: false,
      keypad: false,
      doorStateInput: true,
      lockOutput: true,
    },
  },
  {
    id: 'hikvision-ds-k1t6qt-f70-3xf-tb',
    manufacturer: 'Hikvision',
    model: 'DS-K1T6QT-F70-3XF-TB',
    category: 'access-reader',
    tagline: 'DS-K1T6QT-F70-3XF-TB — face-recognition terminal',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Access-Control-Products/Face-Recognition-Terminals/Value-Series/ds-k1t6qt-f43mfw/',
    specs: {
      technology: ['mifare'],
      protocol: ['wiegand-26', 'wiegand-34'],
      outdoor: false,
      keypad: false,
      doorStateInput: true,
      lockOutput: true,
    },
  },
  {
    id: 'hikvision-ds-k1t6q-f40',
    manufacturer: 'Hikvision',
    model: 'DS-K1T6Q-F40',
    category: 'access-reader',
    tagline: 'DS-K1T6Q-F40 — face-recognition terminal',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Access-Control-Products/Face-Recognition-Terminals/Value-Series/ds-k1t6qt-f43mfw/',
    specs: {
      technology: ['mifare'],
      protocol: ['wiegand-26', 'wiegand-34'],
      outdoor: false,
      keypad: false,
      doorStateInput: true,
      lockOutput: true,
    },
  },
  {
    id: 'hikvision-ds-k1t6q-f70-3xf-tb',
    manufacturer: 'Hikvision',
    model: 'DS-K1T6Q-F70-3XF-TB',
    category: 'access-reader',
    tagline: 'DS-K1T6Q-F70-3XF-TB — face-recognition terminal',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Access-Control-Products/Face-Recognition-Terminals/Value-Series/ds-k1t6qt-f43mfw/',
    specs: {
      technology: ['mifare'],
      protocol: ['wiegand-26', 'wiegand-34'],
      outdoor: false,
      keypad: false,
      doorStateInput: true,
      lockOutput: true,
    },
  },
  {
    id: 'hikvision-ds-k1t6qt-f72',
    manufacturer: 'Hikvision',
    model: 'DS-K1T6QT-F72',
    category: 'access-reader',
    tagline: 'DS-K1T6QT-F72 — face-recognition terminal',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Access-Control-Products/Face-Recognition-Terminals/Value-Series/ds-k1t6qt-f43mfw/',
    specs: {
      technology: ['mifare'],
      protocol: ['wiegand-26', 'wiegand-34'],
      outdoor: false,
      keypad: false,
      doorStateInput: true,
      lockOutput: true,
    },
  },
  {
    id: 'hikvision-ds-k1t6q-f70',
    manufacturer: 'Hikvision',
    model: 'DS-K1T6Q-F70',
    category: 'access-reader',
    tagline: 'DS-K1T6Q-F70 — face-recognition terminal',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Access-Control-Products/Face-Recognition-Terminals/Value-Series/ds-k1t6qt-f43mfw/',
    specs: {
      technology: ['mifare'],
      protocol: ['wiegand-26', 'wiegand-34'],
      outdoor: false,
      keypad: false,
      doorStateInput: true,
      lockOutput: true,
    },
  },
  {
    id: 'hikvision-ds-k1t6q-f41',
    manufacturer: 'Hikvision',
    model: 'DS-K1T6Q-F41',
    category: 'access-reader',
    tagline: 'DS-K1T6Q-F41 — face-recognition terminal',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Access-Control-Products/Face-Recognition-Terminals/Value-Series/ds-k1t6qt-f43mfw/',
    specs: {
      technology: ['mifare'],
      protocol: ['wiegand-26', 'wiegand-34'],
      outdoor: false,
      keypad: false,
      doorStateInput: true,
      lockOutput: true,
    },
  },
  {
    id: 'hikvision-ds-k1t6qt-f73m-3xf',
    manufacturer: 'Hikvision',
    model: 'DS-K1T6QT-F73M-3XF',
    category: 'access-reader',
    tagline: 'DS-K1T6QT-F73M-3XF — face-recognition terminal',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Access-Control-Products/Face-Recognition-Terminals/Value-Series/ds-k1t6qt-f43mfw/',
    specs: {
      technology: ['mifare'],
      protocol: ['wiegand-26', 'wiegand-34'],
      outdoor: false,
      keypad: false,
      doorStateInput: true,
      lockOutput: true,
    },
  },
  {
    id: 'hikvision-ds-k1t6qt-f43mw',
    manufacturer: 'Hikvision',
    model: 'DS-K1T6QT-F43MW',
    category: 'access-reader',
    tagline: 'DS-K1T6QT-F43MW — face-recognition terminal',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Access-Control-Products/Face-Recognition-Terminals/Value-Series/ds-k1t6qt-f43mfw/',
    specs: {
      technology: ['mifare'],
      protocol: ['wiegand-26', 'wiegand-34'],
      outdoor: false,
      keypad: false,
      doorStateInput: true,
      lockOutput: true,
    },
  },
  {
    id: 'hikvision-ds-k1t671mf',
    manufacturer: 'Hikvision',
    model: 'DS-K1T671MF',
    category: 'access-reader',
    tagline: 'DS-K1T671MF — face-recognition terminal',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Access-Control-Products/Face-Recognition-Terminals/Pro-Series/ds-k1t671mf/',
    specs: {
      technology: ['mifare', 'em-marin-125khz'],
      protocol: ['wiegand-26', 'wiegand-34'],
      outdoor: false,
      keypad: false,
      doorStateInput: true,
      lockOutput: true,
    },
  },
  {
    id: 'hikvision-ds-k1t671m',
    manufacturer: 'Hikvision',
    model: 'DS-K1T671M',
    category: 'access-reader',
    tagline: 'DS-K1T671M — face-recognition terminal',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Access-Control-Products/Face-Recognition-Terminals/Pro-Series/ds-k1t671mf/',
    specs: {
      technology: ['mifare', 'em-marin-125khz'],
      protocol: ['wiegand-26', 'wiegand-34'],
      outdoor: false,
      keypad: false,
      doorStateInput: true,
      lockOutput: true,
    },
  },
  {
    id: 'hikvision-ds-k1t671tm-3xf',
    manufacturer: 'Hikvision',
    model: 'DS-K1T671TM-3XF',
    category: 'access-reader',
    tagline: 'DS-K1T671TM-3XF — face-recognition terminal',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Access-Control-Products/Face-Recognition-Terminals/Pro-Series/ds-k1t671mf/',
    specs: {
      technology: ['mifare', 'em-marin-125khz'],
      protocol: ['wiegand-26', 'wiegand-34'],
      outdoor: false,
      keypad: false,
      doorStateInput: true,
      lockOutput: true,
    },
  },
  {
    id: 'hikvision-ds-k1t671tmfw',
    manufacturer: 'Hikvision',
    model: 'DS-K1T671TMFW',
    category: 'access-reader',
    tagline: 'DS-K1T671TMFW — face-recognition terminal',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Access-Control-Products/Face-Recognition-Terminals/Pro-Series/ds-k1t671mf/',
    specs: {
      technology: ['mifare', 'em-marin-125khz'],
      protocol: ['wiegand-26', 'wiegand-34'],
      outdoor: false,
      keypad: false,
      doorStateInput: true,
      lockOutput: true,
    },
  },
  {
    id: 'hikvision-ds-k1t671tmw',
    manufacturer: 'Hikvision',
    model: 'DS-K1T671TMW',
    category: 'access-reader',
    tagline: 'DS-K1T671TMW — face-recognition terminal',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Access-Control-Products/Face-Recognition-Terminals/Pro-Series/ds-k1t671mf/',
    specs: {
      technology: ['mifare', 'em-marin-125khz'],
      protocol: ['wiegand-26', 'wiegand-34'],
      outdoor: false,
      keypad: false,
      doorStateInput: true,
      lockOutput: true,
    },
  },
  {
    id: 'hikvision-ds-k1t671',
    manufacturer: 'Hikvision',
    model: 'DS-K1T671',
    category: 'access-reader',
    tagline: 'DS-K1T671 — face-recognition terminal',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Access-Control-Products/Face-Recognition-Terminals/Pro-Series/ds-k1t671mf/',
    specs: {
      technology: ['mifare', 'em-marin-125khz'],
      protocol: ['wiegand-26', 'wiegand-34'],
      outdoor: false,
      keypad: false,
      doorStateInput: true,
      lockOutput: true,
    },
  },
  {
    id: 'hikvision-ds-k1t671t',
    manufacturer: 'Hikvision',
    model: 'DS-K1T671T',
    category: 'access-reader',
    tagline: 'DS-K1T671T — face-recognition terminal',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Access-Control-Products/Face-Recognition-Terminals/Pro-Series/ds-k1t671mf/',
    specs: {
      technology: ['mifare', 'em-marin-125khz'],
      protocol: ['wiegand-26', 'wiegand-34'],
      outdoor: false,
      keypad: false,
      doorStateInput: true,
      lockOutput: true,
    },
  },
  {
    id: 'hikvision-ds-k1t671b',
    manufacturer: 'Hikvision',
    model: 'DS-K1T671B',
    category: 'access-reader',
    tagline: 'DS-K1T671B — face-recognition terminal',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Access-Control-Products/Face-Recognition-Terminals/Pro-Series/ds-k1t671mf/',
    specs: {
      technology: ['mifare', 'em-marin-125khz'],
      protocol: ['wiegand-26', 'wiegand-34'],
      outdoor: false,
      keypad: false,
      doorStateInput: true,
      lockOutput: true,
    },
  },
  {
    id: 'hikvision-ds-k1t671bm-3xftd',
    manufacturer: 'Hikvision',
    model: 'DS-K1T671BM-3XFTD',
    category: 'access-reader',
    tagline: 'DS-K1T671BM-3XFTD — face-recognition terminal',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Access-Control-Products/Face-Recognition-Terminals/Pro-Series/ds-k1t671mf/',
    specs: {
      technology: ['mifare', 'em-marin-125khz'],
      protocol: ['wiegand-26', 'wiegand-34'],
      outdoor: false,
      keypad: false,
      doorStateInput: true,
      lockOutput: true,
    },
  },
  {
    id: 'hikvision-ds-k1t671tm',
    manufacturer: 'Hikvision',
    model: 'DS-K1T671TM',
    category: 'access-reader',
    tagline: 'DS-K1T671TM — face-recognition terminal',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Access-Control-Products/Face-Recognition-Terminals/Pro-Series/ds-k1t671mf/',
    specs: {
      technology: ['mifare', 'em-marin-125khz'],
      protocol: ['wiegand-26', 'wiegand-34'],
      outdoor: false,
      keypad: false,
      doorStateInput: true,
      lockOutput: true,
    },
  },
  {
    id: 'hikvision-ds-k1t671tmf',
    manufacturer: 'Hikvision',
    model: 'DS-K1T671TMF',
    category: 'access-reader',
    tagline: 'DS-K1T671TMF — face-recognition terminal',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Access-Control-Products/Face-Recognition-Terminals/Pro-Series/ds-k1t671mf/',
    specs: {
      technology: ['mifare', 'em-marin-125khz'],
      protocol: ['wiegand-26', 'wiegand-34'],
      outdoor: false,
      keypad: false,
      doorStateInput: true,
      lockOutput: true,
    },
  },
  {
    id: 'hikvision-ds-k1t671mf-l',
    manufacturer: 'Hikvision',
    model: 'DS-K1T671MF-L',
    category: 'access-reader',
    tagline: 'DS-K1T671MF-L — face-recognition terminal',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Access-Control-Products/Face-Recognition-Terminals/Pro-Series/ds-k1t671mf/',
    specs: {
      technology: ['mifare', 'em-marin-125khz'],
      protocol: ['wiegand-26', 'wiegand-34'],
      outdoor: false,
      keypad: false,
      doorStateInput: true,
      lockOutput: true,
    },
  },
  {
    id: 'hikvision-ds-k1t671m-l',
    manufacturer: 'Hikvision',
    model: 'DS-K1T671M-L',
    category: 'access-reader',
    tagline: 'DS-K1T671M-L — face-recognition terminal',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Access-Control-Products/Face-Recognition-Terminals/Pro-Series/ds-k1t671mf/',
    specs: {
      technology: ['mifare', 'em-marin-125khz'],
      protocol: ['wiegand-26', 'wiegand-34'],
      outdoor: false,
      keypad: false,
      doorStateInput: true,
      lockOutput: true,
    },
  },
  {
    id: 'hikvision-ds-k1t671tm-3xf',
    manufacturer: 'Hikvision',
    model: 'DS-K1T671TM-3XF-',
    category: 'access-reader',
    tagline: 'DS-K1T671TM-3XF- — face-recognition terminal',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Access-Control-Products/Face-Recognition-Terminals/Pro-Series/ds-k1t671mf/',
    specs: {
      technology: ['mifare', 'em-marin-125khz'],
      protocol: ['wiegand-26', 'wiegand-34'],
      outdoor: false,
      keypad: false,
      doorStateInput: true,
      lockOutput: true,
    },
  },
  {
    id: 'hikvision-ds-k1t670mx',
    manufacturer: 'Hikvision',
    model: 'DS-K1T670MX',
    category: 'access-reader',
    tagline: 'DS-K1T670MX — face-recognition terminal, IP65',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Access-Control-Products/Face-Recognition-Terminals/Pro-Series/ds-k1t670mx/',
    specs: {
      technology: ['mifare'],
      protocol: ['wiegand-26', 'wiegand-34', 'osdp'],
      outdoor: true,
      keypad: false,
      doorStateInput: true,
      lockOutput: true,
      ipRating: 'IP65',
    },
  },
  {
    id: 'hikvision-ds-k1t670mwx-qr',
    manufacturer: 'Hikvision',
    model: 'DS-K1T670MWX-QR',
    category: 'access-reader',
    tagline: 'DS-K1T670MWX-QR — face-recognition terminal, IP65',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Access-Control-Products/Face-Recognition-Terminals/Pro-Series/ds-k1t670mx/',
    specs: {
      technology: ['mifare'],
      protocol: ['wiegand-26', 'wiegand-34', 'osdp'],
      outdoor: true,
      keypad: false,
      doorStateInput: true,
      lockOutput: true,
      ipRating: 'IP65',
    },
  },
  {
    id: 'hikvision-ds-k1t670mfwx',
    manufacturer: 'Hikvision',
    model: 'DS-K1T670MFWX',
    category: 'access-reader',
    tagline: 'DS-K1T670MFWX — face-recognition terminal, IP65',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Access-Control-Products/Face-Recognition-Terminals/Pro-Series/ds-k1t670mx/',
    specs: {
      technology: ['mifare'],
      protocol: ['wiegand-26', 'wiegand-34', 'osdp'],
      outdoor: true,
      keypad: false,
      doorStateInput: true,
      lockOutput: true,
      ipRating: 'IP65',
    },
  },
  {
    id: 'hikvision-ds-k1t670mx-qr',
    manufacturer: 'Hikvision',
    model: 'DS-K1T670MX-QR',
    category: 'access-reader',
    tagline: 'DS-K1T670MX-QR — face-recognition terminal, IP65',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Access-Control-Products/Face-Recognition-Terminals/Pro-Series/ds-k1t670mx/',
    specs: {
      technology: ['mifare'],
      protocol: ['wiegand-26', 'wiegand-34', 'osdp'],
      outdoor: true,
      keypad: false,
      doorStateInput: true,
      lockOutput: true,
      ipRating: 'IP65',
    },
  },
  {
    id: 'hikvision-ds-k1t670mwx-wbqr',
    manufacturer: 'Hikvision',
    model: 'DS-K1T670MWX-WBQR',
    category: 'access-reader',
    tagline: 'DS-K1T670MWX-WBQR — face-recognition terminal, IP65',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Access-Control-Products/Face-Recognition-Terminals/Pro-Series/ds-k1t670mx/',
    specs: {
      technology: ['mifare'],
      protocol: ['wiegand-26', 'wiegand-34', 'osdp'],
      outdoor: true,
      keypad: false,
      doorStateInput: true,
      lockOutput: true,
      ipRating: 'IP65',
    },
  },
  {
    id: 'hikvision-ds-k1t670mx-we',
    manufacturer: 'Hikvision',
    model: 'DS-K1T670MX-WE',
    category: 'access-reader',
    tagline: 'DS-K1T670MX-WE — face-recognition terminal, IP65',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Access-Control-Products/Face-Recognition-Terminals/Pro-Series/ds-k1t670mx/',
    specs: {
      technology: ['mifare'],
      protocol: ['wiegand-26', 'wiegand-34', 'osdp'],
      outdoor: true,
      keypad: false,
      doorStateInput: true,
      lockOutput: true,
      ipRating: 'IP65',
    },
  },
  {
    id: 'hikvision-ds-k1t670mx-wb',
    manufacturer: 'Hikvision',
    model: 'DS-K1T670MX-WB',
    category: 'access-reader',
    tagline: 'DS-K1T670MX-WB — face-recognition terminal, IP65',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Access-Control-Products/Face-Recognition-Terminals/Pro-Series/ds-k1t670mx/',
    specs: {
      technology: ['mifare'],
      protocol: ['wiegand-26', 'wiegand-34', 'osdp'],
      outdoor: true,
      keypad: false,
      doorStateInput: true,
      lockOutput: true,
      ipRating: 'IP65',
    },
  },
  {
    id: 'hikvision-ds-k1t670mwx-weqr',
    manufacturer: 'Hikvision',
    model: 'DS-K1T670MWX-WEQR',
    category: 'access-reader',
    tagline: 'DS-K1T670MWX-WEQR — face-recognition terminal, IP65',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Access-Control-Products/Face-Recognition-Terminals/Pro-Series/ds-k1t670mx/',
    specs: {
      technology: ['mifare'],
      protocol: ['wiegand-26', 'wiegand-34', 'osdp'],
      outdoor: true,
      keypad: false,
      doorStateInput: true,
      lockOutput: true,
      ipRating: 'IP65',
    },
  },
  {
    id: 'hikvision-ds-k1t670',
    manufacturer: 'Hikvision',
    model: 'DS-K1T670',
    category: 'access-reader',
    tagline: 'DS-K1T670 — face-recognition terminal, IP65',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Access-Control-Products/Face-Recognition-Terminals/Pro-Series/ds-k1t670mx/',
    specs: {
      technology: ['mifare'],
      protocol: ['wiegand-26', 'wiegand-34', 'osdp'],
      outdoor: true,
      keypad: false,
      doorStateInput: true,
      lockOutput: true,
      ipRating: 'IP65',
    },
  },
  {
    id: 'hikvision-ds-k1t670mwx-wbqr-canada',
    manufacturer: 'Hikvision',
    model: 'DS-K1T670MWX-WBQR-CANADA',
    category: 'access-reader',
    tagline: 'DS-K1T670MWX-WBQR-CANADA — face-recognition terminal, IP65',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Access-Control-Products/Face-Recognition-Terminals/Pro-Series/ds-k1t670mx/',
    specs: {
      technology: ['mifare'],
      protocol: ['wiegand-26', 'wiegand-34', 'osdp'],
      outdoor: true,
      keypad: false,
      doorStateInput: true,
      lockOutput: true,
      ipRating: 'IP65',
    },
  },
  {
    id: 'hikvision-ds-k1t670mwx-qr-msm-moved',
    manufacturer: 'Hikvision',
    model: 'DS-K1T670MWX-QR_MSM_MOVED',
    category: 'access-reader',
    tagline: 'DS-K1T670MWX-QR_MSM_MOVED — face-recognition terminal, IP65',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Access-Control-Products/Face-Recognition-Terminals/Pro-Series/ds-k1t670mx/',
    specs: {
      technology: ['mifare'],
      protocol: ['wiegand-26', 'wiegand-34', 'osdp'],
      outdoor: true,
      keypad: false,
      doorStateInput: true,
      lockOutput: true,
      ipRating: 'IP65',
    },
  },
  {
    id: 'hikvision-ds-k1t670mfwx-msm-moved',
    manufacturer: 'Hikvision',
    model: 'DS-K1T670MFWX_MSM_MOVED',
    category: 'access-reader',
    tagline: 'DS-K1T670MFWX_MSM_MOVED — face-recognition terminal, IP65',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Access-Control-Products/Face-Recognition-Terminals/Pro-Series/ds-k1t670mx/',
    specs: {
      technology: ['mifare'],
      protocol: ['wiegand-26', 'wiegand-34', 'osdp'],
      outdoor: true,
      keypad: false,
      doorStateInput: true,
      lockOutput: true,
      ipRating: 'IP65',
    },
  },
  {
    id: 'hikvision-ds-k1t680df-e1',
    manufacturer: 'Hikvision',
    model: 'DS-K1T680DF-E1',
    category: 'access-reader',
    tagline: 'DS-K1T680DF-E1 — face-recognition terminal, IP65',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Access-Control-Products/Face-Recognition-Terminals/Ultra-Series/ds-k1t680df-e1/',
    specs: {
      technology: ['mifare', 'em-marin-125khz'],
      protocol: ['wiegand-26', 'wiegand-34', 'osdp'],
      outdoor: true,
      keypad: false,
      doorStateInput: true,
      lockOutput: true,
      ipRating: 'IP65',
    },
  },
  {
    id: 'hikvision-ds-k1t680dfg',
    manufacturer: 'Hikvision',
    model: 'DS-K1T680DFG',
    category: 'access-reader',
    tagline: 'DS-K1T680DFG — face-recognition terminal, IP65',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Access-Control-Products/Face-Recognition-Terminals/Ultra-Series/ds-k1t680df-e1/',
    specs: {
      technology: ['mifare', 'em-marin-125khz'],
      protocol: ['wiegand-26', 'wiegand-34', 'osdp'],
      outdoor: true,
      keypad: false,
      doorStateInput: true,
      lockOutput: true,
      ipRating: 'IP65',
    },
  },
  {
    id: 'hikvision-ds-k1t680d-e1',
    manufacturer: 'Hikvision',
    model: 'DS-K1T680D-E1',
    category: 'access-reader',
    tagline: 'DS-K1T680D-E1 — face-recognition terminal, IP65',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Access-Control-Products/Face-Recognition-Terminals/Ultra-Series/ds-k1t680df-e1/',
    specs: {
      technology: ['mifare', 'em-marin-125khz'],
      protocol: ['wiegand-26', 'wiegand-34', 'osdp'],
      outdoor: true,
      keypad: false,
      doorStateInput: true,
      lockOutput: true,
      ipRating: 'IP65',
    },
  },
  {
    id: 'hikvision-ds-k1t680dw',
    manufacturer: 'Hikvision',
    model: 'DS-K1T680DW',
    category: 'access-reader',
    tagline: 'DS-K1T680DW — face-recognition terminal, IP65',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Access-Control-Products/Face-Recognition-Terminals/Ultra-Series/ds-k1t680df-e1/',
    specs: {
      technology: ['mifare', 'em-marin-125khz'],
      protocol: ['wiegand-26', 'wiegand-34', 'osdp'],
      outdoor: true,
      keypad: false,
      doorStateInput: true,
      lockOutput: true,
      ipRating: 'IP65',
    },
  },
  {
    id: 'hikvision-ds-k1t680dg',
    manufacturer: 'Hikvision',
    model: 'DS-K1T680DG',
    category: 'access-reader',
    tagline: 'DS-K1T680DG — face-recognition terminal, IP65',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Access-Control-Products/Face-Recognition-Terminals/Ultra-Series/ds-k1t680df-e1/',
    specs: {
      technology: ['mifare', 'em-marin-125khz'],
      protocol: ['wiegand-26', 'wiegand-34', 'osdp'],
      outdoor: true,
      keypad: false,
      doorStateInput: true,
      lockOutput: true,
      ipRating: 'IP65',
    },
  },
  {
    id: 'hikvision-ds-k1t680dfw',
    manufacturer: 'Hikvision',
    model: 'DS-K1T680DFW',
    category: 'access-reader',
    tagline: 'DS-K1T680DFW — face-recognition terminal, IP65',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Access-Control-Products/Face-Recognition-Terminals/Ultra-Series/ds-k1t680df-e1/',
    specs: {
      technology: ['mifare', 'em-marin-125khz'],
      protocol: ['wiegand-26', 'wiegand-34', 'osdp'],
      outdoor: true,
      keypad: false,
      doorStateInput: true,
      lockOutput: true,
      ipRating: 'IP65',
    },
  },
  {
    id: 'hikvision-ds-k1t680',
    manufacturer: 'Hikvision',
    model: 'DS-K1T680',
    category: 'access-reader',
    tagline: 'DS-K1T680 — face-recognition terminal, IP65',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Access-Control-Products/Face-Recognition-Terminals/Ultra-Series/ds-k1t680df-e1/',
    specs: {
      technology: ['mifare', 'em-marin-125khz'],
      protocol: ['wiegand-26', 'wiegand-34', 'osdp'],
      outdoor: true,
      keypad: false,
      doorStateInput: true,
      lockOutput: true,
      ipRating: 'IP65',
    },
  },
  {
    id: 'hikvision-ds-k1t321mx',
    manufacturer: 'Hikvision',
    model: 'DS-K1T321MX',
    category: 'access-reader',
    tagline: 'DS-K1T321MX — face-recognition terminal',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Access-Control-Products/Face-Recognition-Terminals/Value-Series/ds-k1t321mx/',
    specs: {
      technology: ['mifare', 'em-marin-125khz'],
      protocol: ['wiegand-26', 'wiegand-34'],
      outdoor: false,
      keypad: false,
      doorStateInput: true,
      lockOutput: true,
    },
  },
  {
    id: 'hikvision-ds-k1t321mfx',
    manufacturer: 'Hikvision',
    model: 'DS-K1T321MFX',
    category: 'access-reader',
    tagline: 'DS-K1T321MFX — face-recognition terminal',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Access-Control-Products/Face-Recognition-Terminals/Value-Series/ds-k1t321mx/',
    specs: {
      technology: ['mifare', 'em-marin-125khz'],
      protocol: ['wiegand-26', 'wiegand-34'],
      outdoor: false,
      keypad: false,
      doorStateInput: true,
      lockOutput: true,
    },
  },
  {
    id: 'hikvision-ds-k1t321efwx',
    manufacturer: 'Hikvision',
    model: 'DS-K1T321EFWX',
    category: 'access-reader',
    tagline: 'DS-K1T321EFWX — face-recognition terminal',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Access-Control-Products/Face-Recognition-Terminals/Value-Series/ds-k1t321mx/',
    specs: {
      technology: ['mifare', 'em-marin-125khz'],
      protocol: ['wiegand-26', 'wiegand-34'],
      outdoor: false,
      keypad: false,
      doorStateInput: true,
      lockOutput: true,
    },
  },
  {
    id: 'hikvision-ds-k1t321ewx',
    manufacturer: 'Hikvision',
    model: 'DS-K1T321EWX',
    category: 'access-reader',
    tagline: 'DS-K1T321EWX — face-recognition terminal',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Access-Control-Products/Face-Recognition-Terminals/Value-Series/ds-k1t321mx/',
    specs: {
      technology: ['mifare', 'em-marin-125khz'],
      protocol: ['wiegand-26', 'wiegand-34'],
      outdoor: false,
      keypad: false,
      doorStateInput: true,
      lockOutput: true,
    },
  },
  {
    id: 'hikvision-ds-k1t321efx',
    manufacturer: 'Hikvision',
    model: 'DS-K1T321EFX',
    category: 'access-reader',
    tagline: 'DS-K1T321EFX — face-recognition terminal',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Access-Control-Products/Face-Recognition-Terminals/Value-Series/ds-k1t321mx/',
    specs: {
      technology: ['mifare', 'em-marin-125khz'],
      protocol: ['wiegand-26', 'wiegand-34'],
      outdoor: false,
      keypad: false,
      doorStateInput: true,
      lockOutput: true,
    },
  },
  {
    id: 'hikvision-ds-k1t321mwx',
    manufacturer: 'Hikvision',
    model: 'DS-K1T321MWX',
    category: 'access-reader',
    tagline: 'DS-K1T321MWX — face-recognition terminal',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Access-Control-Products/Face-Recognition-Terminals/Value-Series/ds-k1t321mx/',
    specs: {
      technology: ['mifare', 'em-marin-125khz'],
      protocol: ['wiegand-26', 'wiegand-34'],
      outdoor: false,
      keypad: false,
      doorStateInput: true,
      lockOutput: true,
    },
  },
  {
    id: 'hikvision-ds-k1t321ex',
    manufacturer: 'Hikvision',
    model: 'DS-K1T321EX',
    category: 'access-reader',
    tagline: 'DS-K1T321EX — face-recognition terminal',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Access-Control-Products/Face-Recognition-Terminals/Value-Series/ds-k1t321mx/',
    specs: {
      technology: ['mifare', 'em-marin-125khz'],
      protocol: ['wiegand-26', 'wiegand-34'],
      outdoor: false,
      keypad: false,
      doorStateInput: true,
      lockOutput: true,
    },
  },
  {
    id: 'hikvision-ds-k1t321mfwx',
    manufacturer: 'Hikvision',
    model: 'DS-K1T321MFWX',
    category: 'access-reader',
    tagline: 'DS-K1T321MFWX — face-recognition terminal',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Access-Control-Products/Face-Recognition-Terminals/Value-Series/ds-k1t321mx/',
    specs: {
      technology: ['mifare', 'em-marin-125khz'],
      protocol: ['wiegand-26', 'wiegand-34'],
      outdoor: false,
      keypad: false,
      doorStateInput: true,
      lockOutput: true,
    },
  },
  {
    id: 'hikvision-ds-k1t321mfwx-b',
    manufacturer: 'Hikvision',
    model: 'DS-K1T321MFWX-B',
    category: 'access-reader',
    tagline: 'DS-K1T321MFWX-B — face-recognition terminal',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Access-Control-Products/Face-Recognition-Terminals/Value-Series/ds-k1t321mx/',
    specs: {
      technology: ['mifare', 'em-marin-125khz'],
      protocol: ['wiegand-26', 'wiegand-34'],
      outdoor: false,
      keypad: false,
      doorStateInput: true,
      lockOutput: true,
    },
  },
  {
    id: 'hikvision-ds-k1t321efwx-b',
    manufacturer: 'Hikvision',
    model: 'DS-K1T321EFWX-B',
    category: 'access-reader',
    tagline: 'DS-K1T321EFWX-B — face-recognition terminal',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Access-Control-Products/Face-Recognition-Terminals/Value-Series/ds-k1t321mx/',
    specs: {
      technology: ['mifare', 'em-marin-125khz'],
      protocol: ['wiegand-26', 'wiegand-34'],
      outdoor: false,
      keypad: false,
      doorStateInput: true,
      lockOutput: true,
    },
  },
  {
    id: 'hikvision-ds-k1t321efwx-b-msm-moved',
    manufacturer: 'Hikvision',
    model: 'DS-K1T321EFWX-B_MSM_MOVED',
    category: 'access-reader',
    tagline: 'DS-K1T321EFWX-B_MSM_MOVED — face-recognition terminal',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Access-Control-Products/Face-Recognition-Terminals/Value-Series/ds-k1t321mx/',
    specs: {
      technology: ['mifare', 'em-marin-125khz'],
      protocol: ['wiegand-26', 'wiegand-34'],
      outdoor: false,
      keypad: false,
      doorStateInput: true,
      lockOutput: true,
    },
  },
  {
    id: 'hikvision-ds-k1t321mfwx-b-msm-moved',
    manufacturer: 'Hikvision',
    model: 'DS-K1T321MFWX-B_MSM_MOVED',
    category: 'access-reader',
    tagline: 'DS-K1T321MFWX-B_MSM_MOVED — face-recognition terminal',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Access-Control-Products/Face-Recognition-Terminals/Value-Series/ds-k1t321mx/',
    specs: {
      technology: ['mifare', 'em-marin-125khz'],
      protocol: ['wiegand-26', 'wiegand-34'],
      outdoor: false,
      keypad: false,
      doorStateInput: true,
      lockOutput: true,
    },
  },
  {
    id: 'hikvision-ds-k1t320mwx',
    manufacturer: 'Hikvision',
    model: 'DS-K1T320MWX',
    category: 'access-reader',
    tagline: 'DS-K1T320MWX — face-recognition terminal',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Access-Control-Products/Face-Recognition-Terminals/Value-Series/ds-k1t320mwx/',
    specs: {
      technology: ['mifare', 'em-marin-125khz'],
      protocol: ['wiegand-26', 'wiegand-34'],
      outdoor: false,
      keypad: false,
      doorStateInput: true,
      lockOutput: true,
    },
  },
  {
    id: 'hikvision-ds-k1t320efx',
    manufacturer: 'Hikvision',
    model: 'DS-K1T320EFX',
    category: 'access-reader',
    tagline: 'DS-K1T320EFX — face-recognition terminal',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Access-Control-Products/Face-Recognition-Terminals/Value-Series/ds-k1t320mwx/',
    specs: {
      technology: ['mifare', 'em-marin-125khz'],
      protocol: ['wiegand-26', 'wiegand-34'],
      outdoor: false,
      keypad: false,
      doorStateInput: true,
      lockOutput: true,
    },
  },
  {
    id: 'hikvision-ds-k1t320ewx',
    manufacturer: 'Hikvision',
    model: 'DS-K1T320EWX',
    category: 'access-reader',
    tagline: 'DS-K1T320EWX — face-recognition terminal',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Access-Control-Products/Face-Recognition-Terminals/Value-Series/ds-k1t320mwx/',
    specs: {
      technology: ['mifare', 'em-marin-125khz'],
      protocol: ['wiegand-26', 'wiegand-34'],
      outdoor: false,
      keypad: false,
      doorStateInput: true,
      lockOutput: true,
    },
  },
  {
    id: 'hikvision-ds-k1t320mx',
    manufacturer: 'Hikvision',
    model: 'DS-K1T320MX',
    category: 'access-reader',
    tagline: 'DS-K1T320MX — face-recognition terminal',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Access-Control-Products/Face-Recognition-Terminals/Value-Series/ds-k1t320mwx/',
    specs: {
      technology: ['mifare', 'em-marin-125khz'],
      protocol: ['wiegand-26', 'wiegand-34'],
      outdoor: false,
      keypad: false,
      doorStateInput: true,
      lockOutput: true,
    },
  },
  {
    id: 'hikvision-ds-k1t320ex',
    manufacturer: 'Hikvision',
    model: 'DS-K1T320EX',
    category: 'access-reader',
    tagline: 'DS-K1T320EX — face-recognition terminal',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Access-Control-Products/Face-Recognition-Terminals/Value-Series/ds-k1t320mwx/',
    specs: {
      technology: ['mifare', 'em-marin-125khz'],
      protocol: ['wiegand-26', 'wiegand-34'],
      outdoor: false,
      keypad: false,
      doorStateInput: true,
      lockOutput: true,
    },
  },
  {
    id: 'hikvision-ds-k1t320efwx',
    manufacturer: 'Hikvision',
    model: 'DS-K1T320EFWX',
    category: 'access-reader',
    tagline: 'DS-K1T320EFWX — face-recognition terminal',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Access-Control-Products/Face-Recognition-Terminals/Value-Series/ds-k1t320mwx/',
    specs: {
      technology: ['mifare', 'em-marin-125khz'],
      protocol: ['wiegand-26', 'wiegand-34'],
      outdoor: false,
      keypad: false,
      doorStateInput: true,
      lockOutput: true,
    },
  },
  {
    id: 'hikvision-ds-k1t320mfwx',
    manufacturer: 'Hikvision',
    model: 'DS-K1T320MFWX',
    category: 'access-reader',
    tagline: 'DS-K1T320MFWX — face-recognition terminal',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Access-Control-Products/Face-Recognition-Terminals/Value-Series/ds-k1t320mwx/',
    specs: {
      technology: ['mifare', 'em-marin-125khz'],
      protocol: ['wiegand-26', 'wiegand-34'],
      outdoor: false,
      keypad: false,
      doorStateInput: true,
      lockOutput: true,
    },
  },
  {
    id: 'hikvision-ds-k1t320mfx',
    manufacturer: 'Hikvision',
    model: 'DS-K1T320MFX',
    category: 'access-reader',
    tagline: 'DS-K1T320MFX — face-recognition terminal',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Access-Control-Products/Face-Recognition-Terminals/Value-Series/ds-k1t320mwx/',
    specs: {
      technology: ['mifare', 'em-marin-125khz'],
      protocol: ['wiegand-26', 'wiegand-34'],
      outdoor: false,
      keypad: false,
      doorStateInput: true,
      lockOutput: true,
    },
  },
  {
    id: 'hikvision-ds-k1t320mfwx-b',
    manufacturer: 'Hikvision',
    model: 'DS-K1T320MFWX-B',
    category: 'access-reader',
    tagline: 'DS-K1T320MFWX-B — face-recognition terminal',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Access-Control-Products/Face-Recognition-Terminals/Value-Series/ds-k1t320mwx/',
    specs: {
      technology: ['mifare', 'em-marin-125khz'],
      protocol: ['wiegand-26', 'wiegand-34'],
      outdoor: false,
      keypad: false,
      doorStateInput: true,
      lockOutput: true,
    },
  },
  {
    id: 'hikvision-ds-k1t320efwx-b',
    manufacturer: 'Hikvision',
    model: 'DS-K1T320EFWX-B',
    category: 'access-reader',
    tagline: 'DS-K1T320EFWX-B — face-recognition terminal',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Access-Control-Products/Face-Recognition-Terminals/Value-Series/ds-k1t320mwx/',
    specs: {
      technology: ['mifare', 'em-marin-125khz'],
      protocol: ['wiegand-26', 'wiegand-34'],
      outdoor: false,
      keypad: false,
      doorStateInput: true,
      lockOutput: true,
    },
  },
  {
    id: 'hikvision-ds-k1t320',
    manufacturer: 'Hikvision',
    model: 'DS-K1T320',
    category: 'access-reader',
    tagline: 'DS-K1T320 — face-recognition terminal',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Access-Control-Products/Face-Recognition-Terminals/Value-Series/ds-k1t320mwx/',
    specs: {
      technology: ['mifare', 'em-marin-125khz'],
      protocol: ['wiegand-26', 'wiegand-34'],
      outdoor: false,
      keypad: false,
      doorStateInput: true,
      lockOutput: true,
    },
  },
  {
    id: 'hikvision-ds-k1t323ebwx-qre1',
    manufacturer: 'Hikvision',
    model: 'DS-K1T323EBWX-QRE1',
    category: 'access-reader',
    tagline: 'DS-K1T323EBWX-QRE1 — face-recognition terminal, IP65',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Access-Control-Products/Face-Recognition-Terminals/Value-Series/ds-k1t323ebwx-qre1/',
    specs: {
      technology: ['mifare', 'em-marin-125khz'],
      protocol: ['wiegand-26', 'wiegand-34'],
      outdoor: true,
      keypad: false,
      doorStateInput: true,
      lockOutput: true,
      ipRating: 'IP65',
    },
  },
  {
    id: 'hikvision-ds-k1t323mbwx-e1',
    manufacturer: 'Hikvision',
    model: 'DS-K1T323MBWX-E1',
    category: 'access-reader',
    tagline: 'DS-K1T323MBWX-E1 — face-recognition terminal, IP65',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Access-Control-Products/Face-Recognition-Terminals/Value-Series/ds-k1t323ebwx-qre1/',
    specs: {
      technology: ['mifare', 'em-marin-125khz'],
      protocol: ['wiegand-26', 'wiegand-34'],
      outdoor: true,
      keypad: false,
      doorStateInput: true,
      lockOutput: true,
      ipRating: 'IP65',
    },
  },
  {
    id: 'hikvision-ds-k1t323mbwx-qre1',
    manufacturer: 'Hikvision',
    model: 'DS-K1T323MBWX-QRE1',
    category: 'access-reader',
    tagline: 'DS-K1T323MBWX-QRE1 — face-recognition terminal, IP65',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Access-Control-Products/Face-Recognition-Terminals/Value-Series/ds-k1t323ebwx-qre1/',
    specs: {
      technology: ['mifare', 'em-marin-125khz'],
      protocol: ['wiegand-26', 'wiegand-34'],
      outdoor: true,
      keypad: false,
      doorStateInput: true,
      lockOutput: true,
      ipRating: 'IP65',
    },
  },
  {
    id: 'hikvision-ds-k1t323mbfwx-e1',
    manufacturer: 'Hikvision',
    model: 'DS-K1T323MBFWX-E1',
    category: 'access-reader',
    tagline: 'DS-K1T323MBFWX-E1 — face-recognition terminal, IP65',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Access-Control-Products/Face-Recognition-Terminals/Value-Series/ds-k1t323ebwx-qre1/',
    specs: {
      technology: ['mifare', 'em-marin-125khz'],
      protocol: ['wiegand-26', 'wiegand-34'],
      outdoor: true,
      keypad: false,
      doorStateInput: true,
      lockOutput: true,
      ipRating: 'IP65',
    },
  },
  {
    id: 'hikvision-ds-k1t323ebfwx-e1',
    manufacturer: 'Hikvision',
    model: 'DS-K1T323EBFWX-E1',
    category: 'access-reader',
    tagline: 'DS-K1T323EBFWX-E1 — face-recognition terminal, IP65',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Access-Control-Products/Face-Recognition-Terminals/Value-Series/ds-k1t323ebwx-qre1/',
    specs: {
      technology: ['mifare', 'em-marin-125khz'],
      protocol: ['wiegand-26', 'wiegand-34'],
      outdoor: true,
      keypad: false,
      doorStateInput: true,
      lockOutput: true,
      ipRating: 'IP65',
    },
  },
  {
    id: 'hikvision-ds-k1t323ebwx-e1',
    manufacturer: 'Hikvision',
    model: 'DS-K1T323EBWX-E1',
    category: 'access-reader',
    tagline: 'DS-K1T323EBWX-E1 — face-recognition terminal, IP65',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Access-Control-Products/Face-Recognition-Terminals/Value-Series/ds-k1t323ebwx-qre1/',
    specs: {
      technology: ['mifare', 'em-marin-125khz'],
      protocol: ['wiegand-26', 'wiegand-34'],
      outdoor: true,
      keypad: false,
      doorStateInput: true,
      lockOutput: true,
      ipRating: 'IP65',
    },
  },
  {
    id: 'hikvision-ds-k1t341amf',
    manufacturer: 'Hikvision',
    model: 'DS-K1T341AMF',
    category: 'access-reader',
    tagline: 'DS-K1T341AMF — face-recognition terminal',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Access-Control-Products/Face-Recognition-Terminals/Value-Series/ds-k1t341amf/',
    specs: {
      technology: ['mifare'],
      protocol: ['wiegand-26', 'wiegand-34'],
      outdoor: false,
      keypad: false,
      doorStateInput: true,
      lockOutput: true,
    },
  },
  {
    id: 'hikvision-ds-k1t341am',
    manufacturer: 'Hikvision',
    model: 'DS-K1T341AM',
    category: 'access-reader',
    tagline: 'DS-K1T341AM — face-recognition terminal',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Access-Control-Products/Face-Recognition-Terminals/Value-Series/ds-k1t341amf/',
    specs: {
      technology: ['mifare'],
      protocol: ['wiegand-26', 'wiegand-34'],
      outdoor: false,
      keypad: false,
      doorStateInput: true,
      lockOutput: true,
    },
  },
  {
    id: 'hikvision-ds-k1t341cmf',
    manufacturer: 'Hikvision',
    model: 'DS-K1T341CMF',
    category: 'access-reader',
    tagline: 'DS-K1T341CMF — face-recognition terminal',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Access-Control-Products/Face-Recognition-Terminals/Value-Series/ds-k1t341amf/',
    specs: {
      technology: ['mifare'],
      protocol: ['wiegand-26', 'wiegand-34'],
      outdoor: false,
      keypad: false,
      doorStateInput: true,
      lockOutput: true,
    },
  },
  {
    id: 'hikvision-ds-k1t341cmw',
    manufacturer: 'Hikvision',
    model: 'DS-K1T341CMW',
    category: 'access-reader',
    tagline: 'DS-K1T341CMW — face-recognition terminal',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Access-Control-Products/Face-Recognition-Terminals/Value-Series/ds-k1t341amf/',
    specs: {
      technology: ['mifare'],
      protocol: ['wiegand-26', 'wiegand-34'],
      outdoor: false,
      keypad: false,
      doorStateInput: true,
      lockOutput: true,
    },
  },
  {
    id: 'hikvision-ds-k1t341cmfw',
    manufacturer: 'Hikvision',
    model: 'DS-K1T341CMFW',
    category: 'access-reader',
    tagline: 'DS-K1T341CMFW — face-recognition terminal',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Access-Control-Products/Face-Recognition-Terminals/Value-Series/ds-k1t341amf/',
    specs: {
      technology: ['mifare'],
      protocol: ['wiegand-26', 'wiegand-34'],
      outdoor: false,
      keypad: false,
      doorStateInput: true,
      lockOutput: true,
    },
  },
  {
    id: 'hikvision-ds-k1t341cm',
    manufacturer: 'Hikvision',
    model: 'DS-K1T341CM',
    category: 'access-reader',
    tagline: 'DS-K1T341CM — face-recognition terminal',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Access-Control-Products/Face-Recognition-Terminals/Value-Series/ds-k1t341amf/',
    specs: {
      technology: ['mifare'],
      protocol: ['wiegand-26', 'wiegand-34'],
      outdoor: false,
      keypad: false,
      doorStateInput: true,
      lockOutput: true,
    },
  },
  {
    id: 'hikvision-ds-k1t341',
    manufacturer: 'Hikvision',
    model: 'DS-K1T341',
    category: 'access-reader',
    tagline: 'DS-K1T341 — face-recognition terminal',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Access-Control-Products/Face-Recognition-Terminals/Value-Series/ds-k1t341amf/',
    specs: {
      technology: ['mifare'],
      protocol: ['wiegand-26', 'wiegand-34'],
      outdoor: false,
      keypad: false,
      doorStateInput: true,
      lockOutput: true,
    },
  },
  {
    id: 'hikvision-ds-k1t341b',
    manufacturer: 'Hikvision',
    model: 'DS-K1T341B',
    category: 'access-reader',
    tagline: 'DS-K1T341B — face-recognition terminal',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Access-Control-Products/Face-Recognition-Terminals/Value-Series/ds-k1t341amf/',
    specs: {
      technology: ['mifare'],
      protocol: ['wiegand-26', 'wiegand-34'],
      outdoor: false,
      keypad: false,
      doorStateInput: true,
      lockOutput: true,
    },
  },
  {
    id: 'hikvision-ds-k1t341am-s',
    manufacturer: 'Hikvision',
    model: 'DS-K1T341AM-S',
    category: 'access-reader',
    tagline: 'DS-K1T341AM-S — face-recognition terminal',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Access-Control-Products/Face-Recognition-Terminals/Value-Series/ds-k1t341amf/',
    specs: {
      technology: ['mifare'],
      protocol: ['wiegand-26', 'wiegand-34'],
      outdoor: false,
      keypad: false,
      doorStateInput: true,
      lockOutput: true,
    },
  },
  {
    id: 'hikvision-ds-k1t341amf-s',
    manufacturer: 'Hikvision',
    model: 'DS-K1T341AMF-S',
    category: 'access-reader',
    tagline: 'DS-K1T341AMF-S — face-recognition terminal',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Access-Control-Products/Face-Recognition-Terminals/Value-Series/ds-k1t341amf/',
    specs: {
      technology: ['mifare'],
      protocol: ['wiegand-26', 'wiegand-34'],
      outdoor: false,
      keypad: false,
      doorStateInput: true,
      lockOutput: true,
    },
  },
  {
    id: 'hikvision-ds-k1t341bmwi-t',
    manufacturer: 'Hikvision',
    model: 'DS-K1T341BMWI-T',
    category: 'access-reader',
    tagline: 'DS-K1T341BMWI-T — face-recognition terminal',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Access-Control-Products/Face-Recognition-Terminals/Value-Series/ds-k1t341amf/',
    specs: {
      technology: ['mifare'],
      protocol: ['wiegand-26', 'wiegand-34'],
      outdoor: false,
      keypad: false,
      doorStateInput: true,
      lockOutput: true,
    },
  },
  {
    id: 'hikvision-ds-k1t341a',
    manufacturer: 'Hikvision',
    model: 'DS-K1T341A',
    category: 'access-reader',
    tagline: 'DS-K1T341A — face-recognition terminal',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Access-Control-Products/Face-Recognition-Terminals/Value-Series/ds-k1t341amf/',
    specs: {
      technology: ['mifare'],
      protocol: ['wiegand-26', 'wiegand-34'],
      outdoor: false,
      keypad: false,
      doorStateInput: true,
      lockOutput: true,
    },
  },
  {
    id: 'hikvision-ds-k1t642efw',
    manufacturer: 'Hikvision',
    model: 'DS-K1T642EFW',
    category: 'access-reader',
    tagline: 'DS-K1T642EFW — face-recognition terminal',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Access-Control-Products/Face-Recognition-Terminals/Pro-Series/ds-k1t642efw/',
    specs: {
      technology: ['mifare', 'em-marin-125khz'],
      protocol: ['wiegand-26', 'wiegand-34'],
      outdoor: false,
      keypad: false,
      doorStateInput: true,
      lockOutput: true,
    },
  },
  {
    id: 'hikvision-ds-k1t642ew',
    manufacturer: 'Hikvision',
    model: 'DS-K1T642EW',
    category: 'access-reader',
    tagline: 'DS-K1T642EW — face-recognition terminal',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Access-Control-Products/Face-Recognition-Terminals/Pro-Series/ds-k1t642efw/',
    specs: {
      technology: ['mifare', 'em-marin-125khz'],
      protocol: ['wiegand-26', 'wiegand-34'],
      outdoor: false,
      keypad: false,
      doorStateInput: true,
      lockOutput: true,
    },
  },
  {
    id: 'hikvision-ds-k1t642mw',
    manufacturer: 'Hikvision',
    model: 'DS-K1T642MW',
    category: 'access-reader',
    tagline: 'DS-K1T642MW — face-recognition terminal',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Access-Control-Products/Face-Recognition-Terminals/Pro-Series/ds-k1t642efw/',
    specs: {
      technology: ['mifare', 'em-marin-125khz'],
      protocol: ['wiegand-26', 'wiegand-34'],
      outdoor: false,
      keypad: false,
      doorStateInput: true,
      lockOutput: true,
    },
  },
  {
    id: 'hikvision-ds-k1t642ef',
    manufacturer: 'Hikvision',
    model: 'DS-K1T642EF',
    category: 'access-reader',
    tagline: 'DS-K1T642EF — face-recognition terminal',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Access-Control-Products/Face-Recognition-Terminals/Pro-Series/ds-k1t642efw/',
    specs: {
      technology: ['mifare', 'em-marin-125khz'],
      protocol: ['wiegand-26', 'wiegand-34'],
      outdoor: false,
      keypad: false,
      doorStateInput: true,
      lockOutput: true,
    },
  },
  {
    id: 'hikvision-ds-k1t642e',
    manufacturer: 'Hikvision',
    model: 'DS-K1T642E',
    category: 'access-reader',
    tagline: 'DS-K1T642E — face-recognition terminal',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Access-Control-Products/Face-Recognition-Terminals/Pro-Series/ds-k1t642efw/',
    specs: {
      technology: ['mifare', 'em-marin-125khz'],
      protocol: ['wiegand-26', 'wiegand-34'],
      outdoor: false,
      keypad: false,
      doorStateInput: true,
      lockOutput: true,
    },
  },
  {
    id: 'hikvision-ds-k1t642',
    manufacturer: 'Hikvision',
    model: 'DS-K1T642',
    category: 'access-reader',
    tagline: 'DS-K1T642 — face-recognition terminal',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Access-Control-Products/Face-Recognition-Terminals/Pro-Series/ds-k1t642efw/',
    specs: {
      technology: ['mifare', 'em-marin-125khz'],
      protocol: ['wiegand-26', 'wiegand-34'],
      outdoor: false,
      keypad: false,
      doorStateInput: true,
      lockOutput: true,
    },
  },
  {
    id: 'hikvision-ds-k1t642mf',
    manufacturer: 'Hikvision',
    model: 'DS-K1T642MF',
    category: 'access-reader',
    tagline: 'DS-K1T642MF — face-recognition terminal',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Access-Control-Products/Face-Recognition-Terminals/Pro-Series/ds-k1t642efw/',
    specs: {
      technology: ['mifare', 'em-marin-125khz'],
      protocol: ['wiegand-26', 'wiegand-34'],
      outdoor: false,
      keypad: false,
      doorStateInput: true,
      lockOutput: true,
    },
  },
  {
    id: 'hikvision-ds-k1t642mfw',
    manufacturer: 'Hikvision',
    model: 'DS-K1T642MFW',
    category: 'access-reader',
    tagline: 'DS-K1T642MFW — face-recognition terminal',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Access-Control-Products/Face-Recognition-Terminals/Pro-Series/ds-k1t642efw/',
    specs: {
      technology: ['mifare', 'em-marin-125khz'],
      protocol: ['wiegand-26', 'wiegand-34'],
      outdoor: false,
      keypad: false,
      doorStateInput: true,
      lockOutput: true,
    },
  },
  {
    id: 'hikvision-ds-k1t642m',
    manufacturer: 'Hikvision',
    model: 'DS-K1T642M',
    category: 'access-reader',
    tagline: 'DS-K1T642M — face-recognition terminal',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Access-Control-Products/Face-Recognition-Terminals/Pro-Series/ds-k1t642efw/',
    specs: {
      technology: ['mifare', 'em-marin-125khz'],
      protocol: ['wiegand-26', 'wiegand-34'],
      outdoor: false,
      keypad: false,
      doorStateInput: true,
      lockOutput: true,
    },
  },
  {
    id: 'hikvision-ds-k1t642mfhun-pakistan',
    manufacturer: 'Hikvision',
    model: 'DS-K1T642MFHUN-PAKISTAN',
    category: 'access-reader',
    tagline: 'DS-K1T642MFHUN-PAKISTAN — face-recognition terminal',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Access-Control-Products/Face-Recognition-Terminals/Pro-Series/ds-k1t642efw/',
    specs: {
      technology: ['mifare', 'em-marin-125khz'],
      protocol: ['wiegand-26', 'wiegand-34'],
      outdoor: false,
      keypad: false,
      doorStateInput: true,
      lockOutput: true,
    },
  },
  {
    id: 'hikvision-ds-k1t804aef',
    manufacturer: 'Hikvision',
    model: 'DS-K1T804AEF',
    category: 'access-reader',
    tagline: 'DS-K1T804AEF — fingerprint terminal',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Access-Control-Products/FingerPrint-Terminals/Pro-Series/ds-k1t804aef/',
    specs: {
      technology: ['mifare', 'em-marin-125khz'],
      protocol: ['wiegand-26', 'wiegand-34'],
      outdoor: false,
      keypad: true,
      doorStateInput: true,
      lockOutput: true,
    },
  },
  {
    id: 'hikvision-ds-k1t804af',
    manufacturer: 'Hikvision',
    model: 'DS-K1T804AF',
    category: 'access-reader',
    tagline: 'DS-K1T804AF — fingerprint terminal',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Access-Control-Products/FingerPrint-Terminals/Pro-Series/ds-k1t804aef/',
    specs: {
      technology: ['mifare', 'em-marin-125khz'],
      protocol: ['wiegand-26', 'wiegand-34'],
      outdoor: false,
      keypad: true,
      doorStateInput: true,
      lockOutput: true,
    },
  },
  {
    id: 'hikvision-ds-k1t804amf',
    manufacturer: 'Hikvision',
    model: 'DS-K1T804AMF',
    category: 'access-reader',
    tagline: 'DS-K1T804AMF — fingerprint terminal',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Access-Control-Products/FingerPrint-Terminals/Pro-Series/ds-k1t804aef/',
    specs: {
      technology: ['mifare', 'em-marin-125khz'],
      protocol: ['wiegand-26', 'wiegand-34'],
      outdoor: false,
      keypad: true,
      doorStateInput: true,
      lockOutput: true,
    },
  },
  {
    id: 'hikvision-ds-k1t804mf',
    manufacturer: 'Hikvision',
    model: 'DS-K1T804MF',
    category: 'access-reader',
    tagline: 'DS-K1T804MF — fingerprint terminal',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Access-Control-Products/FingerPrint-Terminals/Pro-Series/ds-k1t804aef/',
    specs: {
      technology: ['mifare', 'em-marin-125khz'],
      protocol: ['wiegand-26', 'wiegand-34'],
      outdoor: false,
      keypad: true,
      doorStateInput: true,
      lockOutput: true,
    },
  },
  {
    id: 'hikvision-ds-k1t804bef',
    manufacturer: 'Hikvision',
    model: 'DS-K1T804BEF',
    category: 'access-reader',
    tagline: 'DS-K1T804BEF — fingerprint terminal',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Access-Control-Products/FingerPrint-Terminals/Pro-Series/ds-k1t804aef/',
    specs: {
      technology: ['mifare', 'em-marin-125khz'],
      protocol: ['wiegand-26', 'wiegand-34'],
      outdoor: false,
      keypad: true,
      doorStateInput: true,
      lockOutput: true,
    },
  },
  {
    id: 'hikvision-ds-k1t804bf',
    manufacturer: 'Hikvision',
    model: 'DS-K1T804BF',
    category: 'access-reader',
    tagline: 'DS-K1T804BF — fingerprint terminal',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Access-Control-Products/FingerPrint-Terminals/Pro-Series/ds-k1t804aef/',
    specs: {
      technology: ['mifare', 'em-marin-125khz'],
      protocol: ['wiegand-26', 'wiegand-34'],
      outdoor: false,
      keypad: true,
      doorStateInput: true,
      lockOutput: true,
    },
  },
  {
    id: 'hikvision-ds-k1t804bmf',
    manufacturer: 'Hikvision',
    model: 'DS-K1T804BMF',
    category: 'access-reader',
    tagline: 'DS-K1T804BMF — fingerprint terminal',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Access-Control-Products/FingerPrint-Terminals/Pro-Series/ds-k1t804aef/',
    specs: {
      technology: ['mifare', 'em-marin-125khz'],
      protocol: ['wiegand-26', 'wiegand-34'],
      outdoor: false,
      keypad: true,
      doorStateInput: true,
      lockOutput: true,
    },
  },
  {
    id: 'hikvision-ds-k1t804ef',
    manufacturer: 'Hikvision',
    model: 'DS-K1T804EF',
    category: 'access-reader',
    tagline: 'DS-K1T804EF — fingerprint terminal',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Access-Control-Products/FingerPrint-Terminals/Pro-Series/ds-k1t804aef/',
    specs: {
      technology: ['mifare', 'em-marin-125khz'],
      protocol: ['wiegand-26', 'wiegand-34'],
      outdoor: false,
      keypad: true,
      doorStateInput: true,
      lockOutput: true,
    },
  },
  {
    id: 'hikvision-ds-k1t804',
    manufacturer: 'Hikvision',
    model: 'DS-K1T804',
    category: 'access-reader',
    tagline: 'DS-K1T804 — fingerprint terminal',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Access-Control-Products/FingerPrint-Terminals/Pro-Series/ds-k1t804aef/',
    specs: {
      technology: ['mifare', 'em-marin-125khz'],
      protocol: ['wiegand-26', 'wiegand-34'],
      outdoor: false,
      keypad: true,
      doorStateInput: true,
      lockOutput: true,
    },
  },
  {
    id: 'hikvision-ds-k1t804b',
    manufacturer: 'Hikvision',
    model: 'DS-K1T804B',
    category: 'access-reader',
    tagline: 'DS-K1T804B — fingerprint terminal',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Access-Control-Products/FingerPrint-Terminals/Pro-Series/ds-k1t804aef/',
    specs: {
      technology: ['mifare', 'em-marin-125khz'],
      protocol: ['wiegand-26', 'wiegand-34'],
      outdoor: false,
      keypad: true,
      doorStateInput: true,
      lockOutput: true,
    },
  },
  {
    id: 'hikvision-ds-k1t804a',
    manufacturer: 'Hikvision',
    model: 'DS-K1T804A',
    category: 'access-reader',
    tagline: 'DS-K1T804A — fingerprint terminal',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Access-Control-Products/FingerPrint-Terminals/Pro-Series/ds-k1t804aef/',
    specs: {
      technology: ['mifare', 'em-marin-125khz'],
      protocol: ['wiegand-26', 'wiegand-34'],
      outdoor: false,
      keypad: true,
      doorStateInput: true,
      lockOutput: true,
    },
  },
  {
    id: 'hikvision-ds-k1t804bmf-msm-moved',
    manufacturer: 'Hikvision',
    model: 'DS-K1T804BMF_MSM_MOVED',
    category: 'access-reader',
    tagline: 'DS-K1T804BMF_MSM_MOVED — fingerprint terminal',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Access-Control-Products/FingerPrint-Terminals/Pro-Series/ds-k1t804aef/',
    specs: {
      technology: ['mifare', 'em-marin-125khz'],
      protocol: ['wiegand-26', 'wiegand-34'],
      outdoor: false,
      keypad: true,
      doorStateInput: true,
      lockOutput: true,
    },
  },
  {
    id: 'hikvision-ds-k1t805mbfwx',
    manufacturer: 'Hikvision',
    model: 'DS-K1T805MBFWX',
    category: 'access-reader',
    tagline: 'DS-K1T805MBFWX — fingerprint terminal, IP65',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Access-Control-Products/FingerPrint-Terminals/Value-Series/ds-k1t805mbfwx/',
    specs: {
      technology: ['mifare', 'em-marin-125khz'],
      protocol: ['wiegand-26', 'wiegand-34'],
      outdoor: true,
      keypad: true,
      doorStateInput: true,
      lockOutput: true,
      ipRating: 'IP65',
    },
  },
  {
    id: 'hikvision-ds-k1t805ebwx',
    manufacturer: 'Hikvision',
    model: 'DS-K1T805EBWX',
    category: 'access-reader',
    tagline: 'DS-K1T805EBWX — fingerprint terminal, IP65',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Access-Control-Products/FingerPrint-Terminals/Value-Series/ds-k1t805mbfwx/',
    specs: {
      technology: ['mifare', 'em-marin-125khz'],
      protocol: ['wiegand-26', 'wiegand-34'],
      outdoor: true,
      keypad: true,
      doorStateInput: true,
      lockOutput: true,
      ipRating: 'IP65',
    },
  },
  {
    id: 'hikvision-ds-k1t805ex',
    manufacturer: 'Hikvision',
    model: 'DS-K1T805EX',
    category: 'access-reader',
    tagline: 'DS-K1T805EX — fingerprint terminal, IP65',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Access-Control-Products/FingerPrint-Terminals/Value-Series/ds-k1t805mbfwx/',
    specs: {
      technology: ['mifare', 'em-marin-125khz'],
      protocol: ['wiegand-26', 'wiegand-34'],
      outdoor: true,
      keypad: true,
      doorStateInput: true,
      lockOutput: true,
      ipRating: 'IP65',
    },
  },
  {
    id: 'hikvision-ds-k1t805mbwx',
    manufacturer: 'Hikvision',
    model: 'DS-K1T805MBWX',
    category: 'access-reader',
    tagline: 'DS-K1T805MBWX — fingerprint terminal, IP65',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Access-Control-Products/FingerPrint-Terminals/Value-Series/ds-k1t805mbfwx/',
    specs: {
      technology: ['mifare', 'em-marin-125khz'],
      protocol: ['wiegand-26', 'wiegand-34'],
      outdoor: true,
      keypad: true,
      doorStateInput: true,
      lockOutput: true,
      ipRating: 'IP65',
    },
  },
  {
    id: 'hikvision-ds-k1t805ebfwx',
    manufacturer: 'Hikvision',
    model: 'DS-K1T805EBFWX',
    category: 'access-reader',
    tagline: 'DS-K1T805EBFWX — fingerprint terminal, IP65',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Access-Control-Products/FingerPrint-Terminals/Value-Series/ds-k1t805mbfwx/',
    specs: {
      technology: ['mifare', 'em-marin-125khz'],
      protocol: ['wiegand-26', 'wiegand-34'],
      outdoor: true,
      keypad: true,
      doorStateInput: true,
      lockOutput: true,
      ipRating: 'IP65',
    },
  },
  {
    id: 'hikvision-ds-k1t805mx',
    manufacturer: 'Hikvision',
    model: 'DS-K1T805MX',
    category: 'access-reader',
    tagline: 'DS-K1T805MX — fingerprint terminal, IP65',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Access-Control-Products/FingerPrint-Terminals/Value-Series/ds-k1t805mbfwx/',
    specs: {
      technology: ['mifare', 'em-marin-125khz'],
      protocol: ['wiegand-26', 'wiegand-34'],
      outdoor: true,
      keypad: true,
      doorStateInput: true,
      lockOutput: true,
      ipRating: 'IP65',
    },
  },
  {
    id: 'hikvision-ds-k1t805mbfwx-msm-moved',
    manufacturer: 'Hikvision',
    model: 'DS-K1T805MBFWX_MSM_MOVED',
    category: 'access-reader',
    tagline: 'DS-K1T805MBFWX_MSM_MOVED — fingerprint terminal, IP65',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Access-Control-Products/FingerPrint-Terminals/Value-Series/ds-k1t805mbfwx/',
    specs: {
      technology: ['mifare', 'em-marin-125khz'],
      protocol: ['wiegand-26', 'wiegand-34'],
      outdoor: true,
      keypad: true,
      doorStateInput: true,
      lockOutput: true,
      ipRating: 'IP65',
    },
  },
  {
    id: 'hikvision-ds-k1t807mbfwx-e1',
    manufacturer: 'Hikvision',
    model: 'DS-K1T807MBFWX-E1',
    category: 'access-reader',
    tagline: 'DS-K1T807MBFWX-E1 — fingerprint terminal, IP65',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Access-Control-Products/FingerPrint-Terminals/Pro-Series/ds-k1t807mbfwx-e1/',
    specs: {
      technology: ['mifare', 'em-marin-125khz'],
      protocol: ['wiegand-26', 'wiegand-34', 'osdp'],
      outdoor: true,
      keypad: true,
      doorStateInput: true,
      lockOutput: true,
      ipRating: 'IP65',
    },
  },
  {
    id: 'hikvision-ds-k1t807ebfwx-e1',
    manufacturer: 'Hikvision',
    model: 'DS-K1T807EBFWX-E1',
    category: 'access-reader',
    tagline: 'DS-K1T807EBFWX-E1 — fingerprint terminal, IP65',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Access-Control-Products/FingerPrint-Terminals/Pro-Series/ds-k1t807mbfwx-e1/',
    specs: {
      technology: ['mifare', 'em-marin-125khz'],
      protocol: ['wiegand-26', 'wiegand-34', 'osdp'],
      outdoor: true,
      keypad: true,
      doorStateInput: true,
      lockOutput: true,
      ipRating: 'IP65',
    },
  },
  {
    id: 'hikvision-ds-k1t807mbfwx-qre1',
    manufacturer: 'Hikvision',
    model: 'DS-K1T807MBFWX-QRE1',
    category: 'access-reader',
    tagline: 'DS-K1T807MBFWX-QRE1 — fingerprint terminal, IP65',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Access-Control-Products/FingerPrint-Terminals/Pro-Series/ds-k1t807mbfwx-e1/',
    specs: {
      technology: ['mifare', 'em-marin-125khz'],
      protocol: ['wiegand-26', 'wiegand-34', 'osdp'],
      outdoor: true,
      keypad: true,
      doorStateInput: true,
      lockOutput: true,
      ipRating: 'IP65',
    },
  },
  {
    id: 'hikvision-ds-k1t807ebfwx-qre1',
    manufacturer: 'Hikvision',
    model: 'DS-K1T807EBFWX-QRE1',
    category: 'access-reader',
    tagline: 'DS-K1T807EBFWX-QRE1 — fingerprint terminal, IP65',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Access-Control-Products/FingerPrint-Terminals/Pro-Series/ds-k1t807mbfwx-e1/',
    specs: {
      technology: ['mifare', 'em-marin-125khz'],
      protocol: ['wiegand-26', 'wiegand-34', 'osdp'],
      outdoor: true,
      keypad: true,
      doorStateInput: true,
      lockOutput: true,
      ipRating: 'IP65',
    },
  },
  {
    id: 'hikvision-ds-k1t807mbwx-qre1',
    manufacturer: 'Hikvision',
    model: 'DS-K1T807MBWX-QRE1',
    category: 'access-reader',
    tagline: 'DS-K1T807MBWX-QRE1 — fingerprint terminal, IP65',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Access-Control-Products/FingerPrint-Terminals/Pro-Series/ds-k1t807mbfwx-e1/',
    specs: {
      technology: ['mifare', 'em-marin-125khz'],
      protocol: ['wiegand-26', 'wiegand-34', 'osdp'],
      outdoor: true,
      keypad: true,
      doorStateInput: true,
      lockOutput: true,
      ipRating: 'IP65',
    },
  },
  {
    id: 'hikvision-ds-k1t807ex-e1',
    manufacturer: 'Hikvision',
    model: 'DS-K1T807EX-E1',
    category: 'access-reader',
    tagline: 'DS-K1T807EX-E1 — fingerprint terminal, IP65',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Access-Control-Products/FingerPrint-Terminals/Pro-Series/ds-k1t807mbfwx-e1/',
    specs: {
      technology: ['mifare', 'em-marin-125khz'],
      protocol: ['wiegand-26', 'wiegand-34', 'osdp'],
      outdoor: true,
      keypad: true,
      doorStateInput: true,
      lockOutput: true,
      ipRating: 'IP65',
    },
  },
  {
    id: 'hikvision-ds-k1t807ebwx-qre1',
    manufacturer: 'Hikvision',
    model: 'DS-K1T807EBWX-QRE1',
    category: 'access-reader',
    tagline: 'DS-K1T807EBWX-QRE1 — fingerprint terminal, IP65',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Access-Control-Products/FingerPrint-Terminals/Pro-Series/ds-k1t807mbfwx-e1/',
    specs: {
      technology: ['mifare', 'em-marin-125khz'],
      protocol: ['wiegand-26', 'wiegand-34', 'osdp'],
      outdoor: true,
      keypad: true,
      doorStateInput: true,
      lockOutput: true,
      ipRating: 'IP65',
    },
  },
  {
    id: 'hikvision-ds-k1t807mx-e1',
    manufacturer: 'Hikvision',
    model: 'DS-K1T807MX-E1',
    category: 'access-reader',
    tagline: 'DS-K1T807MX-E1 — fingerprint terminal, IP65',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Access-Control-Products/FingerPrint-Terminals/Pro-Series/ds-k1t807mbfwx-e1/',
    specs: {
      technology: ['mifare', 'em-marin-125khz'],
      protocol: ['wiegand-26', 'wiegand-34', 'osdp'],
      outdoor: true,
      keypad: true,
      doorStateInput: true,
      lockOutput: true,
      ipRating: 'IP65',
    },
  },
  {
    id: 'hikvision-ds-k1t8005efwx-b',
    manufacturer: 'Hikvision',
    model: 'DS-K1T8005EFWX-B',
    category: 'access-reader',
    tagline: 'DS-K1T8005EFWX-B — fingerprint terminal, IP65',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Access-Control-Products/FingerPrint-Terminals/Pro-Series/ds-k1t8005efwx-b/',
    specs: {
      technology: ['mifare', 'em-marin-125khz'],
      protocol: ['wiegand-26', 'wiegand-34'],
      outdoor: true,
      keypad: true,
      doorStateInput: true,
      lockOutput: true,
      ipRating: 'IP65',
    },
  },
  {
    id: 'hikvision-ds-k1t8005mfwx-b',
    manufacturer: 'Hikvision',
    model: 'DS-K1T8005MFWX-B',
    category: 'access-reader',
    tagline: 'DS-K1T8005MFWX-B — fingerprint terminal, IP65',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Access-Control-Products/FingerPrint-Terminals/Pro-Series/ds-k1t8005efwx-b/',
    specs: {
      technology: ['mifare', 'em-marin-125khz'],
      protocol: ['wiegand-26', 'wiegand-34'],
      outdoor: true,
      keypad: true,
      doorStateInput: true,
      lockOutput: true,
      ipRating: 'IP65',
    },
  },
  {
    id: 'hikvision-ds-k1t8005efx',
    manufacturer: 'Hikvision',
    model: 'DS-K1T8005EFX',
    category: 'access-reader',
    tagline: 'DS-K1T8005EFX — fingerprint terminal, IP65',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Access-Control-Products/FingerPrint-Terminals/Pro-Series/ds-k1t8005efwx-b/',
    specs: {
      technology: ['mifare', 'em-marin-125khz'],
      protocol: ['wiegand-26', 'wiegand-34'],
      outdoor: true,
      keypad: true,
      doorStateInput: true,
      lockOutput: true,
      ipRating: 'IP65',
    },
  },
  {
    id: 'hikvision-ds-k1t8005efwx',
    manufacturer: 'Hikvision',
    model: 'DS-K1T8005EFWX',
    category: 'access-reader',
    tagline: 'DS-K1T8005EFWX — fingerprint terminal, IP65',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Access-Control-Products/FingerPrint-Terminals/Pro-Series/ds-k1t8005efwx-b/',
    specs: {
      technology: ['mifare', 'em-marin-125khz'],
      protocol: ['wiegand-26', 'wiegand-34'],
      outdoor: true,
      keypad: true,
      doorStateInput: true,
      lockOutput: true,
      ipRating: 'IP65',
    },
  },
  {
    id: 'hikvision-ds-k1t8005mfx',
    manufacturer: 'Hikvision',
    model: 'DS-K1T8005MFX',
    category: 'access-reader',
    tagline: 'DS-K1T8005MFX — fingerprint terminal, IP65',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Access-Control-Products/FingerPrint-Terminals/Pro-Series/ds-k1t8005efwx-b/',
    specs: {
      technology: ['mifare', 'em-marin-125khz'],
      protocol: ['wiegand-26', 'wiegand-34'],
      outdoor: true,
      keypad: true,
      doorStateInput: true,
      lockOutput: true,
      ipRating: 'IP65',
    },
  },
  {
    id: 'hikvision-ds-k1t8005mfwx',
    manufacturer: 'Hikvision',
    model: 'DS-K1T8005MFWX',
    category: 'access-reader',
    tagline: 'DS-K1T8005MFWX — fingerprint terminal, IP65',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Access-Control-Products/FingerPrint-Terminals/Pro-Series/ds-k1t8005efwx-b/',
    specs: {
      technology: ['mifare', 'em-marin-125khz'],
      protocol: ['wiegand-26', 'wiegand-34'],
      outdoor: true,
      keypad: true,
      doorStateInput: true,
      lockOutput: true,
      ipRating: 'IP65',
    },
  },
  {
    id: 'hikvision-ds-k1a802amf-b',
    manufacturer: 'Hikvision',
    model: 'DS-K1A802AMF-B',
    category: 'access-reader',
    tagline: 'DS-K1A802AMF-B — fingerprint terminal',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Access-Control-Products/FingerPrint-Terminals/Pro-Series/ds-k1a802amf-b/',
    specs: {
      technology: ['mifare', 'em-marin-125khz'],
      protocol: ['wiegand-26', 'wiegand-34'],
      outdoor: false,
      keypad: true,
      doorStateInput: true,
      lockOutput: true,
    },
  },
  {
    id: 'hikvision-ds-k1a802aef-b',
    manufacturer: 'Hikvision',
    model: 'DS-K1A802AEF-B',
    category: 'access-reader',
    tagline: 'DS-K1A802AEF-B — fingerprint terminal',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Access-Control-Products/FingerPrint-Terminals/Pro-Series/ds-k1a802amf-b/',
    specs: {
      technology: ['mifare', 'em-marin-125khz'],
      protocol: ['wiegand-26', 'wiegand-34'],
      outdoor: false,
      keypad: true,
      doorStateInput: true,
      lockOutput: true,
    },
  },
  {
    id: 'hikvision-ds-k1a802aef',
    manufacturer: 'Hikvision',
    model: 'DS-K1A802AEF',
    category: 'access-reader',
    tagline: 'DS-K1A802AEF — fingerprint terminal',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Access-Control-Products/FingerPrint-Terminals/Pro-Series/ds-k1a802amf-b/',
    specs: {
      technology: ['mifare', 'em-marin-125khz'],
      protocol: ['wiegand-26', 'wiegand-34'],
      outdoor: false,
      keypad: true,
      doorStateInput: true,
      lockOutput: true,
    },
  },
  {
    id: 'hikvision-ds-k1a802af-b',
    manufacturer: 'Hikvision',
    model: 'DS-K1A802AF-B',
    category: 'access-reader',
    tagline: 'DS-K1A802AF-B — fingerprint terminal',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Access-Control-Products/FingerPrint-Terminals/Pro-Series/ds-k1a802amf-b/',
    specs: {
      technology: ['mifare', 'em-marin-125khz'],
      protocol: ['wiegand-26', 'wiegand-34'],
      outdoor: false,
      keypad: true,
      doorStateInput: true,
      lockOutput: true,
    },
  },
  {
    id: 'hikvision-ds-k1a802af',
    manufacturer: 'Hikvision',
    model: 'DS-K1A802AF',
    category: 'access-reader',
    tagline: 'DS-K1A802AF — fingerprint terminal',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Access-Control-Products/FingerPrint-Terminals/Pro-Series/ds-k1a802amf-b/',
    specs: {
      technology: ['mifare', 'em-marin-125khz'],
      protocol: ['wiegand-26', 'wiegand-34'],
      outdoor: false,
      keypad: true,
      doorStateInput: true,
      lockOutput: true,
    },
  },
  {
    id: 'hikvision-ds-k1a802mf-b',
    manufacturer: 'Hikvision',
    model: 'DS-K1A802MF-B',
    category: 'access-reader',
    tagline: 'DS-K1A802MF-B — fingerprint terminal',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Access-Control-Products/FingerPrint-Terminals/Pro-Series/ds-k1a802amf-b/',
    specs: {
      technology: ['mifare', 'em-marin-125khz'],
      protocol: ['wiegand-26', 'wiegand-34'],
      outdoor: false,
      keypad: true,
      doorStateInput: true,
      lockOutput: true,
    },
  },
  {
    id: 'hikvision-ds-k1a802ef-b',
    manufacturer: 'Hikvision',
    model: 'DS-K1A802EF-B',
    category: 'access-reader',
    tagline: 'DS-K1A802EF-B — fingerprint terminal',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Access-Control-Products/FingerPrint-Terminals/Pro-Series/ds-k1a802amf-b/',
    specs: {
      technology: ['mifare', 'em-marin-125khz'],
      protocol: ['wiegand-26', 'wiegand-34'],
      outdoor: false,
      keypad: true,
      doorStateInput: true,
      lockOutput: true,
    },
  },
  {
    id: 'hikvision-ds-k1a802mf',
    manufacturer: 'Hikvision',
    model: 'DS-K1A802MF',
    category: 'access-reader',
    tagline: 'DS-K1A802MF — fingerprint terminal',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Access-Control-Products/FingerPrint-Terminals/Pro-Series/ds-k1a802amf-b/',
    specs: {
      technology: ['mifare', 'em-marin-125khz'],
      protocol: ['wiegand-26', 'wiegand-34'],
      outdoor: false,
      keypad: true,
      doorStateInput: true,
      lockOutput: true,
    },
  },
  {
    id: 'hikvision-ds-k1a802',
    manufacturer: 'Hikvision',
    model: 'DS-K1A802',
    category: 'access-reader',
    tagline: 'DS-K1A802 — fingerprint terminal',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Access-Control-Products/FingerPrint-Terminals/Pro-Series/ds-k1a802amf-b/',
    specs: {
      technology: ['mifare', 'em-marin-125khz'],
      protocol: ['wiegand-26', 'wiegand-34'],
      outdoor: false,
      keypad: true,
      doorStateInput: true,
      lockOutput: true,
    },
  },
  {
    id: 'hikvision-ds-k1a802amf',
    manufacturer: 'Hikvision',
    model: 'DS-K1A802AMF',
    category: 'access-reader',
    tagline: 'DS-K1A802AMF — fingerprint terminal',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Access-Control-Products/FingerPrint-Terminals/Pro-Series/ds-k1a802amf-b/',
    specs: {
      technology: ['mifare', 'em-marin-125khz'],
      protocol: ['wiegand-26', 'wiegand-34'],
      outdoor: false,
      keypad: true,
      doorStateInput: true,
      lockOutput: true,
    },
  },
  {
    id: 'hikvision-ds-k1a802f-b',
    manufacturer: 'Hikvision',
    model: 'DS-K1A802F-B',
    category: 'access-reader',
    tagline: 'DS-K1A802F-B — fingerprint terminal',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Access-Control-Products/FingerPrint-Terminals/Pro-Series/ds-k1a802amf-b/',
    specs: {
      technology: ['mifare', 'em-marin-125khz'],
      protocol: ['wiegand-26', 'wiegand-34'],
      outdoor: false,
      keypad: true,
      doorStateInput: true,
      lockOutput: true,
    },
  },
  {
    id: 'hikvision-ds-k1a802ef',
    manufacturer: 'Hikvision',
    model: 'DS-K1A802EF',
    category: 'access-reader',
    tagline: 'DS-K1A802EF — fingerprint terminal',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Access-Control-Products/FingerPrint-Terminals/Pro-Series/ds-k1a802amf-b/',
    specs: {
      technology: ['mifare', 'em-marin-125khz'],
      protocol: ['wiegand-26', 'wiegand-34'],
      outdoor: false,
      keypad: true,
      doorStateInput: true,
      lockOutput: true,
    },
  },
  {
    id: 'hikvision-ds-k1a8503f',
    manufacturer: 'Hikvision',
    model: 'DS-K1A8503F',
    category: 'access-reader',
    tagline: 'DS-K1A8503F — fingerprint terminal',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Access-Control-Products/FingerPrint-Terminals/Value-Series/ds-k1a8503f/',
    specs: {
      technology: ['mifare', 'em-marin-125khz'],
      protocol: ['wiegand-26', 'wiegand-34'],
      outdoor: false,
      keypad: true,
      doorStateInput: true,
      lockOutput: true,
    },
  },
  {
    id: 'hikvision-ds-k1a8503mf',
    manufacturer: 'Hikvision',
    model: 'DS-K1A8503MF',
    category: 'access-reader',
    tagline: 'DS-K1A8503MF — fingerprint terminal',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Access-Control-Products/FingerPrint-Terminals/Value-Series/ds-k1a8503f/',
    specs: {
      technology: ['mifare', 'em-marin-125khz'],
      protocol: ['wiegand-26', 'wiegand-34'],
      outdoor: false,
      keypad: true,
      doorStateInput: true,
      lockOutput: true,
    },
  },
  {
    id: 'hikvision-ds-k1a8503f-b',
    manufacturer: 'Hikvision',
    model: 'DS-K1A8503F-B',
    category: 'access-reader',
    tagline: 'DS-K1A8503F-B — fingerprint terminal',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Access-Control-Products/FingerPrint-Terminals/Value-Series/ds-k1a8503f/',
    specs: {
      technology: ['mifare', 'em-marin-125khz'],
      protocol: ['wiegand-26', 'wiegand-34'],
      outdoor: false,
      keypad: true,
      doorStateInput: true,
      lockOutput: true,
    },
  },
  {
    id: 'hikvision-ds-k1a8503ef-b',
    manufacturer: 'Hikvision',
    model: 'DS-K1A8503EF-B',
    category: 'access-reader',
    tagline: 'DS-K1A8503EF-B — fingerprint terminal',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Access-Control-Products/FingerPrint-Terminals/Value-Series/ds-k1a8503f/',
    specs: {
      technology: ['mifare', 'em-marin-125khz'],
      protocol: ['wiegand-26', 'wiegand-34'],
      outdoor: false,
      keypad: true,
      doorStateInput: true,
      lockOutput: true,
    },
  },
  {
    id: 'hikvision-ds-k1a8503ef',
    manufacturer: 'Hikvision',
    model: 'DS-K1A8503EF',
    category: 'access-reader',
    tagline: 'DS-K1A8503EF — fingerprint terminal',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Access-Control-Products/FingerPrint-Terminals/Value-Series/ds-k1a8503f/',
    specs: {
      technology: ['mifare', 'em-marin-125khz'],
      protocol: ['wiegand-26', 'wiegand-34'],
      outdoor: false,
      keypad: true,
      doorStateInput: true,
      lockOutput: true,
    },
  },
  {
    id: 'hikvision-ds-k1a8503mf-b',
    manufacturer: 'Hikvision',
    model: 'DS-K1A8503MF-B',
    category: 'access-reader',
    tagline: 'DS-K1A8503MF-B — fingerprint terminal',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Access-Control-Products/FingerPrint-Terminals/Value-Series/ds-k1a8503f/',
    specs: {
      technology: ['mifare', 'em-marin-125khz'],
      protocol: ['wiegand-26', 'wiegand-34'],
      outdoor: false,
      keypad: true,
      doorStateInput: true,
      lockOutput: true,
    },
  },
  {
    id: 'hikvision-ds-k1a8503',
    manufacturer: 'Hikvision',
    model: 'DS-K1A8503',
    category: 'access-reader',
    tagline: 'DS-K1A8503 — fingerprint terminal',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Access-Control-Products/FingerPrint-Terminals/Value-Series/ds-k1a8503f/',
    specs: {
      technology: ['mifare', 'em-marin-125khz'],
      protocol: ['wiegand-26', 'wiegand-34'],
      outdoor: false,
      keypad: true,
      doorStateInput: true,
      lockOutput: true,
    },
  },
  {
    id: 'hikvision-ds-k1t105am',
    manufacturer: 'Hikvision',
    model: 'DS-K1T105AM',
    category: 'access-reader',
    tagline: 'DS-K1T105AM — card reader',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Access-Control-Products/Card-Terminals/Pro-Series/ds-k1t105am/',
    specs: {
      technology: ['mifare', 'em-marin-125khz'],
      protocol: ['wiegand-26', 'wiegand-34'],
      outdoor: false,
      keypad: true,
      doorStateInput: true,
      lockOutput: true,
    },
  },
  {
    id: 'hikvision-ds-k1t105ae',
    manufacturer: 'Hikvision',
    model: 'DS-K1T105AE',
    category: 'access-reader',
    tagline: 'DS-K1T105AE — card reader',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Access-Control-Products/Card-Terminals/Pro-Series/ds-k1t105am/',
    specs: {
      technology: ['mifare', 'em-marin-125khz'],
      protocol: ['wiegand-26', 'wiegand-34'],
      outdoor: false,
      keypad: true,
      doorStateInput: true,
      lockOutput: true,
    },
  },
  {
    id: 'hikvision-ds-k1t105',
    manufacturer: 'Hikvision',
    model: 'DS-K1T105',
    category: 'access-reader',
    tagline: 'DS-K1T105 — card reader',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Access-Control-Products/Card-Terminals/Pro-Series/ds-k1t105am/',
    specs: {
      technology: ['mifare', 'em-marin-125khz'],
      protocol: ['wiegand-26', 'wiegand-34'],
      outdoor: false,
      keypad: true,
      doorStateInput: true,
      lockOutput: true,
    },
  },
  {
    id: 'hikvision-ds-k1t105a',
    manufacturer: 'Hikvision',
    model: 'DS-K1T105A',
    category: 'access-reader',
    tagline: 'DS-K1T105A — card reader',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Access-Control-Products/Card-Terminals/Pro-Series/ds-k1t105am/',
    specs: {
      technology: ['mifare', 'em-marin-125khz'],
      protocol: ['wiegand-26', 'wiegand-34'],
      outdoor: false,
      keypad: true,
      doorStateInput: true,
      lockOutput: true,
    },
  },
  {
    id: 'hikvision-ds-k1t105e',
    manufacturer: 'Hikvision',
    model: 'DS-K1T105E',
    category: 'access-reader',
    tagline: 'DS-K1T105E — card reader',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Access-Control-Products/Card-Terminals/Pro-Series/ds-k1t105am/',
    specs: {
      technology: ['mifare', 'em-marin-125khz'],
      protocol: ['wiegand-26', 'wiegand-34'],
      outdoor: false,
      keypad: true,
      doorStateInput: true,
      lockOutput: true,
    },
  },
  {
    id: 'hikvision-ds-k1t105e-c',
    manufacturer: 'Hikvision',
    model: 'DS-K1T105E-C',
    category: 'access-reader',
    tagline: 'DS-K1T105E-C — card reader',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Access-Control-Products/Card-Terminals/Pro-Series/ds-k1t105am/',
    specs: {
      technology: ['mifare', 'em-marin-125khz'],
      protocol: ['wiegand-26', 'wiegand-34'],
      outdoor: false,
      keypad: true,
      doorStateInput: true,
      lockOutput: true,
    },
  },
  {
    id: 'hikvision-ds-k1t105m',
    manufacturer: 'Hikvision',
    model: 'DS-K1T105M',
    category: 'access-reader',
    tagline: 'DS-K1T105M — card reader',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Access-Control-Products/Card-Terminals/Pro-Series/ds-k1t105am/',
    specs: {
      technology: ['mifare', 'em-marin-125khz'],
      protocol: ['wiegand-26', 'wiegand-34'],
      outdoor: false,
      keypad: true,
      doorStateInput: true,
      lockOutput: true,
    },
  },
  {
    id: 'hikvision-ds-k1t105m-c',
    manufacturer: 'Hikvision',
    model: 'DS-K1T105M-C',
    category: 'access-reader',
    tagline: 'DS-K1T105M-C — card reader',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Access-Control-Products/Card-Terminals/Pro-Series/ds-k1t105am/',
    specs: {
      technology: ['mifare', 'em-marin-125khz'],
      protocol: ['wiegand-26', 'wiegand-34'],
      outdoor: false,
      keypad: true,
      doorStateInput: true,
      lockOutput: true,
    },
  },
  {
    id: 'hikvision-ds-k1t607',
    manufacturer: 'Hikvision',
    model: 'DS-K1T607',
    category: 'access-reader',
    tagline: 'DS-K1T607 — face-recognition terminal',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/africa/products/Access-Control-Products/Face-Recognition-Terminals/Pro-Series/DS-K1T607/',
    specs: {
      technology: ['mifare'],
      protocol: ['wiegand-26', 'wiegand-34'],
      outdoor: false,
      keypad: false,
      doorStateInput: true,
      lockOutput: true,
    },
  },
  {
    id: 'hikvision-ds-k1t607mf',
    manufacturer: 'Hikvision',
    model: 'DS-K1T607MF',
    category: 'access-reader',
    tagline: 'DS-K1T607MF — face-recognition terminal',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/africa/products/Access-Control-Products/Face-Recognition-Terminals/Pro-Series/DS-K1T607/',
    specs: {
      technology: ['mifare'],
      protocol: ['wiegand-26', 'wiegand-34'],
      outdoor: false,
      keypad: false,
      doorStateInput: true,
      lockOutput: true,
    },
  },
  {
    id: 'hikvision-ds-k1t607p',
    manufacturer: 'Hikvision',
    model: 'DS-K1T607P',
    category: 'access-reader',
    tagline: 'DS-K1T607P — face-recognition terminal',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/africa/products/Access-Control-Products/Face-Recognition-Terminals/Pro-Series/DS-K1T607/',
    specs: {
      technology: ['mifare'],
      protocol: ['wiegand-26', 'wiegand-34'],
      outdoor: false,
      keypad: false,
      doorStateInput: true,
      lockOutput: true,
    },
  },
  {
    id: 'hikvision-ds-k1t607t',
    manufacturer: 'Hikvision',
    model: 'DS-K1T607T',
    category: 'access-reader',
    tagline: 'DS-K1T607T — face-recognition terminal',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/africa/products/Access-Control-Products/Face-Recognition-Terminals/Pro-Series/DS-K1T607/',
    specs: {
      technology: ['mifare'],
      protocol: ['wiegand-26', 'wiegand-34'],
      outdoor: false,
      keypad: false,
      doorStateInput: true,
      lockOutput: true,
    },
  },
  {
    id: 'hikvision-ds-k1t607pmfw',
    manufacturer: 'Hikvision',
    model: 'DS-K1T607PMFW',
    category: 'access-reader',
    tagline: 'DS-K1T607PMFW — face-recognition terminal',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/africa/products/Access-Control-Products/Face-Recognition-Terminals/Pro-Series/DS-K1T607/',
    specs: {
      technology: ['mifare'],
      protocol: ['wiegand-26', 'wiegand-34'],
      outdoor: false,
      keypad: false,
      doorStateInput: true,
      lockOutput: true,
    },
  },
  {
    id: 'hikvision-ds-k1t607pmw',
    manufacturer: 'Hikvision',
    model: 'DS-K1T607PMW',
    category: 'access-reader',
    tagline: 'DS-K1T607PMW — face-recognition terminal',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/africa/products/Access-Control-Products/Face-Recognition-Terminals/Pro-Series/DS-K1T607/',
    specs: {
      technology: ['mifare'],
      protocol: ['wiegand-26', 'wiegand-34'],
      outdoor: false,
      keypad: false,
      doorStateInput: true,
      lockOutput: true,
    },
  },
  {
    id: 'hikvision-ds-k1105edkb',
    manufacturer: 'Hikvision',
    model: 'DS-K1105EDKB',
    category: 'access-reader',
    tagline: 'DS-K1105EDKB — card reader, IP65',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Access-Control-Products/Readers/Pro-Series/ds-k1105edkb/',
    specs: {
      technology: ['mifare', 'em-marin-125khz'],
      protocol: ['wiegand-26', 'wiegand-34', 'osdp'],
      outdoor: true,
      keypad: true,
      ipRating: 'IP65',
    },
  },
  {
    id: 'hikvision-ds-k1105edkb-qr',
    manufacturer: 'Hikvision',
    model: 'DS-K1105EDKB-QR',
    category: 'access-reader',
    tagline: 'DS-K1105EDKB-QR — card reader, IP65',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Access-Control-Products/Readers/Pro-Series/ds-k1105edkb/',
    specs: {
      technology: ['mifare', 'em-marin-125khz'],
      protocol: ['wiegand-26', 'wiegand-34', 'osdp'],
      outdoor: true,
      keypad: true,
      ipRating: 'IP65',
    },
  },
  {
    id: 'hikvision-ds-k1105emkb-qr',
    manufacturer: 'Hikvision',
    model: 'DS-K1105EMKB-QR',
    category: 'access-reader',
    tagline: 'DS-K1105EMKB-QR — card reader, IP65',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Access-Control-Products/Readers/Pro-Series/ds-k1105edkb/',
    specs: {
      technology: ['mifare', 'em-marin-125khz'],
      protocol: ['wiegand-26', 'wiegand-34', 'osdp'],
      outdoor: true,
      keypad: true,
      ipRating: 'IP65',
    },
  },
  {
    id: 'hikvision-ds-k1105edb',
    manufacturer: 'Hikvision',
    model: 'DS-K1105EDB',
    category: 'access-reader',
    tagline: 'DS-K1105EDB — card reader, IP65',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Access-Control-Products/Readers/Pro-Series/ds-k1105edkb/',
    specs: {
      technology: ['mifare', 'em-marin-125khz'],
      protocol: ['wiegand-26', 'wiegand-34', 'osdp'],
      outdoor: true,
      keypad: true,
      ipRating: 'IP65',
    },
  },
  {
    id: 'hikvision-ds-k1105emb',
    manufacturer: 'Hikvision',
    model: 'DS-K1105EMB',
    category: 'access-reader',
    tagline: 'DS-K1105EMB — card reader, IP65',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Access-Control-Products/Readers/Pro-Series/ds-k1105edkb/',
    specs: {
      technology: ['mifare', 'em-marin-125khz'],
      protocol: ['wiegand-26', 'wiegand-34', 'osdp'],
      outdoor: true,
      keypad: true,
      ipRating: 'IP65',
    },
  },
  {
    id: 'hikvision-ds-k1105emkb',
    manufacturer: 'Hikvision',
    model: 'DS-K1105EMKB',
    category: 'access-reader',
    tagline: 'DS-K1105EMKB — card reader, IP65',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Access-Control-Products/Readers/Pro-Series/ds-k1105edkb/',
    specs: {
      technology: ['mifare', 'em-marin-125khz'],
      protocol: ['wiegand-26', 'wiegand-34', 'osdp'],
      outdoor: true,
      keypad: true,
      ipRating: 'IP65',
    },
  },
  {
    id: 'hikvision-ds-k1107',
    manufacturer: 'Hikvision',
    model: 'DS-K1107',
    category: 'access-reader',
    tagline: 'DS-K1107 — card reader, IP65',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Access-Control-Products/Readers/Pro-Series/ds-k1107ae/',
    specs: {
      technology: ['mifare', 'em-marin-125khz'],
      protocol: ['wiegand-26', 'wiegand-34'],
      outdoor: true,
      keypad: true,
      ipRating: 'IP65',
    },
  },
  {
    id: 'hikvision-ds-k1107ae',
    manufacturer: 'Hikvision',
    model: 'DS-K1107AE',
    category: 'access-reader',
    tagline: 'DS-K1107AE — card reader, IP65',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Access-Control-Products/Readers/Pro-Series/ds-k1107ae/',
    specs: {
      technology: ['mifare', 'em-marin-125khz'],
      protocol: ['wiegand-26', 'wiegand-34'],
      outdoor: true,
      keypad: true,
      ipRating: 'IP65',
    },
  },
  {
    id: 'hikvision-ds-k1107aek',
    manufacturer: 'Hikvision',
    model: 'DS-K1107AEK',
    category: 'access-reader',
    tagline: 'DS-K1107AEK — card reader, IP65',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Access-Control-Products/Readers/Pro-Series/ds-k1107ae/',
    specs: {
      technology: ['mifare', 'em-marin-125khz'],
      protocol: ['wiegand-26', 'wiegand-34'],
      outdoor: true,
      keypad: true,
      ipRating: 'IP65',
    },
  },
  {
    id: 'hikvision-ds-k1107am',
    manufacturer: 'Hikvision',
    model: 'DS-K1107AM',
    category: 'access-reader',
    tagline: 'DS-K1107AM — card reader, IP65',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Access-Control-Products/Readers/Pro-Series/ds-k1107ae/',
    specs: {
      technology: ['mifare', 'em-marin-125khz'],
      protocol: ['wiegand-26', 'wiegand-34'],
      outdoor: true,
      keypad: true,
      ipRating: 'IP65',
    },
  },
  {
    id: 'hikvision-ds-k1107amk',
    manufacturer: 'Hikvision',
    model: 'DS-K1107AMK',
    category: 'access-reader',
    tagline: 'DS-K1107AMK — card reader, IP65',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Access-Control-Products/Readers/Pro-Series/ds-k1107ae/',
    specs: {
      technology: ['mifare', 'em-marin-125khz'],
      protocol: ['wiegand-26', 'wiegand-34'],
      outdoor: true,
      keypad: true,
      ipRating: 'IP65',
    },
  },
  {
    id: 'hikvision-ds-k2604-g',
    manufacturer: 'Hikvision',
    model: 'DS-K2604-G',
    category: 'door-controller',
    tagline: 'DS-K2604-G — 4-door controller',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Access-Control-Products/Controllers/Pro-Series/ds-k2604-g/',
    specs: {
      doors: 1,
      hostBus: 'tcp-ip',
    },
  },
  {
    id: 'hikvision-ds-k2604',
    manufacturer: 'Hikvision',
    model: 'DS-K2604',
    category: 'door-controller',
    tagline: 'DS-K2604 — 4-door controller',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Access-Control-Products/Controllers/Pro-Series/ds-k2604-g/',
    specs: {
      doors: 1,
      hostBus: 'tcp-ip',
    },
  },
  {
    id: 'hikvision-ds-k2604-g-usa',
    manufacturer: 'Hikvision',
    model: 'DS-K2604-G-USA',
    category: 'door-controller',
    tagline: 'DS-K2604-G-USA — 4-door controller',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Access-Control-Products/Controllers/Pro-Series/ds-k2604-g/',
    specs: {
      doors: 1,
      hostBus: 'tcp-ip',
    },
  },
  {
    id: 'hikvision-ds-k2604t-main-board',
    manufacturer: 'Hikvision',
    model: 'DS-K2604T--MAIN-BOARD',
    category: 'door-controller',
    tagline: 'DS-K2604T--MAIN-BOARD — 4-door controller',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Access-Control-Products/Controllers/Pro-Series/ds-k2604-g/',
    specs: {
      doors: 1,
      hostBus: 'tcp-ip',
    },
  },
  {
    id: 'hikvision-ds-k2604t',
    manufacturer: 'Hikvision',
    model: 'DS-K2604T',
    category: 'door-controller',
    tagline: 'DS-K2604T — 4-door controller',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Access-Control-Products/Controllers/Pro-Series/ds-k2604-g/',
    specs: {
      doors: 1,
      hostBus: 'tcp-ip',
    },
  },
  {
    id: 'hikvision-ds-k2604t-main-board',
    manufacturer: 'Hikvision',
    model: 'DS-K2604T--MAIN-BOARD-',
    category: 'door-controller',
    tagline: 'DS-K2604T--MAIN-BOARD- — 4-door controller',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Access-Control-Products/Controllers/Pro-Series/ds-k2604-g/',
    specs: {
      doors: 1,
      hostBus: 'tcp-ip',
    },
  },
  {
    id: 'hikvision-ds-k2604t0',
    manufacturer: 'Hikvision',
    model: 'DS-K2604T0',
    category: 'door-controller',
    tagline: 'DS-K2604T0 — 4-door controller',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Access-Control-Products/Controllers/Pro-Series/ds-k2604-g/',
    specs: {
      doors: 1,
      hostBus: 'tcp-ip',
    },
  },
  {
    id: 'hikvision-ds-k2604t1',
    manufacturer: 'Hikvision',
    model: 'DS-K2604T1',
    category: 'door-controller',
    tagline: 'DS-K2604T1 — 4-door controller',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Access-Control-Products/Controllers/Pro-Series/ds-k2604-g/',
    specs: {
      doors: 1,
      hostBus: 'tcp-ip',
    },
  },
  {
    id: 'hikvision-ds-k2602-g',
    manufacturer: 'Hikvision',
    model: 'DS-K2602-G',
    category: 'door-controller',
    tagline: 'DS-K2602-G — 2-door controller',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Access-Control-Products/Controllers/Pro-Series/ds-k2602-g/',
    specs: {
      doors: 2,
      hostBus: 'tcp-ip',
    },
  },
  {
    id: 'hikvision-ds-k2602',
    manufacturer: 'Hikvision',
    model: 'DS-K2602',
    category: 'door-controller',
    tagline: 'DS-K2602 — 2-door controller',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Access-Control-Products/Controllers/Pro-Series/ds-k2602-g/',
    specs: {
      doors: 2,
      hostBus: 'tcp-ip',
    },
  },
  {
    id: 'hikvision-ds-k2602-kit',
    manufacturer: 'Hikvision',
    model: 'DS-K2602-KIT',
    category: 'door-controller',
    tagline: 'DS-K2602-KIT — 2-door controller',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Access-Control-Products/Controllers/Pro-Series/ds-k2602-g/',
    specs: {
      doors: 2,
      hostBus: 'tcp-ip',
    },
  },
  {
    id: 'hikvision-ds-k2602-g-usa',
    manufacturer: 'Hikvision',
    model: 'DS-K2602-G-USA',
    category: 'door-controller',
    tagline: 'DS-K2602-G-USA — 2-door controller',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Access-Control-Products/Controllers/Pro-Series/ds-k2602-g/',
    specs: {
      doors: 2,
      hostBus: 'tcp-ip',
    },
  },
  {
    id: 'hikvision-ds-k2602t',
    manufacturer: 'Hikvision',
    model: 'DS-K2602T',
    category: 'door-controller',
    tagline: 'DS-K2602T — 2-door controller',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Access-Control-Products/Controllers/Pro-Series/ds-k2602-g/',
    specs: {
      doors: 2,
      hostBus: 'tcp-ip',
    },
  },
  {
    id: 'hikvision-ds-k2602t-main-board',
    manufacturer: 'Hikvision',
    model: 'DS-K2602T--MAIN-BOARD',
    category: 'door-controller',
    tagline: 'DS-K2602T--MAIN-BOARD — 2-door controller',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Access-Control-Products/Controllers/Pro-Series/ds-k2602-g/',
    specs: {
      doors: 2,
      hostBus: 'tcp-ip',
    },
  },
  {
    id: 'hikvision-ds-k2602t-main-board',
    manufacturer: 'Hikvision',
    model: 'DS-K2602T--MAIN-BOARD-',
    category: 'door-controller',
    tagline: 'DS-K2602T--MAIN-BOARD- — 2-door controller',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Access-Control-Products/Controllers/Pro-Series/ds-k2602-g/',
    specs: {
      doors: 2,
      hostBus: 'tcp-ip',
    },
  },
  {
    id: 'hikvision-ds-k2601-g',
    manufacturer: 'Hikvision',
    model: 'DS-K2601-G',
    category: 'door-controller',
    tagline: 'DS-K2601-G — 1-door controller',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Access-Control-Products/Controllers/Pro-Series/ds-k2601-g/',
    specs: {
      doors: 1,
      hostBus: 'tcp-ip',
    },
  },
  {
    id: 'hikvision-ds-k2601',
    manufacturer: 'Hikvision',
    model: 'DS-K2601',
    category: 'door-controller',
    tagline: 'DS-K2601 — 1-door controller',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Access-Control-Products/Controllers/Pro-Series/ds-k2601-g/',
    specs: {
      doors: 1,
      hostBus: 'tcp-ip',
    },
  },
  {
    id: 'hikvision-ds-k2601t-main-board',
    manufacturer: 'Hikvision',
    model: 'DS-K2601T--MAIN-BOARD',
    category: 'door-controller',
    tagline: 'DS-K2601T--MAIN-BOARD — 1-door controller',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Access-Control-Products/Controllers/Pro-Series/ds-k2601-g/',
    specs: {
      doors: 1,
      hostBus: 'tcp-ip',
    },
  },
  {
    id: 'hikvision-ds-k2601t',
    manufacturer: 'Hikvision',
    model: 'DS-K2601T',
    category: 'door-controller',
    tagline: 'DS-K2601T — 1-door controller',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Access-Control-Products/Controllers/Pro-Series/ds-k2601-g/',
    specs: {
      doors: 1,
      hostBus: 'tcp-ip',
    },
  },
  {
    id: 'hikvision-ds-k2601t-main-board',
    manufacturer: 'Hikvision',
    model: 'DS-K2601T--MAIN-BOARD-',
    category: 'door-controller',
    tagline: 'DS-K2601T--MAIN-BOARD- — 1-door controller',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Access-Control-Products/Controllers/Pro-Series/ds-k2601-g/',
    specs: {
      doors: 1,
      hostBus: 'tcp-ip',
    },
  },
  {
    id: 'dahua-dhi-asi6213d-w',
    manufacturer: 'Dahua',
    model: 'DHI-ASI6213D-W',
    category: 'access-reader',
    tagline: 'DHI-ASI6213D-W — face-recognition terminal',
    verified: true,
    datasheetUrl: 'https://www.dahuasecurity.com/br/products/All-Products/Access-Control/AI/Standalone/Lite/DHI-ASI6213D-W',
    specs: {
      technology: ['mifare'],
      protocol: ['wiegand-26', 'wiegand-34'],
      outdoor: false,
      keypad: true,
      doorStateInput: true,
      lockOutput: true,
    },
  },
  {
    id: 'dahua-dhi-asi6214d-w',
    manufacturer: 'Dahua',
    model: 'DHI-ASI6214D-W',
    category: 'access-reader',
    tagline: 'DHI-ASI6214D-W — face-recognition terminal',
    verified: true,
    datasheetUrl: 'https://www.dahuasecurity.com/br/products/All-Products/Access-Control/AI/Standalone/Lite/DHI-ASI6213D-W',
    specs: {
      technology: ['mifare'],
      protocol: ['wiegand-26', 'wiegand-34'],
      outdoor: false,
      keypad: true,
      doorStateInput: true,
      lockOutput: true,
    },
  },
  {
    id: 'dahua-asi6213j-mw',
    manufacturer: 'Dahua',
    model: 'ASI6213J-MW',
    category: 'access-reader',
    tagline: 'ASI6213J-MW — face-recognition terminal, IP65',
    verified: false,
    datasheetUrl: 'https://www.dahuasecurity.com/products/All-Products/Discontinued-Products/Access-Control/ASI6213J-MW',
    specs: {
      technology: ['mifare'],
      protocol: ['wiegand-26', 'wiegand-34'],
      outdoor: true,
      keypad: true,
      doorStateInput: true,
      lockOutput: true,
      ipRating: 'IP65',
    },
  },
  {
    id: 'dahua-asi6213j-mw-v1',
    manufacturer: 'Dahua',
    model: 'ASI6213J-MW-V1',
    category: 'access-reader',
    tagline: 'ASI6213J-MW-V1 — face-recognition terminal, IP65',
    verified: false,
    datasheetUrl: 'https://www.dahuasecurity.com/products/All-Products/Discontinued-Products/Access-Control/ASI6213J-MW',
    specs: {
      technology: ['mifare'],
      protocol: ['wiegand-26', 'wiegand-34'],
      outdoor: true,
      keypad: true,
      doorStateInput: true,
      lockOutput: true,
      ipRating: 'IP65',
    },
  },
  {
    id: 'dahua-asi6213j-ft1',
    manufacturer: 'Dahua',
    model: 'ASI6213J-FT1',
    category: 'access-reader',
    tagline: 'ASI6213J-FT1 — face-recognition terminal, IP65',
    verified: false,
    datasheetUrl: 'https://www.dahuasecurity.com/products/All-Products/Discontinued-Products/Access-Control/ASI6213J-MW',
    specs: {
      technology: ['mifare'],
      protocol: ['wiegand-26', 'wiegand-34'],
      outdoor: true,
      keypad: true,
      doorStateInput: true,
      lockOutput: true,
      ipRating: 'IP65',
    },
  },
  {
    id: 'dahua-asi6213j-mw-0a',
    manufacturer: 'Dahua',
    model: 'ASI6213J-MW%0A',
    category: 'access-reader',
    tagline: 'ASI6213J-MW%0A — face-recognition terminal, IP65',
    verified: false,
    datasheetUrl: 'https://www.dahuasecurity.com/products/All-Products/Discontinued-Products/Access-Control/ASI6213J-MW',
    specs: {
      technology: ['mifare'],
      protocol: ['wiegand-26', 'wiegand-34'],
      outdoor: true,
      keypad: true,
      doorStateInput: true,
      lockOutput: true,
      ipRating: 'IP65',
    },
  },
  {
    id: 'dahua-asi6213s-pw',
    manufacturer: 'Dahua',
    model: 'ASI6213S-PW',
    category: 'access-reader',
    tagline: 'ASI6213S-PW — face-recognition terminal, IP65',
    verified: true,
    datasheetUrl: 'https://www.dahuasecurity.com/uk/products/All-Products/Access-Control/AI/Standalone/Lite/ASI6213S-PW',
    specs: {
      technology: ['mifare'],
      protocol: ['wiegand-26', 'wiegand-34'],
      outdoor: true,
      keypad: true,
      doorStateInput: true,
      lockOutput: true,
      ipRating: 'IP65',
    },
  },
  {
    id: 'dahua-asi6213s-pw-v1',
    manufacturer: 'Dahua',
    model: 'ASI6213S-PW-V1',
    category: 'access-reader',
    tagline: 'ASI6213S-PW-V1 — face-recognition terminal, IP65',
    verified: true,
    datasheetUrl: 'https://www.dahuasecurity.com/uk/products/All-Products/Access-Control/AI/Standalone/Lite/ASI6213S-PW',
    specs: {
      technology: ['mifare'],
      protocol: ['wiegand-26', 'wiegand-34'],
      outdoor: true,
      keypad: true,
      doorStateInput: true,
      lockOutput: true,
      ipRating: 'IP65',
    },
  },
  {
    id: 'dahua-asi6213s-d',
    manufacturer: 'Dahua',
    model: 'ASI6213S-D',
    category: 'access-reader',
    tagline: 'ASI6213S-D — face-recognition terminal, IP65',
    verified: true,
    datasheetUrl: 'https://www.dahuasecurity.com/uk/products/All-Products/Access-Control/AI/Standalone/Lite/ASI6213S-PW',
    specs: {
      technology: ['mifare'],
      protocol: ['wiegand-26', 'wiegand-34'],
      outdoor: true,
      keypad: true,
      doorStateInput: true,
      lockOutput: true,
      ipRating: 'IP65',
    },
  },
  {
    id: 'dahua-asi3103f-w',
    manufacturer: 'Dahua',
    model: 'ASI3103F-W',
    category: 'access-reader',
    tagline: 'ASI3103F-W — face-recognition terminal, IP65',
    verified: true,
    datasheetUrl: 'https://www.dahuasecurity.com/ro/products/All-Products/Access-Control--Time-Attendance/AI/Standalone/Lite/ASI3103F-W',
    specs: {
      technology: ['mifare'],
      protocol: ['wiegand-26', 'wiegand-34'],
      outdoor: true,
      keypad: false,
      doorStateInput: true,
      lockOutput: true,
      ipRating: 'IP65',
    },
  },
  {
    id: 'dahua-asi3103f-mepw',
    manufacturer: 'Dahua',
    model: 'ASI3103F-MEPW',
    category: 'access-reader',
    tagline: 'ASI3103F-MEPW — face-recognition terminal, IP65',
    verified: true,
    datasheetUrl: 'https://www.dahuasecurity.com/ro/products/All-Products/Access-Control--Time-Attendance/AI/Standalone/Lite/ASI3103F-W',
    specs: {
      technology: ['mifare'],
      protocol: ['wiegand-26', 'wiegand-34'],
      outdoor: true,
      keypad: false,
      doorStateInput: true,
      lockOutput: true,
      ipRating: 'IP65',
    },
  },
  {
    id: 'dahua-asi3103f-mew',
    manufacturer: 'Dahua',
    model: 'ASI3103F-MEW',
    category: 'access-reader',
    tagline: 'ASI3103F-MEW — face-recognition terminal, IP65',
    verified: true,
    datasheetUrl: 'https://www.dahuasecurity.com/ro/products/All-Products/Access-Control--Time-Attendance/AI/Standalone/Lite/ASI3103F-W',
    specs: {
      technology: ['mifare'],
      protocol: ['wiegand-26', 'wiegand-34'],
      outdoor: true,
      keypad: false,
      doorStateInput: true,
      lockOutput: true,
      ipRating: 'IP65',
    },
  },
  {
    id: 'dahua-asi7223x-a',
    manufacturer: 'Dahua',
    model: 'ASI7223X-A',
    category: 'access-reader',
    tagline: 'ASI7223X-A — face-recognition terminal, IP65',
    verified: false,
    datasheetUrl: 'https://www.dahuasecurity.com/products/All-Products/Access-ControlTime-Attendance/AI/Standalone/ASI7223X-A',
    specs: {
      technology: ['mifare'],
      protocol: ['wiegand-26', 'wiegand-34'],
      outdoor: true,
      keypad: false,
      doorStateInput: true,
      lockOutput: true,
      ipRating: 'IP65',
    },
  },
  {
    id: 'dahua-asi7223x-a-t1',
    manufacturer: 'Dahua',
    model: 'ASI7223X-A-T1',
    category: 'access-reader',
    tagline: 'ASI7223X-A-T1 — face-recognition terminal, IP65',
    verified: false,
    datasheetUrl: 'https://www.dahuasecurity.com/products/All-Products/Access-ControlTime-Attendance/AI/Standalone/ASI7223X-A',
    specs: {
      technology: ['mifare'],
      protocol: ['wiegand-26', 'wiegand-34'],
      outdoor: true,
      keypad: false,
      doorStateInput: true,
      lockOutput: true,
      ipRating: 'IP65',
    },
  },
  {
    id: 'dahua-asi7223x-a-v1-t1',
    manufacturer: 'Dahua',
    model: 'ASI7223X-A-V1-T1',
    category: 'access-reader',
    tagline: 'ASI7223X-A-V1-T1 — face-recognition terminal, IP65',
    verified: false,
    datasheetUrl: 'https://www.dahuasecurity.com/products/All-Products/Access-ControlTime-Attendance/AI/Standalone/ASI7223X-A',
    specs: {
      technology: ['mifare'],
      protocol: ['wiegand-26', 'wiegand-34'],
      outdoor: true,
      keypad: false,
      doorStateInput: true,
      lockOutput: true,
      ipRating: 'IP65',
    },
  },
  {
    id: 'dahua-asi1212m-w',
    manufacturer: 'Dahua',
    model: 'ASI1212M-W',
    category: 'access-reader',
    tagline: 'ASI1212M-W — fingerprint terminal, IP65',
    verified: true,
    datasheetUrl: 'https://www.dahuasecurity.com/au/products/All-Products/Access-Control--Time-Attendance/Access-Control/Standalone/Lite/ASI1212M-W',
    specs: {
      technology: ['mifare'],
      protocol: ['wiegand-26', 'wiegand-34'],
      outdoor: true,
      keypad: true,
      doorStateInput: true,
      lockOutput: true,
      ipRating: 'IP65',
    },
  },
  {
    id: 'dahua-asi1212m-dw',
    manufacturer: 'Dahua',
    model: 'ASI1212M-DW',
    category: 'access-reader',
    tagline: 'ASI1212M-DW — fingerprint terminal, IP65',
    verified: true,
    datasheetUrl: 'https://www.dahuasecurity.com/au/products/All-Products/Access-Control--Time-Attendance/Access-Control/Standalone/Lite/ASI1212M-W',
    specs: {
      technology: ['mifare'],
      protocol: ['wiegand-26', 'wiegand-34'],
      outdoor: true,
      keypad: true,
      doorStateInput: true,
      lockOutput: true,
      ipRating: 'IP65',
    },
  },
  {
    id: 'dahua-asi1212m-p',
    manufacturer: 'Dahua',
    model: 'ASI1212M-P',
    category: 'access-reader',
    tagline: 'ASI1212M-P — fingerprint terminal, IP65',
    verified: true,
    datasheetUrl: 'https://www.dahuasecurity.com/au/products/All-Products/Access-Control--Time-Attendance/Access-Control/Standalone/Lite/ASI1212M-W',
    specs: {
      technology: ['mifare'],
      protocol: ['wiegand-26', 'wiegand-34'],
      outdoor: true,
      keypad: true,
      doorStateInput: true,
      lockOutput: true,
      ipRating: 'IP65',
    },
  },
  {
    id: 'dahua-asi1201m-mep',
    manufacturer: 'Dahua',
    model: 'ASI1201M-MEP',
    category: 'access-reader',
    tagline: 'ASI1201M-MEP — card reader, IP65',
    verified: true,
    datasheetUrl: 'https://www.dahuasecurity.com/au/products/All-Products/Access-Control--Time-Attendance/Access-Control/Standalone/Lite/ASI1201M-MEP',
    specs: {
      technology: ['mifare', 'em-marin-125khz'],
      protocol: ['wiegand-26', 'wiegand-34'],
      outdoor: true,
      keypad: true,
      doorStateInput: true,
      lockOutput: true,
      ipRating: 'IP65',
    },
  },
  {
    id: 'dahua-asi1201m-mew',
    manufacturer: 'Dahua',
    model: 'ASI1201M-MEW',
    category: 'access-reader',
    tagline: 'ASI1201M-MEW — card reader, IP65',
    verified: true,
    datasheetUrl: 'https://www.dahuasecurity.com/au/products/All-Products/Access-Control--Time-Attendance/Access-Control/Standalone/Lite/ASI1201M-MEP',
    specs: {
      technology: ['mifare', 'em-marin-125khz'],
      protocol: ['wiegand-26', 'wiegand-34'],
      outdoor: true,
      keypad: true,
      doorStateInput: true,
      lockOutput: true,
      ipRating: 'IP65',
    },
  },
  {
    id: 'dahua-asi1201m-me',
    manufacturer: 'Dahua',
    model: 'ASI1201M-ME',
    category: 'access-reader',
    tagline: 'ASI1201M-ME — card reader, IP65',
    verified: true,
    datasheetUrl: 'https://www.dahuasecurity.com/au/products/All-Products/Access-Control--Time-Attendance/Access-Control/Standalone/Lite/ASI1201M-MEP',
    specs: {
      technology: ['mifare', 'em-marin-125khz'],
      protocol: ['wiegand-26', 'wiegand-34'],
      outdoor: true,
      keypad: true,
      doorStateInput: true,
      lockOutput: true,
      ipRating: 'IP65',
    },
  },
  {
    id: 'dahua-asi1201e-v1',
    manufacturer: 'Dahua',
    model: 'ASI1201E-V1',
    category: 'access-reader',
    tagline: 'ASI1201E-V1 — card reader, IP66',
    verified: true,
    datasheetUrl: 'https://www.dahuasecurity.com/cz/products/All-Products/Access-Control--Time-Attendance/Access-Control/Standalone/Lite/ASI1201E-V1',
    specs: {
      technology: ['mifare'],
      protocol: ['wiegand-26', 'wiegand-34'],
      outdoor: true,
      keypad: true,
      doorStateInput: true,
      lockOutput: true,
      ipRating: 'IP66',
    },
  },
  {
    id: 'dahua-asi1201e-d-v1',
    manufacturer: 'Dahua',
    model: 'ASI1201E-D-V1',
    category: 'access-reader',
    tagline: 'ASI1201E-D-V1 — card reader, IP66',
    verified: true,
    datasheetUrl: 'https://www.dahuasecurity.com/cz/products/All-Products/Access-Control--Time-Attendance/Access-Control/Standalone/Lite/ASI1201E-V1',
    specs: {
      technology: ['mifare'],
      protocol: ['wiegand-26', 'wiegand-34'],
      outdoor: true,
      keypad: true,
      doorStateInput: true,
      lockOutput: true,
      ipRating: 'IP66',
    },
  },
  {
    id: 'dahua-asi1201e-d',
    manufacturer: 'Dahua',
    model: 'ASI1201E-D',
    category: 'access-reader',
    tagline: 'ASI1201E-D — card reader, IP66',
    verified: true,
    datasheetUrl: 'https://www.dahuasecurity.com/cz/products/All-Products/Access-Control--Time-Attendance/Access-Control/Standalone/Lite/ASI1201E-V1',
    specs: {
      technology: ['mifare'],
      protocol: ['wiegand-26', 'wiegand-34'],
      outdoor: true,
      keypad: true,
      doorStateInput: true,
      lockOutput: true,
      ipRating: 'IP66',
    },
  },
  {
    id: 'dahua-asi2212j-pw',
    manufacturer: 'Dahua',
    model: 'ASI2212J-PW',
    category: 'access-reader',
    tagline: 'ASI2212J-PW — fingerprint terminal, IP65',
    verified: false,
    datasheetUrl: 'https://www.dahuasecurity.com/products/All-Products/Access-Control--Time-Attendance/Access-Control/Standalone/Pro/ASI2212J-PW',
    specs: {
      technology: ['mifare'],
      protocol: ['wiegand-26', 'wiegand-34'],
      outdoor: true,
      keypad: true,
      doorStateInput: true,
      lockOutput: true,
      ipRating: 'IP65',
    },
  },
  {
    id: 'dahua-asi2212j-dpw',
    manufacturer: 'Dahua',
    model: 'ASI2212J-DPW',
    category: 'access-reader',
    tagline: 'ASI2212J-DPW — fingerprint terminal, IP65',
    verified: false,
    datasheetUrl: 'https://www.dahuasecurity.com/products/All-Products/Access-Control--Time-Attendance/Access-Control/Standalone/Pro/ASI2212J-PW',
    specs: {
      technology: ['mifare'],
      protocol: ['wiegand-26', 'wiegand-34'],
      outdoor: true,
      keypad: true,
      doorStateInput: true,
      lockOutput: true,
      ipRating: 'IP65',
    },
  },
  {
    id: 'dahua-asi2212j-d',
    manufacturer: 'Dahua',
    model: 'ASI2212J-D',
    category: 'access-reader',
    tagline: 'ASI2212J-D — fingerprint terminal, IP65',
    verified: false,
    datasheetUrl: 'https://www.dahuasecurity.com/products/All-Products/Access-Control--Time-Attendance/Access-Control/Standalone/Pro/ASI2212J-PW',
    specs: {
      technology: ['mifare'],
      protocol: ['wiegand-26', 'wiegand-34'],
      outdoor: true,
      keypad: true,
      doorStateInput: true,
      lockOutput: true,
      ipRating: 'IP65',
    },
  },
  {
    id: 'dahua-asi2201h-dw',
    manufacturer: 'Dahua',
    model: 'ASI2201H-DW',
    category: 'access-reader',
    tagline: 'ASI2201H-DW — card reader, IP65',
    verified: false,
    datasheetUrl: 'https://www.dahuasecurity.com/products/All-Products/Access-Control--Time-Attendance/Access-Control/Standalone/Pro/ASI2201H-DW',
    specs: {
      technology: ['mifare'],
      protocol: ['wiegand-26', 'wiegand-34', 'osdp'],
      outdoor: true,
      keypad: true,
      doorStateInput: true,
      lockOutput: true,
      ipRating: 'IP65',
    },
  },
  {
    id: 'dahua-asi2201h-w',
    manufacturer: 'Dahua',
    model: 'ASI2201H-W',
    category: 'access-reader',
    tagline: 'ASI2201H-W — card reader, IP65',
    verified: false,
    datasheetUrl: 'https://www.dahuasecurity.com/products/All-Products/Access-Control--Time-Attendance/Access-Control/Standalone/Pro/ASI2201H-DW',
    specs: {
      technology: ['mifare'],
      protocol: ['wiegand-26', 'wiegand-34', 'osdp'],
      outdoor: true,
      keypad: true,
      doorStateInput: true,
      lockOutput: true,
      ipRating: 'IP65',
    },
  },
  {
    id: 'dahua-asi2201h-w-asi2201h-dw',
    manufacturer: 'Dahua',
    model: 'ASI2201H-W---ASI2201H-DW',
    category: 'access-reader',
    tagline: 'ASI2201H-W---ASI2201H-DW — card reader, IP65',
    verified: false,
    datasheetUrl: 'https://www.dahuasecurity.com/products/All-Products/Access-Control--Time-Attendance/Access-Control/Standalone/Pro/ASI2201H-DW',
    specs: {
      technology: ['mifare'],
      protocol: ['wiegand-26', 'wiegand-34', 'osdp'],
      outdoor: true,
      keypad: true,
      doorStateInput: true,
      lockOutput: true,
      ipRating: 'IP65',
    },
  },
  {
    id: 'dahua-asi2212h-dw',
    manufacturer: 'Dahua',
    model: 'ASI2212H-DW',
    category: 'access-reader',
    tagline: 'ASI2212H-DW — fingerprint terminal, IP65',
    verified: false,
    datasheetUrl: 'https://www.dahuasecurity.com/products/All-Products/Access-Control--Time-Attendance/Access-Control/Standalone/Pro/ASI2212H-DW',
    specs: {
      technology: ['mifare'],
      protocol: ['wiegand-26', 'wiegand-34', 'osdp'],
      outdoor: true,
      keypad: true,
      doorStateInput: true,
      lockOutput: true,
      ipRating: 'IP65',
    },
  },
  {
    id: 'dahua-asi2212h-w',
    manufacturer: 'Dahua',
    model: 'ASI2212H-W',
    category: 'access-reader',
    tagline: 'ASI2212H-W — fingerprint terminal, IP65',
    verified: false,
    datasheetUrl: 'https://www.dahuasecurity.com/products/All-Products/Access-Control--Time-Attendance/Access-Control/Standalone/Pro/ASI2212H-DW',
    specs: {
      technology: ['mifare'],
      protocol: ['wiegand-26', 'wiegand-34', 'osdp'],
      outdoor: true,
      keypad: true,
      doorStateInput: true,
      lockOutput: true,
      ipRating: 'IP65',
    },
  },
  {
    id: 'dahua-asi2212h-w-asi2212h-dw',
    manufacturer: 'Dahua',
    model: 'ASI2212H-W---ASI2212H-DW',
    category: 'access-reader',
    tagline: 'ASI2212H-W---ASI2212H-DW — fingerprint terminal, IP65',
    verified: false,
    datasheetUrl: 'https://www.dahuasecurity.com/products/All-Products/Access-Control--Time-Attendance/Access-Control/Standalone/Pro/ASI2212H-DW',
    specs: {
      technology: ['mifare'],
      protocol: ['wiegand-26', 'wiegand-34', 'osdp'],
      outdoor: true,
      keypad: true,
      doorStateInput: true,
      lockOutput: true,
      ipRating: 'IP65',
    },
  },
  {
    id: 'dahua-asi8214s-w',
    manufacturer: 'Dahua',
    model: 'ASI8214S-W',
    category: 'access-reader',
    tagline: 'ASI8214S-W — face-recognition terminal, IP65',
    verified: true,
    datasheetUrl: 'https://www.dahuasecurity.com/au/products/All-Products/Access-Control--Time-Attendance/AI/Standalone/Ultra/ASI8214S-W',
    specs: {
      technology: ['mifare'],
      protocol: ['wiegand-26', 'wiegand-34', 'osdp'],
      outdoor: true,
      keypad: true,
      doorStateInput: true,
      lockOutput: true,
      ipRating: 'IP65',
    },
  },
  {
    id: 'dahua-asi8214s-w-v1',
    manufacturer: 'Dahua',
    model: 'ASI8214S-W-V1',
    category: 'access-reader',
    tagline: 'ASI8214S-W-V1 — face-recognition terminal, IP65',
    verified: true,
    datasheetUrl: 'https://www.dahuasecurity.com/au/products/All-Products/Access-Control--Time-Attendance/AI/Standalone/Ultra/ASI8214S-W',
    specs: {
      technology: ['mifare'],
      protocol: ['wiegand-26', 'wiegand-34', 'osdp'],
      outdoor: true,
      keypad: true,
      doorStateInput: true,
      lockOutput: true,
      ipRating: 'IP65',
    },
  },
  {
    id: 'dahua-asi7223y-a-v3',
    manufacturer: 'Dahua',
    model: 'ASI7223Y-A-V3',
    category: 'access-reader',
    tagline: 'ASI7223Y-A-V3 — face-recognition terminal',
    verified: false,
    datasheetUrl: 'https://www.dahuasecurity.com/products/All-Products/Access-ControlTime-Attendance/AI/Standalone/ASI7223Y-A-V3',
    specs: {
      technology: ['mifare'],
      protocol: ['wiegand-26', 'wiegand-34'],
      outdoor: false,
      keypad: false,
      doorStateInput: true,
      lockOutput: true,
    },
  },
  {
    id: 'dahua-asi7223y-a-v3-t1',
    manufacturer: 'Dahua',
    model: 'ASI7223Y-A-V3-T1',
    category: 'access-reader',
    tagline: 'ASI7223Y-A-V3-T1 — face-recognition terminal',
    verified: false,
    datasheetUrl: 'https://www.dahuasecurity.com/products/All-Products/Access-ControlTime-Attendance/AI/Standalone/ASI7223Y-A-V3',
    specs: {
      technology: ['mifare'],
      protocol: ['wiegand-26', 'wiegand-34'],
      outdoor: false,
      keypad: false,
      doorStateInput: true,
      lockOutput: true,
    },
  },
  {
    id: 'dahua-asi3203e-dw',
    manufacturer: 'Dahua',
    model: 'ASI3203E-DW',
    category: 'access-reader',
    tagline: 'ASI3203E-DW — face-recognition terminal',
    verified: true,
    datasheetUrl: 'https://www.dahuasecurity.com/au/products/All-Products/Access-Control--Time-Attendance/AI/Standalone/Lite/ASI3203E-DW',
    specs: {
      technology: ['mifare'],
      protocol: ['wiegand-26', 'wiegand-34'],
      outdoor: false,
      keypad: false,
      doorStateInput: true,
      lockOutput: true,
    },
  },
  {
    id: 'dahua-asi3203e-w',
    manufacturer: 'Dahua',
    model: 'ASI3203E-W',
    category: 'access-reader',
    tagline: 'ASI3203E-W — face-recognition terminal',
    verified: true,
    datasheetUrl: 'https://www.dahuasecurity.com/au/products/All-Products/Access-Control--Time-Attendance/AI/Standalone/Lite/ASI3203E-DW',
    specs: {
      technology: ['mifare'],
      protocol: ['wiegand-26', 'wiegand-34'],
      outdoor: false,
      keypad: false,
      doorStateInput: true,
      lockOutput: true,
    },
  },
  {
    id: 'dahua-asi3204e-w',
    manufacturer: 'Dahua',
    model: 'ASI3204E-W',
    category: 'access-reader',
    tagline: 'ASI3204E-W — face-recognition terminal',
    verified: false,
    datasheetUrl: 'https://www.dahuasecurity.com/au/products/All-Products/Access-Control--Time-Attendance/AI/Standalone/Lite/ASI3204E-W',
    specs: {
      technology: ['mifare'],
      protocol: ['wiegand-26', 'wiegand-34'],
      outdoor: false,
      keypad: false,
      doorStateInput: true,
      lockOutput: true,
    },
  },
  {
    id: 'dahua-asi3204e-dw',
    manufacturer: 'Dahua',
    model: 'ASI3204E-DW',
    category: 'access-reader',
    tagline: 'ASI3204E-DW — face-recognition terminal',
    verified: false,
    datasheetUrl: 'https://www.dahuasecurity.com/au/products/All-Products/Access-Control--Time-Attendance/AI/Standalone/Lite/ASI3204E-W',
    specs: {
      technology: ['mifare'],
      protocol: ['wiegand-26', 'wiegand-34'],
      outdoor: false,
      keypad: false,
      doorStateInput: true,
      lockOutput: true,
    },
  },
  {
    id: 'dahua-asi3213a-w',
    manufacturer: 'Dahua',
    model: 'ASI3213A-W',
    category: 'access-reader',
    tagline: 'ASI3213A-W — face-recognition terminal',
    verified: true,
    datasheetUrl: 'https://www.dahuasecurity.com/au/products/All-Products/Access-Control--Time-Attendance/AI/Standalone/Lite/ASI3213A-W',
    specs: {
      technology: ['mifare'],
      protocol: ['wiegand-26', 'wiegand-34'],
      outdoor: false,
      keypad: false,
      doorStateInput: true,
      lockOutput: true,
    },
  },
  {
    id: 'dahua-asi3213a-w-0a',
    manufacturer: 'Dahua',
    model: 'ASI3213A-W%0A',
    category: 'access-reader',
    tagline: 'ASI3213A-W%0A — face-recognition terminal',
    verified: true,
    datasheetUrl: 'https://www.dahuasecurity.com/au/products/All-Products/Access-Control--Time-Attendance/AI/Standalone/Lite/ASI3213A-W',
    specs: {
      technology: ['mifare'],
      protocol: ['wiegand-26', 'wiegand-34'],
      outdoor: false,
      keypad: false,
      doorStateInput: true,
      lockOutput: true,
    },
  },
  {
    id: 'dahua-asi7213x-t1',
    manufacturer: 'Dahua',
    model: 'ASI7213X-T1',
    category: 'access-reader',
    tagline: 'ASI7213X-T1 — face-recognition terminal, IP65',
    verified: false,
    datasheetUrl: 'https://www.dahuasecurity.com/products/All-Products/Access-ControlTime-Attendance/AI/Standalone/ASI7213X-T1',
    specs: {
      technology: ['mifare'],
      protocol: ['wiegand-26', 'wiegand-34'],
      outdoor: true,
      keypad: false,
      doorStateInput: true,
      lockOutput: true,
      ipRating: 'IP65',
    },
  },
  {
    id: 'dahua-asi7213x-v1-t1',
    manufacturer: 'Dahua',
    model: 'ASI7213X-V1-T1',
    category: 'access-reader',
    tagline: 'ASI7213X-V1-T1 — face-recognition terminal, IP65',
    verified: false,
    datasheetUrl: 'https://www.dahuasecurity.com/products/All-Products/Access-ControlTime-Attendance/AI/Standalone/ASI7213X-T1',
    specs: {
      technology: ['mifare'],
      protocol: ['wiegand-26', 'wiegand-34'],
      outdoor: true,
      keypad: false,
      doorStateInput: true,
      lockOutput: true,
      ipRating: 'IP65',
    },
  },
  {
    id: 'dahua-asr2200a-b',
    manufacturer: 'Dahua',
    model: 'ASR2200A-B',
    category: 'access-reader',
    tagline: 'ASR2200A-B — card reader, IP66',
    verified: true,
    datasheetUrl: 'https://www.dahuasecurity.com/br/products/All-Products/Access-Control/Readers/ASR2200A-B',
    specs: {
      technology: ['mifare'],
      protocol: ['wiegand-26', 'wiegand-34'],
      outdoor: true,
      keypad: false,
      doorStateInput: false,
      lockOutput: false,
      ipRating: 'IP66',
    },
  },
  {
    id: 'dahua-asr2200a-d',
    manufacturer: 'Dahua',
    model: 'ASR2200A-D',
    category: 'access-reader',
    tagline: 'ASR2200A-D — card reader, IP66',
    verified: true,
    datasheetUrl: 'https://www.dahuasecurity.com/br/products/All-Products/Access-Control/Readers/ASR2200A-B',
    specs: {
      technology: ['mifare'],
      protocol: ['wiegand-26', 'wiegand-34'],
      outdoor: true,
      keypad: false,
      doorStateInput: false,
      lockOutput: false,
      ipRating: 'IP66',
    },
  },
  {
    id: 'dahua-asr2200a-asr2200a-d',
    manufacturer: 'Dahua',
    model: 'ASR2200A-ASR2200A-D',
    category: 'access-reader',
    tagline: 'ASR2200A-ASR2200A-D — card reader, IP66',
    verified: true,
    datasheetUrl: 'https://www.dahuasecurity.com/br/products/All-Products/Access-Control/Readers/ASR2200A-B',
    specs: {
      technology: ['mifare'],
      protocol: ['wiegand-26', 'wiegand-34'],
      outdoor: true,
      keypad: false,
      doorStateInput: false,
      lockOutput: false,
      ipRating: 'IP66',
    },
  },
  {
    id: 'dahua-asr2201a-d',
    manufacturer: 'Dahua',
    model: 'ASR2201A-D',
    category: 'access-reader',
    tagline: 'ASR2201A-D — card reader, IP66',
    verified: true,
    datasheetUrl: 'https://www.dahuasecurity.com/br/products/All-Products/Access-Control/Readers/ASR2201A-D',
    specs: {
      technology: ['mifare'],
      protocol: ['wiegand-26', 'wiegand-34'],
      outdoor: true,
      keypad: true,
      doorStateInput: false,
      lockOutput: false,
      ipRating: 'IP66',
    },
  },
  {
    id: 'dahua-asr2201a-asr2201a-d',
    manufacturer: 'Dahua',
    model: 'ASR2201A-ASR2201A-D',
    category: 'access-reader',
    tagline: 'ASR2201A-ASR2201A-D — card reader, IP66',
    verified: true,
    datasheetUrl: 'https://www.dahuasecurity.com/br/products/All-Products/Access-Control/Readers/ASR2201A-D',
    specs: {
      technology: ['mifare'],
      protocol: ['wiegand-26', 'wiegand-34'],
      outdoor: true,
      keypad: true,
      doorStateInput: false,
      lockOutput: false,
      ipRating: 'IP66',
    },
  },
  {
    id: 'dahua-asr1100b-asr1100b-d',
    manufacturer: 'Dahua',
    model: 'ASR1100B-ASR1100B-D',
    category: 'access-reader',
    tagline: 'ASR1100B-ASR1100B-D — card reader, IP67',
    verified: true,
    datasheetUrl: 'https://www.dahuasecurity.com/de/products/All-Products/Discontinued-Products/Access-Control/ASR1100B-ASR1100B-D',
    specs: {
      technology: ['mifare', 'em-marin-125khz'],
      protocol: ['wiegand-26', 'wiegand-34'],
      outdoor: true,
      keypad: false,
      doorStateInput: false,
      lockOutput: false,
      ipRating: 'IP67',
    },
  },
  {
    id: 'dahua-asr1100b-v1',
    manufacturer: 'Dahua',
    model: 'ASR1100B-V1',
    category: 'access-reader',
    tagline: 'ASR1100B-V1 — card reader, IP67',
    verified: true,
    datasheetUrl: 'https://www.dahuasecurity.com/de/products/All-Products/Discontinued-Products/Access-Control/ASR1100B-ASR1100B-D',
    specs: {
      technology: ['mifare', 'em-marin-125khz'],
      protocol: ['wiegand-26', 'wiegand-34'],
      outdoor: true,
      keypad: false,
      doorStateInput: false,
      lockOutput: false,
      ipRating: 'IP67',
    },
  },
  {
    id: 'dahua-asr1100b-d-v1',
    manufacturer: 'Dahua',
    model: 'ASR1100B-D-V1',
    category: 'access-reader',
    tagline: 'ASR1100B-D-V1 — card reader, IP67',
    verified: true,
    datasheetUrl: 'https://www.dahuasecurity.com/de/products/All-Products/Discontinued-Products/Access-Control/ASR1100B-ASR1100B-D',
    specs: {
      technology: ['mifare', 'em-marin-125khz'],
      protocol: ['wiegand-26', 'wiegand-34'],
      outdoor: true,
      keypad: false,
      doorStateInput: false,
      lockOutput: false,
      ipRating: 'IP67',
    },
  },
  {
    id: 'dahua-asr1101m-asr1101m-d',
    manufacturer: 'Dahua',
    model: 'ASR1101M-ASR1101M-D',
    category: 'access-reader',
    tagline: 'ASR1101M-ASR1101M-D — card reader',
    verified: true,
    datasheetUrl: 'https://www.dahuasecurity.com/de/products/All-Products/Discontinued-Products/Access-Control/ASR1101M-ASR1101M-D',
    specs: {
      technology: ['mifare', 'em-marin-125khz'],
      protocol: ['wiegand-26', 'wiegand-34'],
      outdoor: false,
      keypad: true,
      doorStateInput: false,
      lockOutput: false,
    },
  },
  {
    id: 'dahua-asr1101m-v1',
    manufacturer: 'Dahua',
    model: 'ASR1101M-V1',
    category: 'access-reader',
    tagline: 'ASR1101M-V1 — card reader',
    verified: true,
    datasheetUrl: 'https://www.dahuasecurity.com/de/products/All-Products/Discontinued-Products/Access-Control/ASR1101M-ASR1101M-D',
    specs: {
      technology: ['mifare', 'em-marin-125khz'],
      protocol: ['wiegand-26', 'wiegand-34'],
      outdoor: false,
      keypad: true,
      doorStateInput: false,
      lockOutput: false,
    },
  },
  {
    id: 'dahua-asr1101m-d-v1',
    manufacturer: 'Dahua',
    model: 'ASR1101M-D-V1',
    category: 'access-reader',
    tagline: 'ASR1101M-D-V1 — card reader',
    verified: true,
    datasheetUrl: 'https://www.dahuasecurity.com/de/products/All-Products/Discontinued-Products/Access-Control/ASR1101M-ASR1101M-D',
    specs: {
      technology: ['mifare', 'em-marin-125khz'],
      protocol: ['wiegand-26', 'wiegand-34'],
      outdoor: false,
      keypad: true,
      doorStateInput: false,
      lockOutput: false,
    },
  },
  {
    id: 'dahua-asc2204c-h',
    manufacturer: 'Dahua',
    model: 'ASC2204C-H',
    category: 'door-controller',
    tagline: 'ASC2204C-H — 4-door controller',
    verified: false,
    datasheetUrl: 'https://www.dahuasecurity.com/au/products/All-Products/Discontinued-Products/Access-Control/ASC2204C-H',
    specs: {
      doors: 1,
      hostBus: 'tcp-ip',
    },
  },
  {
    id: 'dahua-asc2204c-d',
    manufacturer: 'Dahua',
    model: 'ASC2204C-D',
    category: 'door-controller',
    tagline: 'ASC2204C-D — 4-door controller',
    verified: false,
    datasheetUrl: 'https://www.dahuasecurity.com/au/products/All-Products/Discontinued-Products/Access-Control/ASC2204C-H',
    specs: {
      doors: 1,
      hostBus: 'tcp-ip',
    },
  },
  {
    id: 'dahua-asc2204c-s',
    manufacturer: 'Dahua',
    model: 'ASC2204C-S',
    category: 'door-controller',
    tagline: 'ASC2204C-S — 4-door controller',
    verified: false,
    datasheetUrl: 'https://www.dahuasecurity.com/au/products/All-Products/Discontinued-Products/Access-Control/ASC2204C-H',
    specs: {
      doors: 1,
      hostBus: 'tcp-ip',
    },
  },
  {
    id: 'dahua-asc2202c-s',
    manufacturer: 'Dahua',
    model: 'ASC2202C-S',
    category: 'door-controller',
    tagline: 'ASC2202C-S — 2-door controller',
    verified: true,
    datasheetUrl: 'https://www.dahuasecurity.com/br/products/All-Products/Access-Control/Controllers/ASC2202C-S',
    specs: {
      doors: 2,
      hostBus: 'tcp-ip',
    },
  },
  {
    id: 'dahua-asc2202c-d',
    manufacturer: 'Dahua',
    model: 'ASC2202C-D',
    category: 'door-controller',
    tagline: 'ASC2202C-D — 2-door controller',
    verified: true,
    datasheetUrl: 'https://www.dahuasecurity.com/br/products/All-Products/Access-Control/Controllers/ASC2202C-S',
    specs: {
      doors: 2,
      hostBus: 'tcp-ip',
    },
  },
  {
    id: 'dahua-asc1202b-s',
    manufacturer: 'Dahua',
    model: 'ASC1202B-S',
    category: 'door-controller',
    tagline: 'ASC1202B-S — 2-door controller',
    verified: true,
    datasheetUrl: 'https://www.dahuasecurity.com/au/products/All-Products/Discontinued-Products/Access-Control/ASC1202B-S',
    specs: {
      doors: 2,
      hostBus: 'tcp-ip',
    },
  },
  {
    id: 'dahua-asc1202b-d',
    manufacturer: 'Dahua',
    model: 'ASC1202B-D',
    category: 'door-controller',
    tagline: 'ASC1202B-D — 2-door controller',
    verified: true,
    datasheetUrl: 'https://www.dahuasecurity.com/au/products/All-Products/Discontinued-Products/Access-Control/ASC1202B-S',
    specs: {
      doors: 2,
      hostBus: 'tcp-ip',
    },
  },
  {
    id: 'dahua-asm100-asm100-d',
    manufacturer: 'Dahua',
    model: 'ASM100-ASM100-D',
    category: 'access-reader',
    tagline: 'ASM100-ASM100-D — card reader',
    verified: false,
    datasheetUrl: 'https://www.dahuasecurity.com/products/All-Products/Access-Control--Time-Attendance/Modules/ASM100-ASM100-D',
    specs: {
      technology: ['mifare'],
      protocol: ['wiegand-26', 'wiegand-34'],
      outdoor: false,
      keypad: false,
      doorStateInput: false,
      lockOutput: false,
    },
  },
  {
    id: 'dahua-asm100-v1',
    manufacturer: 'Dahua',
    model: 'ASM100-V1',
    category: 'access-reader',
    tagline: 'ASM100-V1 — card reader',
    verified: false,
    datasheetUrl: 'https://www.dahuasecurity.com/products/All-Products/Access-Control--Time-Attendance/Modules/ASM100-ASM100-D',
    specs: {
      technology: ['mifare'],
      protocol: ['wiegand-26', 'wiegand-34'],
      outdoor: false,
      keypad: false,
      doorStateInput: false,
      lockOutput: false,
    },
  },
  {
    id: 'dahua-asm100-d-v1',
    manufacturer: 'Dahua',
    model: 'ASM100-D-V1',
    category: 'access-reader',
    tagline: 'ASM100-D-V1 — card reader',
    verified: false,
    datasheetUrl: 'https://www.dahuasecurity.com/products/All-Products/Access-Control--Time-Attendance/Modules/ASM100-ASM100-D',
    specs: {
      technology: ['mifare'],
      protocol: ['wiegand-26', 'wiegand-34'],
      outdoor: false,
      keypad: false,
      doorStateInput: false,
      lockOutput: false,
    },
  },
  {
    id: 'dahua-asm100-s2-asm100-d',
    manufacturer: 'Dahua',
    model: 'ASM100-S2-ASM100-D',
    category: 'access-reader',
    tagline: 'ASM100-S2-ASM100-D — card reader',
    verified: false,
    datasheetUrl: 'https://www.dahuasecurity.com/products/All-Products/Access-Control--Time-Attendance/Modules/ASM100-ASM100-D',
    specs: {
      technology: ['mifare'],
      protocol: ['wiegand-26', 'wiegand-34'],
      outdoor: false,
      keypad: false,
      doorStateInput: false,
      lockOutput: false,
    },
  },
  {
    id: 'dahua-asm100-v1-asm100-d-v1',
    manufacturer: 'Dahua',
    model: 'ASM100-V1-ASM100-D-V1',
    category: 'access-reader',
    tagline: 'ASM100-V1-ASM100-D-V1 — card reader',
    verified: false,
    datasheetUrl: 'https://www.dahuasecurity.com/products/All-Products/Access-Control--Time-Attendance/Modules/ASM100-ASM100-D',
    specs: {
      technology: ['mifare'],
      protocol: ['wiegand-26', 'wiegand-34'],
      outdoor: false,
      keypad: false,
      doorStateInput: false,
      lockOutput: false,
    },
  },
];
